"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orders (Beta)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.5.97
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTransitDetailsResource = exports.OrderSupplierReferenceType = exports.OrderStatus = exports.OrderReleaseStatus = exports.OrderReleaseDetailsReleaseTypeEnum = exports.OrderReleaseReleaseTypeEnum = exports.OrderReferenceQualifier = exports.OrderItemShippingRequirementsReferenceType = exports.OrderItemReferenceType = exports.OrderCustomerReferenceType = exports.OceanTrackingReferenceType = exports.OceanTrackingOrderServiceServiceTypeEnum = exports.OceanTrackingServiceTypeEnum = exports.LocationType = exports.LengthUnit = exports.LegacyShipmentStageStageTypeEnum = exports.LegacyShipmentResourceRefResourceTypeEnum = exports.LegStageStageTypeEnum = exports.HazmatPackingGroup = exports.FtlReferenceType = exports.FtlLegLegTypeEnum = exports.FreightInvoiceTenantRole = exports.FreightClass = exports.DrayageShipmentModeSpecificDataModeEnum = exports.DrayageReferenceType = exports.DrayageLegOverallStatus = exports.DrayageLegExecutionStatus = exports.DrayageBookingAccessorials = exports.DrayageBookingLegTypeEnum = exports.DocumentType = exports.CreatedBySource = exports.CreateTransportationReleaseReleaseTypeEnum = exports.CreateSalesOrderReleaseReleaseTypeEnum = exports.CreatePurchaseOrderReleaseReleaseTypeEnum = exports.CreatePurchaseOrderOrderTypeEnum = exports.ContainerWidthFT = exports.ContainerType = exports.ContainerPackagingType = exports.ContainerLengthFT = exports.ContainerHeightFT = exports.ContainerDimensionUnitEnum = exports.ContactType = exports.ChargeCategory = exports.CarrierAssignmentStatus = exports.BulkLoadOrderOperationResult = exports.BulkLoadOrderOperationAction = exports.BECoreShipmentTimelineEventType = exports.BECoreShipmentTimelineEventSubType = exports.AreaUnit = exports.Accessorials = void 0;
exports.LegsDrayageApiFp = exports.LegsDrayageApiAxiosParamCreator = exports.LegsApi = exports.LegsApiFactory = exports.LegsApiFp = exports.LegsApiAxiosParamCreator = exports.WeightUnit = exports.VolumeUnit = exports.UpdateSalesOrderOrderTypeEnum = exports.UpdatePurchaseOrderOrderTypeEnum = exports.UpdateEntireSalesOrderOrderTypeEnum = exports.UpdateEntirePurchaseOrderOrderTypeEnum = exports.TransportationReleaseDetailsReleaseTypeEnum = exports.TransportationReleaseReleaseTypeEnum = exports.TransportationMode = exports.TransloadServiceTypeEnum = exports.TransitStatus = exports.TrackingResourceType = exports.TimelineEventSource = exports.TerminalFeeServiceTypeEnum = exports.TemperatureUnit = exports.StorageServiceTypeEnum = exports.StopReferenceQualifier = exports.StopReason = exports.StopExecutionStatus = exports.StageType = exports.StageTimelineEventType = exports.StageSummaryResourceTypeEnum = exports.ShipmentTimelineEventType = exports.ShipmentOverallStatus = exports.ServiceStageStageTypeEnum = exports.ServiceReferenceType = exports.SalesOrderTransitDocumentType = exports.SalesOrderTransitDocumentTransitTypeEnum = exports.SalesOrderStatus = exports.SalesOrderOrderTypeEnum = exports.RemitToEntityType = exports.RailTrackingReferenceType = exports.RailTrackingOrderServiceServiceTypeEnum = exports.RailTrackingServiceTypeEnum = exports.PurchaseOrderStatus = exports.PurchaseOrderOrderTypeEnum = exports.ProductPackagingType = exports.ProductOrderStopReferenceQualifier = exports.ProductOrderStatus = exports.PieceType = exports.PaymentTerm = exports.PackagingType = exports.OrderType = exports.OrderTransitTimelineEventTransitTypeEnum = void 0;
exports.TransportationOrdersApi = exports.TransportationOrdersApiFactory = exports.TransportationOrdersApiFp = exports.TransportationOrdersApiAxiosParamCreator = exports.ShipmentsApi = exports.ShipmentsApiFactory = exports.ShipmentsApiFp = exports.ShipmentsApiAxiosParamCreator = exports.ServicesApi = exports.ServicesApiFactory = exports.ServicesApiFp = exports.ServicesApiAxiosParamCreator = exports.SalesOrdersApi = exports.SalesOrdersApiFactory = exports.SalesOrdersApiFp = exports.SalesOrdersApiAxiosParamCreator = exports.PurchaseOrdersApi = exports.PurchaseOrdersApiFactory = exports.PurchaseOrdersApiFp = exports.PurchaseOrdersApiAxiosParamCreator = exports.OrdersApi = exports.OrdersApiFactory = exports.OrdersApiFp = exports.OrdersApiAxiosParamCreator = exports.LegsFTLAlphaApi = exports.LegsFTLAlphaApiFactory = exports.LegsFTLAlphaApiFp = exports.LegsFTLAlphaApiAxiosParamCreator = exports.LegsDrayageApi = exports.LegsDrayageApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var Accessorials;
(function (Accessorials) {
    Accessorials["AppointmentRequested"] = "APPOINTMENT_REQUESTED";
    Accessorials["ConstructionSiteDelivery"] = "CONSTRUCTION_SITE_DELIVERY";
    Accessorials["ConstructionSitePickup"] = "CONSTRUCTION_SITE_PICKUP";
    Accessorials["ConventionTradeShowDelivery"] = "CONVENTION_TRADE_SHOW_DELIVERY";
    Accessorials["ConventionTradeShowPickup"] = "CONVENTION_TRADE_SHOW_PICKUP";
    Accessorials["InsideDelivery"] = "INSIDE_DELIVERY";
    Accessorials["InsidePickup"] = "INSIDE_PICKUP";
    Accessorials["LiftgateDelivery"] = "LIFTGATE_DELIVERY";
    Accessorials["LiftgatePickup"] = "LIFTGATE_PICKUP";
    Accessorials["LimitedAccessDelivery"] = "LIMITED_ACCESS_DELIVERY";
    Accessorials["LimitedAccessPickup"] = "LIMITED_ACCESS_PICKUP";
    Accessorials["ResidentialDelivery"] = "RESIDENTIAL_DELIVERY";
    Accessorials["ResidentialPickup"] = "RESIDENTIAL_PICKUP";
    Accessorials["SortSegregate"] = "SORT_SEGREGATE";
})(Accessorials = exports.Accessorials || (exports.Accessorials = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var AreaUnit;
(function (AreaUnit) {
    AreaUnit["Ft"] = "SQ_FT";
    AreaUnit["Yd"] = "SQ_YD";
})(AreaUnit = exports.AreaUnit || (exports.AreaUnit = {}));
/**
 * Enum for shipment timeline event subtypes. Further defines event beyond BECoreShipmentTimelineEventType.
 * @export
 * @enum {string}
 */
var BECoreShipmentTimelineEventSubType;
(function (BECoreShipmentTimelineEventSubType) {
    BECoreShipmentTimelineEventSubType["AtDelivery"] = "AT_DELIVERY";
    BECoreShipmentTimelineEventSubType["AtLocation"] = "AT_LOCATION";
    BECoreShipmentTimelineEventSubType["AtPickup"] = "AT_PICKUP";
    BECoreShipmentTimelineEventSubType["AtStop"] = "AT_STOP";
    BECoreShipmentTimelineEventSubType["Canceled"] = "CANCELED";
    BECoreShipmentTimelineEventSubType["Delayed"] = "DELAYED";
    BECoreShipmentTimelineEventSubType["Delivered"] = "DELIVERED";
    BECoreShipmentTimelineEventSubType["DeliveredException"] = "DELIVERED_EXCEPTION";
    BECoreShipmentTimelineEventSubType["Delivery"] = "DELIVERY";
    BECoreShipmentTimelineEventSubType["DeliveryAppointment"] = "DELIVERY_APPOINTMENT";
    BECoreShipmentTimelineEventSubType["DeliveryMissed"] = "DELIVERY_MISSED";
    BECoreShipmentTimelineEventSubType["Departed"] = "DEPARTED";
    BECoreShipmentTimelineEventSubType["DepartedStop"] = "DEPARTED_STOP";
    BECoreShipmentTimelineEventSubType["Departure"] = "DEPARTURE";
    BECoreShipmentTimelineEventSubType["DepartureMissed"] = "DEPARTURE_MISSED";
    BECoreShipmentTimelineEventSubType["Dispatched"] = "DISPATCHED";
    BECoreShipmentTimelineEventSubType["EnRoute"] = "EN_ROUTE";
    BECoreShipmentTimelineEventSubType["Exception"] = "EXCEPTION";
    BECoreShipmentTimelineEventSubType["Held"] = "HELD";
    BECoreShipmentTimelineEventSubType["InTransit"] = "IN_TRANSIT";
    BECoreShipmentTimelineEventSubType["Info"] = "INFO";
    BECoreShipmentTimelineEventSubType["Interline"] = "INTERLINE";
    BECoreShipmentTimelineEventSubType["InterlineDelivered"] = "INTERLINE_DELIVERED";
    BECoreShipmentTimelineEventSubType["InterlineMissed"] = "INTERLINE_MISSED";
    BECoreShipmentTimelineEventSubType["OutForDelivery"] = "OUT_FOR_DELIVERY";
    BECoreShipmentTimelineEventSubType["PickedUp"] = "PICKED_UP";
    BECoreShipmentTimelineEventSubType["Pickup"] = "PICKUP";
    BECoreShipmentTimelineEventSubType["PickupMissed"] = "PICKUP_MISSED";
    BECoreShipmentTimelineEventSubType["StopCancelled"] = "STOP_CANCELLED";
    BECoreShipmentTimelineEventSubType["StopCompleted"] = "STOP_COMPLETED";
})(BECoreShipmentTimelineEventSubType = exports.BECoreShipmentTimelineEventSubType || (exports.BECoreShipmentTimelineEventSubType = {}));
/**
 * Enum for shipment timeline event types.
 * @export
 * @enum {string}
 */
var BECoreShipmentTimelineEventType;
(function (BECoreShipmentTimelineEventType) {
    BECoreShipmentTimelineEventType["AtDelivery"] = "AT_DELIVERY";
    BECoreShipmentTimelineEventType["AtPickup"] = "AT_PICKUP";
    BECoreShipmentTimelineEventType["Booked"] = "BOOKED";
    BECoreShipmentTimelineEventType["Cancelled"] = "CANCELLED";
    BECoreShipmentTimelineEventType["CarrierMatched"] = "CARRIER_MATCHED";
    BECoreShipmentTimelineEventType["Delivered"] = "DELIVERED";
    BECoreShipmentTimelineEventType["DetailsChanged"] = "DETAILS_CHANGED";
    BECoreShipmentTimelineEventType["Dispatched"] = "DISPATCHED";
    BECoreShipmentTimelineEventType["DriverAssigned"] = "DRIVER_ASSIGNED";
    BECoreShipmentTimelineEventType["EtaChanged"] = "ETA_CHANGED";
    BECoreShipmentTimelineEventType["Info"] = "INFO";
    BECoreShipmentTimelineEventType["LocationUpdated"] = "LOCATION_UPDATED";
    BECoreShipmentTimelineEventType["PickedUp"] = "PICKED_UP";
    BECoreShipmentTimelineEventType["TrackReceived"] = "TRACK_RECEIVED";
    BECoreShipmentTimelineEventType["StopCompleted"] = "STOP_COMPLETED";
    BECoreShipmentTimelineEventType["StopEvent"] = "STOP_EVENT";
})(BECoreShipmentTimelineEventType = exports.BECoreShipmentTimelineEventType || (exports.BECoreShipmentTimelineEventType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var BulkLoadOrderOperationAction;
(function (BulkLoadOrderOperationAction) {
    BulkLoadOrderOperationAction["Create"] = "CREATE";
    BulkLoadOrderOperationAction["Update"] = "UPDATE";
    BulkLoadOrderOperationAction["CreateOrUpdate"] = "CREATE_OR_UPDATE";
    BulkLoadOrderOperationAction["Cancel"] = "CANCEL";
})(BulkLoadOrderOperationAction = exports.BulkLoadOrderOperationAction || (exports.BulkLoadOrderOperationAction = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var BulkLoadOrderOperationResult;
(function (BulkLoadOrderOperationResult) {
    BulkLoadOrderOperationResult["Success"] = "SUCCESS";
    BulkLoadOrderOperationResult["Error"] = "ERROR";
})(BulkLoadOrderOperationResult = exports.BulkLoadOrderOperationResult || (exports.BulkLoadOrderOperationResult = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var CarrierAssignmentStatus;
(function (CarrierAssignmentStatus) {
    CarrierAssignmentStatus["NotAssigned"] = "NOT_ASSIGNED";
    CarrierAssignmentStatus["Requested"] = "REQUESTED";
    CarrierAssignmentStatus["Accepted"] = "ACCEPTED";
})(CarrierAssignmentStatus = exports.CarrierAssignmentStatus || (exports.CarrierAssignmentStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ChargeCategory;
(function (ChargeCategory) {
    ChargeCategory["LineHaul"] = "LINE_HAUL";
    ChargeCategory["Fuel"] = "FUEL";
    ChargeCategory["FuelSurcharge"] = "FUEL_SURCHARGE";
    ChargeCategory["Accessorial"] = "ACCESSORIAL";
    ChargeCategory["Insurance"] = "INSURANCE";
    ChargeCategory["Detention"] = "DETENTION";
    ChargeCategory["ServiceFee"] = "SERVICE_FEE";
    ChargeCategory["Adjustment"] = "ADJUSTMENT";
    ChargeCategory["Other"] = "OTHER";
    ChargeCategory["Tax"] = "TAX";
})(ChargeCategory = exports.ChargeCategory || (exports.ChargeCategory = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContactType;
(function (ContactType) {
    ContactType["AccountRep"] = "ACCOUNT_REP";
    ContactType["Administrator"] = "ADMINISTRATOR";
    ContactType["AfterHoursContact"] = "AFTER_HOURS_CONTACT";
    ContactType["AppointmentScheduler"] = "APPOINTMENT_SCHEDULER";
    ContactType["Agent"] = "AGENT";
    ContactType["Broker"] = "BROKER";
    ContactType["CarrierRep"] = "CARRIER_REP";
    ContactType["ForwarderContact"] = "FORWARDER_CONTACT";
    ContactType["Other"] = "OTHER";
    ContactType["ReceivingContact"] = "RECEIVING_CONTACT";
    ContactType["SalesRep"] = "SALES_REP";
    ContactType["ShipperContact"] = "SHIPPER_CONTACT";
    ContactType["UltimateReceiver"] = "ULTIMATE_RECEIVER";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
/**
    * @export
    * @enum {string}
    */
var ContainerDimensionUnitEnum;
(function (ContainerDimensionUnitEnum) {
    ContainerDimensionUnitEnum["Ft"] = "FT";
})(ContainerDimensionUnitEnum = exports.ContainerDimensionUnitEnum || (exports.ContainerDimensionUnitEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContainerHeightFT;
(function (ContainerHeightFT) {
    ContainerHeightFT["_85"] = "8.5";
    ContainerHeightFT["_95"] = "9.5";
})(ContainerHeightFT = exports.ContainerHeightFT || (exports.ContainerHeightFT = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContainerLengthFT;
(function (ContainerLengthFT) {
    ContainerLengthFT["_20"] = "20";
    ContainerLengthFT["_40"] = "40";
    ContainerLengthFT["_45"] = "45";
    ContainerLengthFT["_53"] = "53";
})(ContainerLengthFT = exports.ContainerLengthFT || (exports.ContainerLengthFT = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContainerPackagingType;
(function (ContainerPackagingType) {
    ContainerPackagingType["Container"] = "CONTAINER";
})(ContainerPackagingType = exports.ContainerPackagingType || (exports.ContainerPackagingType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContainerType;
(function (ContainerType) {
    ContainerType["GeneralPurpose"] = "GENERAL_PURPOSE";
    ContainerType["InsulatedGeneralPurpose"] = "INSULATED_GENERAL_PURPOSE";
    ContainerType["Bulk"] = "BULK";
    ContainerType["Refrigerated"] = "REFRIGERATED";
    ContainerType["Oversize"] = "OVERSIZE";
    ContainerType["FlatRack"] = "FLAT_RACK";
    ContainerType["Tank"] = "TANK";
    ContainerType["RefrigeratedTank"] = "REFRIGERATED_TANK";
    ContainerType["OpenTop"] = "OPEN_TOP";
})(ContainerType = exports.ContainerType || (exports.ContainerType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ContainerWidthFT;
(function (ContainerWidthFT) {
    ContainerWidthFT["_8"] = "8";
    ContainerWidthFT["_85"] = "8.5";
})(ContainerWidthFT = exports.ContainerWidthFT || (exports.ContainerWidthFT = {}));
/**
    * @export
    * @enum {string}
    */
var CreatePurchaseOrderOrderTypeEnum;
(function (CreatePurchaseOrderOrderTypeEnum) {
    CreatePurchaseOrderOrderTypeEnum["PurchaseOrder"] = "PURCHASE_ORDER";
})(CreatePurchaseOrderOrderTypeEnum = exports.CreatePurchaseOrderOrderTypeEnum || (exports.CreatePurchaseOrderOrderTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreatePurchaseOrderReleaseReleaseTypeEnum;
(function (CreatePurchaseOrderReleaseReleaseTypeEnum) {
    CreatePurchaseOrderReleaseReleaseTypeEnum["Order"] = "ORDER";
})(CreatePurchaseOrderReleaseReleaseTypeEnum = exports.CreatePurchaseOrderReleaseReleaseTypeEnum || (exports.CreatePurchaseOrderReleaseReleaseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateSalesOrderReleaseReleaseTypeEnum;
(function (CreateSalesOrderReleaseReleaseTypeEnum) {
    CreateSalesOrderReleaseReleaseTypeEnum["Order"] = "ORDER";
})(CreateSalesOrderReleaseReleaseTypeEnum = exports.CreateSalesOrderReleaseReleaseTypeEnum || (exports.CreateSalesOrderReleaseReleaseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreateTransportationReleaseReleaseTypeEnum;
(function (CreateTransportationReleaseReleaseTypeEnum) {
    CreateTransportationReleaseReleaseTypeEnum["Transportation"] = "TRANSPORTATION";
})(CreateTransportationReleaseReleaseTypeEnum = exports.CreateTransportationReleaseReleaseTypeEnum || (exports.CreateTransportationReleaseReleaseTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var CreatedBySource;
(function (CreatedBySource) {
    CreatedBySource["ShipwellWeb"] = "SHIPWELL_WEB";
    CreatedBySource["Import"] = "IMPORT";
    CreatedBySource["Tender"] = "TENDER";
    CreatedBySource["ShipwellWebUnauth"] = "SHIPWELL_WEB_UNAUTH";
    CreatedBySource["Other"] = "OTHER";
})(CreatedBySource = exports.CreatedBySource || (exports.CreatedBySource = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DocumentType;
(function (DocumentType) {
    DocumentType["Bol"] = "BOL";
    DocumentType["Fuel"] = "FUEL";
    DocumentType["Lumper"] = "LUMPER";
    DocumentType["Hos"] = "HOS";
    DocumentType["Signature"] = "SIGNATURE";
    DocumentType["RateConfirmation"] = "RATE_CONFIRMATION";
    DocumentType["DeliveryReceipt"] = "DELIVERY_RECEIPT";
    DocumentType["WeightCertificate"] = "WEIGHT_CERTIFICATE";
    DocumentType["OveragesShortagesAndDamages"] = "OVERAGES_SHORTAGES_AND_DAMAGES";
    DocumentType["Invoice"] = "INVOICE";
    DocumentType["Insurance"] = "INSURANCE";
    DocumentType["CustomsPaperwork"] = "CUSTOMS_PAPERWORK";
    DocumentType["PackingSlips"] = "PACKING_SLIPS";
    DocumentType["Other"] = "OTHER";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
/**
    * @export
    * @enum {string}
    */
var DrayageBookingLegTypeEnum;
(function (DrayageBookingLegTypeEnum) {
    DrayageBookingLegTypeEnum["Drayage"] = "DRAYAGE";
})(DrayageBookingLegTypeEnum = exports.DrayageBookingLegTypeEnum || (exports.DrayageBookingLegTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DrayageBookingAccessorials;
(function (DrayageBookingAccessorials) {
    DrayageBookingAccessorials["Cross"] = "CROSS";
    DrayageBookingAccessorials["Fridge"] = "FRIDGE";
    DrayageBookingAccessorials["Hazmat"] = "HAZMAT";
    DrayageBookingAccessorials["Layover"] = "LAYOVER";
    DrayageBookingAccessorials["Overdim"] = "OVERDIM";
    DrayageBookingAccessorials["Overweight"] = "OVERWEIGHT";
    DrayageBookingAccessorials["Pallet"] = "PALLET";
    DrayageBookingAccessorials["Storage"] = "STORAGE";
    DrayageBookingAccessorials["Scale"] = "SCALE";
    DrayageBookingAccessorials["Transload"] = "TRANSLOAD";
    DrayageBookingAccessorials["Warehouse"] = "WAREHOUSE";
})(DrayageBookingAccessorials = exports.DrayageBookingAccessorials || (exports.DrayageBookingAccessorials = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DrayageLegExecutionStatus;
(function (DrayageLegExecutionStatus) {
    DrayageLegExecutionStatus["Dispatched"] = "DISPATCHED";
    DrayageLegExecutionStatus["AtPickup"] = "AT_PICKUP";
    DrayageLegExecutionStatus["InTransit"] = "IN_TRANSIT";
    DrayageLegExecutionStatus["AtDelivery"] = "AT_DELIVERY";
    DrayageLegExecutionStatus["Delivered"] = "DELIVERED";
    DrayageLegExecutionStatus["ContainerReturned"] = "CONTAINER_RETURNED";
})(DrayageLegExecutionStatus = exports.DrayageLegExecutionStatus || (exports.DrayageLegExecutionStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DrayageLegOverallStatus;
(function (DrayageLegOverallStatus) {
    DrayageLegOverallStatus["Draft"] = "DRAFT";
    DrayageLegOverallStatus["Tendered"] = "TENDERED";
    DrayageLegOverallStatus["CarrierConfirmed"] = "CARRIER_CONFIRMED";
    DrayageLegOverallStatus["Dispatched"] = "DISPATCHED";
    DrayageLegOverallStatus["AtPickup"] = "AT_PICKUP";
    DrayageLegOverallStatus["InTransit"] = "IN_TRANSIT";
    DrayageLegOverallStatus["AtDelivery"] = "AT_DELIVERY";
    DrayageLegOverallStatus["Delivered"] = "DELIVERED";
    DrayageLegOverallStatus["ContainerReturned"] = "CONTAINER_RETURNED";
    DrayageLegOverallStatus["Cancelled"] = "CANCELLED";
})(DrayageLegOverallStatus = exports.DrayageLegOverallStatus || (exports.DrayageLegOverallStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DrayageReferenceType;
(function (DrayageReferenceType) {
    DrayageReferenceType["BolNumber"] = "BOL_NUMBER";
    DrayageReferenceType["HouseBolNumber"] = "HOUSE_BOL_NUMBER";
    DrayageReferenceType["CustomerReferenceNumber"] = "CUSTOMER_REFERENCE_NUMBER";
    DrayageReferenceType["PoNumber"] = "PO_NUMBER";
    DrayageReferenceType["BookingNumber"] = "BOOKING_NUMBER";
    DrayageReferenceType["Scac"] = "SCAC";
})(DrayageReferenceType = exports.DrayageReferenceType || (exports.DrayageReferenceType = {}));
/**
    * @export
    * @enum {string}
    */
var DrayageShipmentModeSpecificDataModeEnum;
(function (DrayageShipmentModeSpecificDataModeEnum) {
    DrayageShipmentModeSpecificDataModeEnum["Drayage"] = "DRAYAGE";
})(DrayageShipmentModeSpecificDataModeEnum = exports.DrayageShipmentModeSpecificDataModeEnum || (exports.DrayageShipmentModeSpecificDataModeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var FreightClass;
(function (FreightClass) {
    FreightClass["_50"] = "50";
    FreightClass["_55"] = "55";
    FreightClass["_60"] = "60";
    FreightClass["_65"] = "65";
    FreightClass["_70"] = "70";
    FreightClass["_775"] = "77.5";
    FreightClass["_85"] = "85";
    FreightClass["_925"] = "92.5";
    FreightClass["_100"] = "100";
    FreightClass["_110"] = "110";
    FreightClass["_125"] = "125";
    FreightClass["_150"] = "150";
    FreightClass["_175"] = "175";
    FreightClass["_200"] = "200";
    FreightClass["_250"] = "250";
    FreightClass["_300"] = "300";
    FreightClass["_400"] = "400";
    FreightClass["_500"] = "500";
})(FreightClass = exports.FreightClass || (exports.FreightClass = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var FreightInvoiceTenantRole;
(function (FreightInvoiceTenantRole) {
    FreightInvoiceTenantRole["ServiceProvider"] = "SERVICE_PROVIDER";
    FreightInvoiceTenantRole["BookingParty"] = "BOOKING_PARTY";
})(FreightInvoiceTenantRole = exports.FreightInvoiceTenantRole || (exports.FreightInvoiceTenantRole = {}));
/**
    * @export
    * @enum {string}
    */
var FtlLegLegTypeEnum;
(function (FtlLegLegTypeEnum) {
    FtlLegLegTypeEnum["Ftl"] = "FTL";
})(FtlLegLegTypeEnum = exports.FtlLegLegTypeEnum || (exports.FtlLegLegTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var FtlReferenceType;
(function (FtlReferenceType) {
    FtlReferenceType["BolNumber"] = "BOL_NUMBER";
    FtlReferenceType["CustomerReferenceNumber"] = "CUSTOMER_REFERENCE_NUMBER";
    FtlReferenceType["PoNumber"] = "PO_NUMBER";
})(FtlReferenceType = exports.FtlReferenceType || (exports.FtlReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var HazmatPackingGroup;
(function (HazmatPackingGroup) {
    HazmatPackingGroup["I"] = "I";
    HazmatPackingGroup["Ii"] = "II";
    HazmatPackingGroup["Iii"] = "III";
})(HazmatPackingGroup = exports.HazmatPackingGroup || (exports.HazmatPackingGroup = {}));
/**
    * @export
    * @enum {string}
    */
var LegStageStageTypeEnum;
(function (LegStageStageTypeEnum) {
    LegStageStageTypeEnum["Leg"] = "LEG";
})(LegStageStageTypeEnum = exports.LegStageStageTypeEnum || (exports.LegStageStageTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LegacyShipmentResourceRefResourceTypeEnum;
(function (LegacyShipmentResourceRefResourceTypeEnum) {
    LegacyShipmentResourceRefResourceTypeEnum["Shipment"] = "shipment";
})(LegacyShipmentResourceRefResourceTypeEnum = exports.LegacyShipmentResourceRefResourceTypeEnum || (exports.LegacyShipmentResourceRefResourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LegacyShipmentStageStageTypeEnum;
(function (LegacyShipmentStageStageTypeEnum) {
    LegacyShipmentStageStageTypeEnum["LegacyShipment"] = "LEGACY_SHIPMENT";
})(LegacyShipmentStageStageTypeEnum = exports.LegacyShipmentStageStageTypeEnum || (exports.LegacyShipmentStageStageTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var LengthUnit;
(function (LengthUnit) {
    LengthUnit["Cm"] = "CM";
    LengthUnit["Ft"] = "FT";
    LengthUnit["In"] = "IN";
    LengthUnit["M"] = "M";
})(LengthUnit = exports.LengthUnit || (exports.LengthUnit = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var LocationType;
(function (LocationType) {
    LocationType["ContainerYard"] = "CONTAINER_YARD";
    LocationType["Other"] = "OTHER";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
/**
    * @export
    * @enum {string}
    */
var OceanTrackingServiceTypeEnum;
(function (OceanTrackingServiceTypeEnum) {
    OceanTrackingServiceTypeEnum["OceanTracking"] = "OCEAN_TRACKING";
})(OceanTrackingServiceTypeEnum = exports.OceanTrackingServiceTypeEnum || (exports.OceanTrackingServiceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OceanTrackingOrderServiceServiceTypeEnum;
(function (OceanTrackingOrderServiceServiceTypeEnum) {
    OceanTrackingOrderServiceServiceTypeEnum["OceanTracking"] = "OCEAN_TRACKING";
})(OceanTrackingOrderServiceServiceTypeEnum = exports.OceanTrackingOrderServiceServiceTypeEnum || (exports.OceanTrackingOrderServiceServiceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OceanTrackingReferenceType;
(function (OceanTrackingReferenceType) {
    OceanTrackingReferenceType["Scac"] = "SCAC";
})(OceanTrackingReferenceType = exports.OceanTrackingReferenceType || (exports.OceanTrackingReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderCustomerReferenceType;
(function (OrderCustomerReferenceType) {
    OrderCustomerReferenceType["ExternalId"] = "EXTERNAL_ID";
})(OrderCustomerReferenceType = exports.OrderCustomerReferenceType || (exports.OrderCustomerReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderItemReferenceType;
(function (OrderItemReferenceType) {
    OrderItemReferenceType["ExternalReference"] = "EXTERNAL_REFERENCE";
    OrderItemReferenceType["ProductRef"] = "PRODUCT_REF";
})(OrderItemReferenceType = exports.OrderItemReferenceType || (exports.OrderItemReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderItemShippingRequirementsReferenceType;
(function (OrderItemShippingRequirementsReferenceType) {
    OrderItemShippingRequirementsReferenceType["ProductRef"] = "PRODUCT_REF";
})(OrderItemShippingRequirementsReferenceType = exports.OrderItemShippingRequirementsReferenceType || (exports.OrderItemShippingRequirementsReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderReferenceQualifier;
(function (OrderReferenceQualifier) {
    OrderReferenceQualifier["ExternalInvoiceId"] = "EXTERNAL_INVOICE_ID";
    OrderReferenceQualifier["ShipmentId"] = "SHIPMENT_ID";
    OrderReferenceQualifier["CustomerReferenceNumber"] = "CUSTOMER_REFERENCE_NUMBER";
    OrderReferenceQualifier["PurchaseOrderNumber"] = "PURCHASE_ORDER_NUMBER";
})(OrderReferenceQualifier = exports.OrderReferenceQualifier || (exports.OrderReferenceQualifier = {}));
/**
    * @export
    * @enum {string}
    */
var OrderReleaseReleaseTypeEnum;
(function (OrderReleaseReleaseTypeEnum) {
    OrderReleaseReleaseTypeEnum["Order"] = "ORDER";
})(OrderReleaseReleaseTypeEnum = exports.OrderReleaseReleaseTypeEnum || (exports.OrderReleaseReleaseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OrderReleaseDetailsReleaseTypeEnum;
(function (OrderReleaseDetailsReleaseTypeEnum) {
    OrderReleaseDetailsReleaseTypeEnum["Order"] = "ORDER";
})(OrderReleaseDetailsReleaseTypeEnum = exports.OrderReleaseDetailsReleaseTypeEnum || (exports.OrderReleaseDetailsReleaseTypeEnum = {}));
/**
 * Possible statuses for a Product Order Release.
 * @export
 * @enum {string}
 */
var OrderReleaseStatus;
(function (OrderReleaseStatus) {
    OrderReleaseStatus["Need"] = "NEED";
    OrderReleaseStatus["Accepted"] = "ACCEPTED";
    OrderReleaseStatus["Rejected"] = "REJECTED";
    OrderReleaseStatus["Cancelled"] = "CANCELLED";
})(OrderReleaseStatus = exports.OrderReleaseStatus || (exports.OrderReleaseStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Requested"] = "REQUESTED";
    OrderStatus["Accepted"] = "ACCEPTED";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Expired"] = "EXPIRED";
    OrderStatus["Revoked"] = "REVOKED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderSupplierReferenceType;
(function (OrderSupplierReferenceType) {
    OrderSupplierReferenceType["ExternalId"] = "EXTERNAL_ID";
})(OrderSupplierReferenceType = exports.OrderSupplierReferenceType || (exports.OrderSupplierReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderTransitDetailsResource;
(function (OrderTransitDetailsResource) {
    OrderTransitDetailsResource["Shipment"] = "SHIPMENT";
})(OrderTransitDetailsResource = exports.OrderTransitDetailsResource || (exports.OrderTransitDetailsResource = {}));
/**
    * @export
    * @enum {string}
    */
var OrderTransitTimelineEventTransitTypeEnum;
(function (OrderTransitTimelineEventTransitTypeEnum) {
    OrderTransitTimelineEventTransitTypeEnum["Shipment"] = "SHIPMENT";
})(OrderTransitTimelineEventTransitTypeEnum = exports.OrderTransitTimelineEventTransitTypeEnum || (exports.OrderTransitTimelineEventTransitTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderType;
(function (OrderType) {
    OrderType["PurchaseOrder"] = "PURCHASE_ORDER";
    OrderType["SalesOrder"] = "SALES_ORDER";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var PackagingType;
(function (PackagingType) {
    PackagingType["Bag"] = "BAG";
    PackagingType["Bale"] = "BALE";
    PackagingType["Barrel"] = "BARREL";
    PackagingType["Basket"] = "BASKET";
    PackagingType["Bin"] = "BIN";
    PackagingType["Box"] = "BOX";
    PackagingType["Bucket"] = "BUCKET";
    PackagingType["Bundle"] = "BUNDLE";
    PackagingType["Can"] = "CAN";
    PackagingType["Carton"] = "CARTON";
    PackagingType["Case"] = "CASE";
    PackagingType["Coil"] = "COIL";
    PackagingType["Container"] = "CONTAINER";
    PackagingType["Crate"] = "CRATE";
    PackagingType["Cylinder"] = "CYLINDER";
    PackagingType["Drum"] = "DRUM";
    PackagingType["Envelope"] = "ENVELOPE";
    PackagingType["FloorLoaded"] = "FLOOR_LOADED";
    PackagingType["Hamper"] = "HAMPER";
    PackagingType["None"] = "NONE";
    PackagingType["Other"] = "OTHER";
    PackagingType["Package"] = "PACKAGE";
    PackagingType["Pail"] = "PAIL";
    PackagingType["Pallet"] = "PALLET";
    PackagingType["Piece"] = "PIECE";
    PackagingType["ProviderSpecific"] = "PROVIDER_SPECIFIC";
    PackagingType["Reel"] = "REEL";
    PackagingType["Roll"] = "ROLL";
    PackagingType["Skid"] = "SKID";
    PackagingType["Tank"] = "TANK";
    PackagingType["ToteBin"] = "TOTE_BIN";
    PackagingType["ToteCan"] = "TOTE_CAN";
    PackagingType["Tube"] = "TUBE";
    PackagingType["Unit"] = "UNIT";
})(PackagingType = exports.PackagingType || (exports.PackagingType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm["Prepaid"] = "PREPAID";
    PaymentTerm["Collect"] = "COLLECT";
    PaymentTerm["ThirdParty"] = "THIRD_PARTY";
})(PaymentTerm = exports.PaymentTerm || (exports.PaymentTerm = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var PieceType;
(function (PieceType) {
    PieceType["Bag"] = "BAG";
    PieceType["Bale"] = "BALE";
    PieceType["Box"] = "BOX";
    PieceType["Bucket"] = "BUCKET";
    PieceType["Bundle"] = "BUNDLE";
    PieceType["Can"] = "CAN";
    PieceType["Carton"] = "CARTON";
    PieceType["Case"] = "CASE";
    PieceType["Coil"] = "COIL";
    PieceType["Crate"] = "CRATE";
    PieceType["Cylinder"] = "CYLINDER";
    PieceType["Drum"] = "DRUM";
    PieceType["Package"] = "PACKAGE";
    PieceType["Pieces"] = "PIECES";
    PieceType["Pail"] = "PAIL";
    PieceType["Reel"] = "REEL";
    PieceType["Roll"] = "ROLL";
    PieceType["Skid"] = "SKID";
    PieceType["Tube"] = "TUBE";
})(PieceType = exports.PieceType || (exports.PieceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ProductOrderStatus;
(function (ProductOrderStatus) {
    ProductOrderStatus["NotReady"] = "NOT_READY";
    ProductOrderStatus["Ready"] = "READY";
    ProductOrderStatus["Filled"] = "FILLED";
    ProductOrderStatus["Assigned"] = "ASSIGNED";
    ProductOrderStatus["Cancelled"] = "CANCELLED";
    ProductOrderStatus["Dispatched"] = "DISPATCHED";
    ProductOrderStatus["InTransit"] = "IN_TRANSIT";
    ProductOrderStatus["OutForDelivery"] = "OUT_FOR_DELIVERY";
    ProductOrderStatus["Delivered"] = "DELIVERED";
})(ProductOrderStatus = exports.ProductOrderStatus || (exports.ProductOrderStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ProductOrderStopReferenceQualifier;
(function (ProductOrderStopReferenceQualifier) {
    ProductOrderStopReferenceQualifier["DockExternalId"] = "DOCK_EXTERNAL_ID";
    ProductOrderStopReferenceQualifier["AddressBookEntryId"] = "ADDRESS_BOOK_ENTRY_ID";
    ProductOrderStopReferenceQualifier["AddressBookEntryReferenceId"] = "ADDRESS_BOOK_ENTRY_REFERENCE_ID";
    ProductOrderStopReferenceQualifier["StopId"] = "STOP_ID";
    ProductOrderStopReferenceQualifier["CompanyExternalId"] = "COMPANY_EXTERNAL_ID";
})(ProductOrderStopReferenceQualifier = exports.ProductOrderStopReferenceQualifier || (exports.ProductOrderStopReferenceQualifier = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ProductPackagingType;
(function (ProductPackagingType) {
    ProductPackagingType["Bag"] = "BAG";
    ProductPackagingType["Bale"] = "BALE";
    ProductPackagingType["Barrel"] = "BARREL";
    ProductPackagingType["Basket"] = "BASKET";
    ProductPackagingType["Box"] = "BOX";
    ProductPackagingType["Bucket"] = "BUCKET";
    ProductPackagingType["Bundle"] = "BUNDLE";
    ProductPackagingType["Carton"] = "CARTON";
    ProductPackagingType["Case"] = "CASE";
    ProductPackagingType["Coil"] = "COIL";
    ProductPackagingType["Crate"] = "CRATE";
    ProductPackagingType["Cylinder"] = "CYLINDER";
    ProductPackagingType["Drum"] = "DRUM";
    ProductPackagingType["Envelope"] = "ENVELOPE";
    ProductPackagingType["Hamper"] = "HAMPER";
    ProductPackagingType["None"] = "NONE";
    ProductPackagingType["Other"] = "OTHER";
    ProductPackagingType["Pail"] = "PAIL";
    ProductPackagingType["Pallet"] = "PALLET";
    ProductPackagingType["Piece"] = "PIECE";
    ProductPackagingType["Reel"] = "REEL";
    ProductPackagingType["Roll"] = "ROLL";
    ProductPackagingType["Skid"] = "SKID";
    ProductPackagingType["Tank"] = "TANK";
    ProductPackagingType["Tube"] = "TUBE";
    ProductPackagingType["FloorLoaded"] = "FLOOR_LOADED";
    ProductPackagingType["Package"] = "PACKAGE";
})(ProductPackagingType = exports.ProductPackagingType || (exports.ProductPackagingType = {}));
/**
    * @export
    * @enum {string}
    */
var PurchaseOrderOrderTypeEnum;
(function (PurchaseOrderOrderTypeEnum) {
    PurchaseOrderOrderTypeEnum["PurchaseOrder"] = "PURCHASE_ORDER";
})(PurchaseOrderOrderTypeEnum = exports.PurchaseOrderOrderTypeEnum || (exports.PurchaseOrderOrderTypeEnum = {}));
/**
 * Status for purchase orders.
 * @export
 * @enum {string}
 */
var PurchaseOrderStatus;
(function (PurchaseOrderStatus) {
    PurchaseOrderStatus["NotReady"] = "NOT_READY";
    PurchaseOrderStatus["Ready"] = "READY";
    PurchaseOrderStatus["Filled"] = "FILLED";
    PurchaseOrderStatus["Assigned"] = "ASSIGNED";
    PurchaseOrderStatus["Cancelled"] = "CANCELLED";
    PurchaseOrderStatus["Dispatched"] = "DISPATCHED";
    PurchaseOrderStatus["InTransit"] = "IN_TRANSIT";
    PurchaseOrderStatus["OutForDelivery"] = "OUT_FOR_DELIVERY";
    PurchaseOrderStatus["Delivered"] = "DELIVERED";
})(PurchaseOrderStatus = exports.PurchaseOrderStatus || (exports.PurchaseOrderStatus = {}));
/**
    * @export
    * @enum {string}
    */
var RailTrackingServiceTypeEnum;
(function (RailTrackingServiceTypeEnum) {
    RailTrackingServiceTypeEnum["RailTracking"] = "RAIL_TRACKING";
})(RailTrackingServiceTypeEnum = exports.RailTrackingServiceTypeEnum || (exports.RailTrackingServiceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RailTrackingOrderServiceServiceTypeEnum;
(function (RailTrackingOrderServiceServiceTypeEnum) {
    RailTrackingOrderServiceServiceTypeEnum["RailTracking"] = "RAIL_TRACKING";
})(RailTrackingOrderServiceServiceTypeEnum = exports.RailTrackingOrderServiceServiceTypeEnum || (exports.RailTrackingOrderServiceServiceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var RailTrackingReferenceType;
(function (RailTrackingReferenceType) {
    RailTrackingReferenceType["Scac"] = "SCAC";
})(RailTrackingReferenceType = exports.RailTrackingReferenceType || (exports.RailTrackingReferenceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var RemitToEntityType;
(function (RemitToEntityType) {
    RemitToEntityType["Individual"] = "INDIVIDUAL";
    RemitToEntityType["Company"] = "COMPANY";
})(RemitToEntityType = exports.RemitToEntityType || (exports.RemitToEntityType = {}));
/**
    * @export
    * @enum {string}
    */
var SalesOrderOrderTypeEnum;
(function (SalesOrderOrderTypeEnum) {
    SalesOrderOrderTypeEnum["SalesOrder"] = "SALES_ORDER";
})(SalesOrderOrderTypeEnum = exports.SalesOrderOrderTypeEnum || (exports.SalesOrderOrderTypeEnum = {}));
/**
 * Status for sales orders.
 * @export
 * @enum {string}
 */
var SalesOrderStatus;
(function (SalesOrderStatus) {
    SalesOrderStatus["NotReady"] = "NOT_READY";
    SalesOrderStatus["Ready"] = "READY";
    SalesOrderStatus["Filled"] = "FILLED";
    SalesOrderStatus["Assigned"] = "ASSIGNED";
    SalesOrderStatus["Cancelled"] = "CANCELLED";
    SalesOrderStatus["Dispatched"] = "DISPATCHED";
    SalesOrderStatus["InTransit"] = "IN_TRANSIT";
    SalesOrderStatus["OutForDelivery"] = "OUT_FOR_DELIVERY";
    SalesOrderStatus["Delivered"] = "DELIVERED";
})(SalesOrderStatus = exports.SalesOrderStatus || (exports.SalesOrderStatus = {}));
/**
    * @export
    * @enum {string}
    */
var SalesOrderTransitDocumentTransitTypeEnum;
(function (SalesOrderTransitDocumentTransitTypeEnum) {
    SalesOrderTransitDocumentTransitTypeEnum["Shipment"] = "SHIPMENT";
})(SalesOrderTransitDocumentTransitTypeEnum = exports.SalesOrderTransitDocumentTransitTypeEnum || (exports.SalesOrderTransitDocumentTransitTypeEnum = {}));
/**
 * Enum for sales order transit document types.
 * @export
 * @enum {string}
 */
var SalesOrderTransitDocumentType;
(function (SalesOrderTransitDocumentType) {
    SalesOrderTransitDocumentType["Bol"] = "BOL";
    SalesOrderTransitDocumentType["ShippingLabel"] = "SHIPPING_LABEL";
})(SalesOrderTransitDocumentType = exports.SalesOrderTransitDocumentType || (exports.SalesOrderTransitDocumentType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ServiceReferenceType;
(function (ServiceReferenceType) {
    ServiceReferenceType["BolNumber"] = "BOL_NUMBER";
    ServiceReferenceType["HouseBolNumber"] = "HOUSE_BOL_NUMBER";
    ServiceReferenceType["CustomerReferenceNumber"] = "CUSTOMER_REFERENCE_NUMBER";
    ServiceReferenceType["PoNumber"] = "PO_NUMBER";
    ServiceReferenceType["BookingNumber"] = "BOOKING_NUMBER";
    ServiceReferenceType["ContainerNumber"] = "CONTAINER_NUMBER";
})(ServiceReferenceType = exports.ServiceReferenceType || (exports.ServiceReferenceType = {}));
/**
    * @export
    * @enum {string}
    */
var ServiceStageStageTypeEnum;
(function (ServiceStageStageTypeEnum) {
    ServiceStageStageTypeEnum["Service"] = "SERVICE";
})(ServiceStageStageTypeEnum = exports.ServiceStageStageTypeEnum || (exports.ServiceStageStageTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ShipmentOverallStatus;
(function (ShipmentOverallStatus) {
    ShipmentOverallStatus["Draft"] = "DRAFT";
    ShipmentOverallStatus["InProgress"] = "IN_PROGRESS";
    ShipmentOverallStatus["Complete"] = "COMPLETE";
    ShipmentOverallStatus["Cancelled"] = "CANCELLED";
})(ShipmentOverallStatus = exports.ShipmentOverallStatus || (exports.ShipmentOverallStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ShipmentTimelineEventType;
(function (ShipmentTimelineEventType) {
    ShipmentTimelineEventType["Info"] = "INFO";
})(ShipmentTimelineEventType = exports.ShipmentTimelineEventType || (exports.ShipmentTimelineEventType = {}));
/**
    * @export
    * @enum {string}
    */
var StageSummaryResourceTypeEnum;
(function (StageSummaryResourceTypeEnum) {
    StageSummaryResourceTypeEnum["ShipmentStage"] = "shipment_stage";
})(StageSummaryResourceTypeEnum = exports.StageSummaryResourceTypeEnum || (exports.StageSummaryResourceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StageTimelineEventType;
(function (StageTimelineEventType) {
    StageTimelineEventType["Info"] = "INFO";
    StageTimelineEventType["LocationUpdate"] = "LOCATION_UPDATE";
})(StageTimelineEventType = exports.StageTimelineEventType || (exports.StageTimelineEventType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StageType;
(function (StageType) {
    StageType["Leg"] = "LEG";
    StageType["LegacyShipment"] = "LEGACY_SHIPMENT";
    StageType["Service"] = "SERVICE";
})(StageType = exports.StageType || (exports.StageType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StopExecutionStatus;
(function (StopExecutionStatus) {
    StopExecutionStatus["Pending"] = "PENDING";
    StopExecutionStatus["EnRoute"] = "EN_ROUTE";
    StopExecutionStatus["AtStop"] = "AT_STOP";
    StopExecutionStatus["Departed"] = "DEPARTED";
})(StopExecutionStatus = exports.StopExecutionStatus || (exports.StopExecutionStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StopReason;
(function (StopReason) {
    StopReason["Load"] = "LOAD";
    StopReason["Unload"] = "UNLOAD";
})(StopReason = exports.StopReason || (exports.StopReason = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StopReferenceQualifier;
(function (StopReferenceQualifier) {
    StopReferenceQualifier["PickupNumber"] = "PICKUP_NUMBER";
})(StopReferenceQualifier = exports.StopReferenceQualifier || (exports.StopReferenceQualifier = {}));
/**
    * @export
    * @enum {string}
    */
var StorageServiceTypeEnum;
(function (StorageServiceTypeEnum) {
    StorageServiceTypeEnum["Storage"] = "STORAGE";
})(StorageServiceTypeEnum = exports.StorageServiceTypeEnum || (exports.StorageServiceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["C"] = "C";
    TemperatureUnit["F"] = "F";
})(TemperatureUnit = exports.TemperatureUnit || (exports.TemperatureUnit = {}));
/**
    * @export
    * @enum {string}
    */
var TerminalFeeServiceTypeEnum;
(function (TerminalFeeServiceTypeEnum) {
    TerminalFeeServiceTypeEnum["TerminalFee"] = "TERMINAL_FEE";
})(TerminalFeeServiceTypeEnum = exports.TerminalFeeServiceTypeEnum || (exports.TerminalFeeServiceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TimelineEventSource;
(function (TimelineEventSource) {
    TimelineEventSource["Manual"] = "MANUAL";
    TimelineEventSource["System"] = "SYSTEM";
})(TimelineEventSource = exports.TimelineEventSource || (exports.TimelineEventSource = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TrackingResourceType;
(function (TrackingResourceType) {
    TrackingResourceType["Leg"] = "LEG";
    TrackingResourceType["ShipmentService"] = "SHIPMENT_SERVICE";
})(TrackingResourceType = exports.TrackingResourceType || (exports.TrackingResourceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TransitStatus;
(function (TransitStatus) {
    TransitStatus["Dispatched"] = "DISPATCHED";
    TransitStatus["InTransit"] = "IN_TRANSIT";
    TransitStatus["OutForDelivery"] = "OUT_FOR_DELIVERY";
    TransitStatus["Delivered"] = "DELIVERED";
})(TransitStatus = exports.TransitStatus || (exports.TransitStatus = {}));
/**
    * @export
    * @enum {string}
    */
var TransloadServiceTypeEnum;
(function (TransloadServiceTypeEnum) {
    TransloadServiceTypeEnum["Transload"] = "TRANSLOAD";
})(TransloadServiceTypeEnum = exports.TransloadServiceTypeEnum || (exports.TransloadServiceTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TransportationMode;
(function (TransportationMode) {
    TransportationMode["Drayage"] = "DRAYAGE";
    TransportationMode["Ftl"] = "FTL";
    TransportationMode["Rail"] = "RAIL";
})(TransportationMode = exports.TransportationMode || (exports.TransportationMode = {}));
/**
    * @export
    * @enum {string}
    */
var TransportationReleaseReleaseTypeEnum;
(function (TransportationReleaseReleaseTypeEnum) {
    TransportationReleaseReleaseTypeEnum["Transportation"] = "TRANSPORTATION";
})(TransportationReleaseReleaseTypeEnum = exports.TransportationReleaseReleaseTypeEnum || (exports.TransportationReleaseReleaseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TransportationReleaseDetailsReleaseTypeEnum;
(function (TransportationReleaseDetailsReleaseTypeEnum) {
    TransportationReleaseDetailsReleaseTypeEnum["Transportation"] = "TRANSPORTATION";
})(TransportationReleaseDetailsReleaseTypeEnum = exports.TransportationReleaseDetailsReleaseTypeEnum || (exports.TransportationReleaseDetailsReleaseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateEntirePurchaseOrderOrderTypeEnum;
(function (UpdateEntirePurchaseOrderOrderTypeEnum) {
    UpdateEntirePurchaseOrderOrderTypeEnum["PurchaseOrder"] = "PURCHASE_ORDER";
})(UpdateEntirePurchaseOrderOrderTypeEnum = exports.UpdateEntirePurchaseOrderOrderTypeEnum || (exports.UpdateEntirePurchaseOrderOrderTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateEntireSalesOrderOrderTypeEnum;
(function (UpdateEntireSalesOrderOrderTypeEnum) {
    UpdateEntireSalesOrderOrderTypeEnum["SalesOrder"] = "SALES_ORDER";
})(UpdateEntireSalesOrderOrderTypeEnum = exports.UpdateEntireSalesOrderOrderTypeEnum || (exports.UpdateEntireSalesOrderOrderTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdatePurchaseOrderOrderTypeEnum;
(function (UpdatePurchaseOrderOrderTypeEnum) {
    UpdatePurchaseOrderOrderTypeEnum["PurchaseOrder"] = "PURCHASE_ORDER";
})(UpdatePurchaseOrderOrderTypeEnum = exports.UpdatePurchaseOrderOrderTypeEnum || (exports.UpdatePurchaseOrderOrderTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UpdateSalesOrderOrderTypeEnum;
(function (UpdateSalesOrderOrderTypeEnum) {
    UpdateSalesOrderOrderTypeEnum["SalesOrder"] = "SALES_ORDER";
})(UpdateSalesOrderOrderTypeEnum = exports.UpdateSalesOrderOrderTypeEnum || (exports.UpdateSalesOrderOrderTypeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var VolumeUnit;
(function (VolumeUnit) {
    VolumeUnit["CuFt"] = "CU_FT";
    VolumeUnit["CuM"] = "CU_M";
    VolumeUnit["Gallon"] = "GALLON";
    VolumeUnit["Liter"] = "LITER";
})(VolumeUnit = exports.VolumeUnit || (exports.VolumeUnit = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["Kg"] = "KG";
    WeightUnit["Lb"] = "LB";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
/**
 * LegsApi - axios parameter creator
 * @export
 */
var LegsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Associates an existing shipping item to a leg
         * @summary Assign Shipment Item
         * @param {string} legId
         * @param {AssignShipmentItem} assignShipmentItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignShipmentItemLegsLegIdItemsAssignPost: function (legId, assignShipmentItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('assignShipmentItemLegsLegIdItemsAssignPost', 'legId', legId);
                            // verify required parameter 'assignShipmentItem' is not null or undefined
                            (0, common_1.assertParamExists)('assignShipmentItemLegsLegIdItemsAssignPost', 'assignShipmentItem', assignShipmentItem);
                            localVarPath = "/legs/{leg_id}/items/assign"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(assignShipmentItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new leg item for a Leg
         * @summary Create Leg Item
         * @param {string} legId
         * @param {CreateLegItemRequest} createLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegItemLegsLegIdItemsPost: function (legId, createLegItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('createLegItemLegsLegIdItemsPost', 'legId', legId);
                            // verify required parameter 'createLegItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createLegItemLegsLegIdItemsPost', 'createLegItemRequest', createLegItemRequest);
                            localVarPath = "/legs/{leg_id}/items"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLegItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Leg Note
         * @param {string} legId
         * @param {CreateLegNote} createLegNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegNoteLegsLegIdNotesPost: function (legId, createLegNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('createLegNoteLegsLegIdNotesPost', 'legId', legId);
                            // verify required parameter 'createLegNote' is not null or undefined
                            (0, common_1.assertParamExists)('createLegNoteLegsLegIdNotesPost', 'createLegNote', createLegNote);
                            localVarPath = "/legs/{leg_id}/notes"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLegNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new leg timeline event
         * @summary Create Leg Timeline Event
         * @param {string} legId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegTimelineEventLegsLegIdTimelineEventsPost: function (legId, createStageTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('createLegTimelineEventLegsLegIdTimelineEventsPost', 'legId', legId);
                            // verify required parameter 'createStageTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('createLegTimelineEventLegsLegIdTimelineEventsPost', 'createStageTimelineEvent', createStageTimelineEvent);
                            localVarPath = "/legs/{leg_id}/timeline-events"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createStageTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Tracking Point
         * @param {string} legId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackingPointLegsLegIdTrackingPost: function (legId, createTrackingPoint, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('createTrackingPointLegsLegIdTrackingPost', 'legId', legId);
                            // verify required parameter 'createTrackingPoint' is not null or undefined
                            (0, common_1.assertParamExists)('createTrackingPointLegsLegIdTrackingPost', 'createTrackingPoint', createTrackingPoint);
                            localVarPath = "/legs/{leg_id}/tracking"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTrackingPoint, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegNoteLegsLegIdNotesLegNoteIdDelete: function (legId, legNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLegNoteLegsLegIdNotesLegNoteIdDelete', 'legId', legId);
                            // verify required parameter 'legNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLegNoteLegsLegIdNotesLegNoteIdDelete', 'legNoteId', legNoteId);
                            localVarPath = "/legs/{leg_id}/notes/{leg_note_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_note_id", "}"), encodeURIComponent(String(legNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} legId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete: function (legId, timelineEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete', 'legId', legId);
                            // verify required parameter 'timelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete', 'timelineEventId', timelineEventId);
                            localVarPath = "/legs/{leg_id}/timeline-events/{timeline_event_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("timeline_event_id", "}"), encodeURIComponent(String(timelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Detail
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegDetailLegsLegIdGet: function (legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegDetailLegsLegIdGet', 'legId', legId);
                            localVarPath = "/legs/{leg_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNoteLegsLegIdNotesLegNoteIdGet: function (legId, legNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegNoteLegsLegIdNotesLegNoteIdGet', 'legId', legId);
                            // verify required parameter 'legNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegNoteLegsLegIdNotesLegNoteIdGet', 'legNoteId', legNoteId);
                            localVarPath = "/legs/{leg_id}/notes/{leg_note_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_note_id", "}"), encodeURIComponent(String(legNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Notes
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNotesLegsLegIdNotesGet: function (legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegNotesLegsLegIdNotesGet', 'legId', legId);
                            localVarPath = "/legs/{leg_id}/notes"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns leg timeline events
         * @summary Get Leg Timeline Events
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegTimelineEventsLegsLegIdTimelineEventsGet: function (legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegTimelineEventsLegsLegIdTimelineEventsGet', 'legId', legId);
                            localVarPath = "/legs/{leg_id}/timeline-events"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all Legs. You can filter by passing in query parameters e.g ``` /legs?transportation_mode=DRAYAGE ``` :param request: :return:
         * @summary Get Legs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsLegsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/legs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Tracking Points
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrackingPointsLegsLegIdTrackingGet: function (legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('listTrackingPointsLegsLegIdTrackingGet', 'legId', legId);
                            localVarPath = "/legs/{leg_id}/tracking"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Pin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinLegNoteLegsLegIdNotesLegNoteIdPinPost: function (legId, legNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('pinLegNoteLegsLegIdNotesLegNoteIdPinPost', 'legId', legId);
                            // verify required parameter 'legNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('pinLegNoteLegsLegIdNotesLegNoteIdPinPost', 'legNoteId', legNoteId);
                            localVarPath = "/legs/{leg_id}/notes/{leg_note_id}/pin"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_note_id", "}"), encodeURIComponent(String(legNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unpin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost: function (legId, legNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost', 'legId', legId);
                            // verify required parameter 'legNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost', 'legNoteId', legNoteId);
                            localVarPath = "/legs/{leg_id}/notes/{leg_note_id}/unpin"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_note_id", "}"), encodeURIComponent(String(legNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates an existing Leg Item
         * @summary Update Leg Item
         * @param {string} legId
         * @param {string} legItemId
         * @param {UpdateLegItemRequest} updateLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegItemLegsLegIdItemsLegItemIdPut: function (legId, legItemId, updateLegItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegItemLegsLegIdItemsLegItemIdPut', 'legId', legId);
                            // verify required parameter 'legItemId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegItemLegsLegIdItemsLegItemIdPut', 'legItemId', legItemId);
                            // verify required parameter 'updateLegItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegItemLegsLegIdItemsLegItemIdPut', 'updateLegItemRequest', updateLegItemRequest);
                            localVarPath = "/legs/{leg_id}/items/{leg_item_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_item_id", "}"), encodeURIComponent(String(legItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLegItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {UpdateLegNoteDetail} updateLegNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegNoteLegsLegIdNotesLegNoteIdPut: function (legId, legNoteId, updateLegNoteDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegNoteLegsLegIdNotesLegNoteIdPut', 'legId', legId);
                            // verify required parameter 'legNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegNoteLegsLegIdNotesLegNoteIdPut', 'legNoteId', legNoteId);
                            // verify required parameter 'updateLegNoteDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegNoteLegsLegIdNotesLegNoteIdPut', 'updateLegNoteDetail', updateLegNoteDetail);
                            localVarPath = "/legs/{leg_id}/notes/{leg_note_id}"
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("leg_note_id", "}"), encodeURIComponent(String(legNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLegNoteDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LegsApiAxiosParamCreator = LegsApiAxiosParamCreator;
/**
 * LegsApi - functional programming interface
 * @export
 */
var LegsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LegsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Associates an existing shipping item to a leg
         * @summary Assign Shipment Item
         * @param {string} legId
         * @param {AssignShipmentItem} assignShipmentItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignShipmentItemLegsLegIdItemsAssignPost: function (legId, assignShipmentItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.assignShipmentItemLegsLegIdItemsAssignPost(legId, assignShipmentItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new leg item for a Leg
         * @summary Create Leg Item
         * @param {string} legId
         * @param {CreateLegItemRequest} createLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegItemLegsLegIdItemsPost: function (legId, createLegItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLegItemLegsLegIdItemsPost(legId, createLegItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Leg Note
         * @param {string} legId
         * @param {CreateLegNote} createLegNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegNoteLegsLegIdNotesPost: function (legId, createLegNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLegNoteLegsLegIdNotesPost(legId, createLegNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new leg timeline event
         * @summary Create Leg Timeline Event
         * @param {string} legId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegTimelineEventLegsLegIdTimelineEventsPost: function (legId, createStageTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLegTimelineEventLegsLegIdTimelineEventsPost(legId, createStageTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Tracking Point
         * @param {string} legId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackingPointLegsLegIdTrackingPost: function (legId, createTrackingPoint, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTrackingPointLegsLegIdTrackingPost(legId, createTrackingPoint, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegNoteLegsLegIdNotesLegNoteIdDelete: function (legId, legNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLegNoteLegsLegIdNotesLegNoteIdDelete(legId, legNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} legId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete: function (legId, timelineEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete(legId, timelineEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Detail
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegDetailLegsLegIdGet: function (legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegDetailLegsLegIdGet(legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNoteLegsLegIdNotesLegNoteIdGet: function (legId, legNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegNoteLegsLegIdNotesLegNoteIdGet(legId, legNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Leg Notes
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNotesLegsLegIdNotesGet: function (legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegNotesLegsLegIdNotesGet(legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns leg timeline events
         * @summary Get Leg Timeline Events
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegTimelineEventsLegsLegIdTimelineEventsGet: function (legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegTimelineEventsLegsLegIdTimelineEventsGet(legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all Legs. You can filter by passing in query parameters e.g ``` /legs?transportation_mode=DRAYAGE ``` :param request: :return:
         * @summary Get Legs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsLegsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegsLegsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Tracking Points
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrackingPointsLegsLegIdTrackingGet: function (legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listTrackingPointsLegsLegIdTrackingGet(legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Pin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinLegNoteLegsLegIdNotesLegNoteIdPinPost: function (legId, legNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pinLegNoteLegsLegIdNotesLegNoteIdPinPost(legId, legNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unpin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost: function (legId, legNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost(legId, legNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates an existing Leg Item
         * @summary Update Leg Item
         * @param {string} legId
         * @param {string} legItemId
         * @param {UpdateLegItemRequest} updateLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegItemLegsLegIdItemsLegItemIdPut: function (legId, legItemId, updateLegItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLegItemLegsLegIdItemsLegItemIdPut(legId, legItemId, updateLegItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {UpdateLegNoteDetail} updateLegNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegNoteLegsLegIdNotesLegNoteIdPut: function (legId, legNoteId, updateLegNoteDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLegNoteLegsLegIdNotesLegNoteIdPut(legId, legNoteId, updateLegNoteDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LegsApiFp = LegsApiFp;
/**
 * LegsApi - factory interface
 * @export
 */
var LegsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LegsApiFp)(configuration);
    return {
        /**
         * Associates an existing shipping item to a leg
         * @summary Assign Shipment Item
         * @param {string} legId
         * @param {AssignShipmentItem} assignShipmentItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignShipmentItemLegsLegIdItemsAssignPost: function (legId, assignShipmentItem, options) {
            return localVarFp.assignShipmentItemLegsLegIdItemsAssignPost(legId, assignShipmentItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new leg item for a Leg
         * @summary Create Leg Item
         * @param {string} legId
         * @param {CreateLegItemRequest} createLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegItemLegsLegIdItemsPost: function (legId, createLegItemRequest, options) {
            return localVarFp.createLegItemLegsLegIdItemsPost(legId, createLegItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Leg Note
         * @param {string} legId
         * @param {CreateLegNote} createLegNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegNoteLegsLegIdNotesPost: function (legId, createLegNote, options) {
            return localVarFp.createLegNoteLegsLegIdNotesPost(legId, createLegNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new leg timeline event
         * @summary Create Leg Timeline Event
         * @param {string} legId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegTimelineEventLegsLegIdTimelineEventsPost: function (legId, createStageTimelineEvent, options) {
            return localVarFp.createLegTimelineEventLegsLegIdTimelineEventsPost(legId, createStageTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Tracking Point
         * @param {string} legId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackingPointLegsLegIdTrackingPost: function (legId, createTrackingPoint, options) {
            return localVarFp.createTrackingPointLegsLegIdTrackingPost(legId, createTrackingPoint, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegNoteLegsLegIdNotesLegNoteIdDelete: function (legId, legNoteId, options) {
            return localVarFp.deleteLegNoteLegsLegIdNotesLegNoteIdDelete(legId, legNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} legId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete: function (legId, timelineEventId, options) {
            return localVarFp.deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete(legId, timelineEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Leg Detail
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegDetailLegsLegIdGet: function (legId, options) {
            return localVarFp.getLegDetailLegsLegIdGet(legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNoteLegsLegIdNotesLegNoteIdGet: function (legId, legNoteId, options) {
            return localVarFp.getLegNoteLegsLegIdNotesLegNoteIdGet(legId, legNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Leg Notes
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegNotesLegsLegIdNotesGet: function (legId, options) {
            return localVarFp.getLegNotesLegsLegIdNotesGet(legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns leg timeline events
         * @summary Get Leg Timeline Events
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegTimelineEventsLegsLegIdTimelineEventsGet: function (legId, options) {
            return localVarFp.getLegTimelineEventsLegsLegIdTimelineEventsGet(legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all Legs. You can filter by passing in query parameters e.g ``` /legs?transportation_mode=DRAYAGE ``` :param request: :return:
         * @summary Get Legs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsLegsGet: function (options) {
            return localVarFp.getLegsLegsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Tracking Points
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrackingPointsLegsLegIdTrackingGet: function (legId, options) {
            return localVarFp.listTrackingPointsLegsLegIdTrackingGet(legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Pin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinLegNoteLegsLegIdNotesLegNoteIdPinPost: function (legId, legNoteId, options) {
            return localVarFp.pinLegNoteLegsLegIdNotesLegNoteIdPinPost(legId, legNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unpin Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost: function (legId, legNoteId, options) {
            return localVarFp.unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost(legId, legNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an existing Leg Item
         * @summary Update Leg Item
         * @param {string} legId
         * @param {string} legItemId
         * @param {UpdateLegItemRequest} updateLegItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegItemLegsLegIdItemsLegItemIdPut: function (legId, legItemId, updateLegItemRequest, options) {
            return localVarFp.updateLegItemLegsLegIdItemsLegItemIdPut(legId, legItemId, updateLegItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Leg Note
         * @param {string} legId
         * @param {string} legNoteId
         * @param {UpdateLegNoteDetail} updateLegNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegNoteLegsLegIdNotesLegNoteIdPut: function (legId, legNoteId, updateLegNoteDetail, options) {
            return localVarFp.updateLegNoteLegsLegIdNotesLegNoteIdPut(legId, legNoteId, updateLegNoteDetail, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LegsApiFactory = LegsApiFactory;
/**
 * LegsApi - object-oriented interface
 * @export
 * @class LegsApi
 * @extends {BaseAPI}
 */
var LegsApi = /** @class */ (function (_super) {
    __extends(LegsApi, _super);
    function LegsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Associates an existing shipping item to a leg
     * @summary Assign Shipment Item
     * @param {string} legId
     * @param {AssignShipmentItem} assignShipmentItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.assignShipmentItemLegsLegIdItemsAssignPost = function (legId, assignShipmentItem, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).assignShipmentItemLegsLegIdItemsAssignPost(legId, assignShipmentItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new leg item for a Leg
     * @summary Create Leg Item
     * @param {string} legId
     * @param {CreateLegItemRequest} createLegItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.createLegItemLegsLegIdItemsPost = function (legId, createLegItemRequest, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).createLegItemLegsLegIdItemsPost(legId, createLegItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Leg Note
     * @param {string} legId
     * @param {CreateLegNote} createLegNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.createLegNoteLegsLegIdNotesPost = function (legId, createLegNote, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).createLegNoteLegsLegIdNotesPost(legId, createLegNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new leg timeline event
     * @summary Create Leg Timeline Event
     * @param {string} legId
     * @param {CreateStageTimelineEvent} createStageTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.createLegTimelineEventLegsLegIdTimelineEventsPost = function (legId, createStageTimelineEvent, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).createLegTimelineEventLegsLegIdTimelineEventsPost(legId, createStageTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Tracking Point
     * @param {string} legId
     * @param {CreateTrackingPoint} createTrackingPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.createTrackingPointLegsLegIdTrackingPost = function (legId, createTrackingPoint, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).createTrackingPointLegsLegIdTrackingPost(legId, createTrackingPoint, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Leg Note
     * @param {string} legId
     * @param {string} legNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.deleteLegNoteLegsLegIdNotesLegNoteIdDelete = function (legId, legNoteId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).deleteLegNoteLegsLegIdNotesLegNoteIdDelete(legId, legNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Timeline Event
     * @param {string} legId
     * @param {string} timelineEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete = function (legId, timelineEventId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).deleteTimelineEventLegsLegIdTimelineEventsTimelineEventIdDelete(legId, timelineEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Leg Detail
     * @param {string} legId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.getLegDetailLegsLegIdGet = function (legId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).getLegDetailLegsLegIdGet(legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Leg Note
     * @param {string} legId
     * @param {string} legNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.getLegNoteLegsLegIdNotesLegNoteIdGet = function (legId, legNoteId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).getLegNoteLegsLegIdNotesLegNoteIdGet(legId, legNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Leg Notes
     * @param {string} legId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.getLegNotesLegsLegIdNotesGet = function (legId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).getLegNotesLegsLegIdNotesGet(legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns leg timeline events
     * @summary Get Leg Timeline Events
     * @param {string} legId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.getLegTimelineEventsLegsLegIdTimelineEventsGet = function (legId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).getLegTimelineEventsLegsLegIdTimelineEventsGet(legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all Legs. You can filter by passing in query parameters e.g ``` /legs?transportation_mode=DRAYAGE ``` :param request: :return:
     * @summary Get Legs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.getLegsLegsGet = function (options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).getLegsLegsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Tracking Points
     * @param {string} legId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.listTrackingPointsLegsLegIdTrackingGet = function (legId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).listTrackingPointsLegsLegIdTrackingGet(legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Pin Leg Note
     * @param {string} legId
     * @param {string} legNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.pinLegNoteLegsLegIdNotesLegNoteIdPinPost = function (legId, legNoteId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).pinLegNoteLegsLegIdNotesLegNoteIdPinPost(legId, legNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unpin Leg Note
     * @param {string} legId
     * @param {string} legNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost = function (legId, legNoteId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).unpinLegNoteLegsLegIdNotesLegNoteIdUnpinPost(legId, legNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an existing Leg Item
     * @summary Update Leg Item
     * @param {string} legId
     * @param {string} legItemId
     * @param {UpdateLegItemRequest} updateLegItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.updateLegItemLegsLegIdItemsLegItemIdPut = function (legId, legItemId, updateLegItemRequest, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).updateLegItemLegsLegIdItemsLegItemIdPut(legId, legItemId, updateLegItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Leg Note
     * @param {string} legId
     * @param {string} legNoteId
     * @param {UpdateLegNoteDetail} updateLegNoteDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.updateLegNoteLegsLegIdNotesLegNoteIdPut = function (legId, legNoteId, updateLegNoteDetail, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).updateLegNoteLegsLegIdNotesLegNoteIdPut(legId, legNoteId, updateLegNoteDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LegsApi;
}(base_1.BaseAPI));
exports.LegsApi = LegsApi;
/**
 * LegsDrayageApi - axios parameter creator
 * @export
 */
var LegsDrayageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Cancel Drayage Booking
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/cancel"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} drayageBookingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsLegsDrayageDrayageBookingIdContactsPost: function (drayageBookingId, createContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('createContactsLegsDrayageDrayageBookingIdContactsPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'createContact' is not null or undefined
                            (0, common_1.assertParamExists)('createContactsLegsDrayageDrayageBookingIdContactsPost', 'createContact', createContact);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/contacts"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a DrayageBooking.
         * @summary Create Drayage Booking
         * @param {CreateDrayageBooking} createDrayageBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageBookingLegsDrayagePost: function (createDrayageBooking, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createDrayageBooking' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageBookingLegsDrayagePost', 'createDrayageBooking', createDrayageBooking);
                            localVarPath = "/legs/drayage";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDrayageBooking, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Transportation Order From Mulitple Legs
         * @param {CreateDrayageTransportationOrderFromMultipleLegs} createDrayageTransportationOrderFromMultipleLegs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost: function (createDrayageTransportationOrderFromMultipleLegs, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createDrayageTransportationOrderFromMultipleLegs' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost', 'createDrayageTransportationOrderFromMultipleLegs', createDrayageTransportationOrderFromMultipleLegs);
                            localVarPath = "/legs/drayage/transportation-order";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDrayageTransportationOrderFromMultipleLegs, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Transportation Order
         * @param {string} drayageBookingId
         * @param {CreateDrayageTransportationOrderFromLegRequest} createDrayageTransportationOrderFromLegRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost: function (drayageBookingId, createDrayageTransportationOrderFromLegRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'createDrayageTransportationOrderFromLegRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost', 'createDrayageTransportationOrderFromLegRequest', createDrayageTransportationOrderFromLegRequest);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/transportation-order"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDrayageTransportationOrderFromLegRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Driver
         * @param {string} drayageBookingId
         * @param {CreateDriver} createDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverLegsDrayageDrayageBookingIdDriversPost: function (drayageBookingId, createDriver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('createDriverLegsDrayageDrayageBookingIdDriversPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'createDriver' is not null or undefined
                            (0, common_1.assertParamExists)('createDriverLegsDrayageDrayageBookingIdDriversPost', 'createDriver', createDriver);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/drivers"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDriver, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Equipment
         * @param {string} drayageBookingId
         * @param {CreateEquipment} createEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipmentLegsDrayageDrayageBookingIdEquipmentPost: function (drayageBookingId, createEquipment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('createEquipmentLegsDrayageDrayageBookingIdEquipmentPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'createEquipment' is not null or undefined
                            (0, common_1.assertParamExists)('createEquipmentLegsDrayageDrayageBookingIdEquipmentPost', 'createEquipment', createEquipment);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/equipment"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createEquipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete: function (drayageBookingId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/documents/{document_id}"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Booking Detail
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageBookingDetailLegsDrayageDrayageBookingIdGet: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageBookingDetailLegsDrayageDrayageBookingIdGet', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Use GET /legs?transportation_mode=DRAYAGE instead
         * @summary Get Drayage Booking List
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDrayageBookingListLegsDrayageGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/legs/drayage";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/contacts"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/documents"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Order List
         * @param {string} drayageBookingId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet: function (drayageBookingId, skip, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/orders"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status At Delivery
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/at-delivery"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status At Pickup
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/at-pickup"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Container Returned
         * @param {string} drayageBookingId
         * @param {ContainerReturnRequest} containerReturnRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost: function (drayageBookingId, containerReturnRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'containerReturnRequest' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost', 'containerReturnRequest', containerReturnRequest);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/container-returned"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(containerReturnRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Delivered
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/delivered"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Dispatched
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/dispatched"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status In Transit
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/in-transit"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Reset
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost: function (drayageBookingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost', 'drayageBookingId', drayageBookingId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/execution-statuses/reset"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Arrive
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopArriveRequest} stopArriveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost: function (drayageBookingId, sequenceId, stopArriveRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost', 'sequenceId', sequenceId);
                            // verify required parameter 'stopArriveRequest' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost', 'stopArriveRequest', stopArriveRequest);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops/{sequence_id}/execution-statuses/arrive"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopArriveRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Depart
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopDepartRequest} stopDepartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost: function (drayageBookingId, sequenceId, stopDepartRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost', 'sequenceId', sequenceId);
                            // verify required parameter 'stopDepartRequest' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost', 'stopDepartRequest', stopDepartRequest);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops/{sequence_id}/execution-statuses/depart"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopDepartRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status En Route
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost: function (drayageBookingId, sequenceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost', 'sequenceId', sequenceId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops/{sequence_id}/execution-statuses/en-route"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Reset
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost: function (drayageBookingId, sequenceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost', 'sequenceId', sequenceId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops/{sequence_id}/execution-statuses/reset"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Accessorials
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingAccessorials} updateDrayageBookingAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut: function (drayageBookingId, updateDrayageBookingAccessorials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateDrayageBookingAccessorials' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut', 'updateDrayageBookingAccessorials', updateDrayageBookingAccessorials);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/accessorials"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDrayageBookingAccessorials, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Drivers
         * @param {string} drayageBookingId
         * @param {Array<UpdateDriver>} updateDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut: function (drayageBookingId, updateDriver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateDriver' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut', 'updateDriver', updateDriver);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/drivers"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDriver, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Equipment
         * @param {string} drayageBookingId
         * @param {Array<UpdateEquipment>} updateEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut: function (drayageBookingId, updateEquipment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateEquipment' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut', 'updateEquipment', updateEquipment);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/equipment"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEquipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking References
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingReferences} updateDrayageBookingReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut: function (drayageBookingId, updateDrayageBookingReferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateDrayageBookingReferences' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut', 'updateDrayageBookingReferences', updateDrayageBookingReferences);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/references"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDrayageBookingReferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Stops
         * @param {string} drayageBookingId
         * @param {UpdateRunningStopsRequest} updateRunningStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut: function (drayageBookingId, updateRunningStopsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateRunningStopsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut', 'updateRunningStopsRequest', updateRunningStopsRequest);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateRunningStopsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Summary
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingSummary} updateDrayageBookingSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut: function (drayageBookingId, updateDrayageBookingSummary, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateDrayageBookingSummary' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut', 'updateDrayageBookingSummary', updateDrayageBookingSummary);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/summary"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDrayageBookingSummary, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Bookings Stops Detail
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {UpdateRunningStop} updateRunningStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut: function (drayageBookingId, sequenceId, updateRunningStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut', 'sequenceId', sequenceId);
                            // verify required parameter 'updateRunningStop' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut', 'updateRunningStop', updateRunningStop);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/stops/{sequence_id}"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateRunningStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {Array<UpdateContact>} updateContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut: function (drayageBookingId, updateContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'updateContact' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut', 'updateContact', updateContact);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/contacts"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut: function (drayageBookingId, documentId, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut', 'documentId', documentId);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/documents/{document_id}"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new URLSearchParams();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.set('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.set('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams.toString();
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost: function (drayageBookingId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'drayageBookingId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost', 'drayageBookingId', drayageBookingId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost', 'file', file);
                            localVarPath = "/legs/drayage/{drayage_booking_id}/documents"
                                .replace("{".concat("drayage_booking_id", "}"), encodeURIComponent(String(drayageBookingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LegsDrayageApiAxiosParamCreator = LegsDrayageApiAxiosParamCreator;
/**
 * LegsDrayageApi - functional programming interface
 * @export
 */
var LegsDrayageApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LegsDrayageApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Cancel Drayage Booking
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} drayageBookingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsLegsDrayageDrayageBookingIdContactsPost: function (drayageBookingId, createContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createContactsLegsDrayageDrayageBookingIdContactsPost(drayageBookingId, createContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a DrayageBooking.
         * @summary Create Drayage Booking
         * @param {CreateDrayageBooking} createDrayageBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageBookingLegsDrayagePost: function (createDrayageBooking, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageBookingLegsDrayagePost(createDrayageBooking, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Transportation Order From Mulitple Legs
         * @param {CreateDrayageTransportationOrderFromMultipleLegs} createDrayageTransportationOrderFromMultipleLegs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost: function (createDrayageTransportationOrderFromMultipleLegs, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost(createDrayageTransportationOrderFromMultipleLegs, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Transportation Order
         * @param {string} drayageBookingId
         * @param {CreateDrayageTransportationOrderFromLegRequest} createDrayageTransportationOrderFromLegRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost: function (drayageBookingId, createDrayageTransportationOrderFromLegRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost(drayageBookingId, createDrayageTransportationOrderFromLegRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Driver
         * @param {string} drayageBookingId
         * @param {CreateDriver} createDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverLegsDrayageDrayageBookingIdDriversPost: function (drayageBookingId, createDriver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDriverLegsDrayageDrayageBookingIdDriversPost(drayageBookingId, createDriver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Equipment
         * @param {string} drayageBookingId
         * @param {CreateEquipment} createEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipmentLegsDrayageDrayageBookingIdEquipmentPost: function (drayageBookingId, createEquipment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createEquipmentLegsDrayageDrayageBookingIdEquipmentPost(drayageBookingId, createEquipment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete: function (drayageBookingId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete(drayageBookingId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Booking Detail
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageBookingDetailLegsDrayageDrayageBookingIdGet: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageBookingDetailLegsDrayageDrayageBookingIdGet(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Use GET /legs?transportation_mode=DRAYAGE instead
         * @summary Get Drayage Booking List
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDrayageBookingListLegsDrayageGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageBookingListLegsDrayageGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Drayage Leg Order List
         * @param {string} drayageBookingId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet: function (drayageBookingId, skip, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet(drayageBookingId, skip, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status At Delivery
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status At Pickup
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Container Returned
         * @param {string} drayageBookingId
         * @param {ContainerReturnRequest} containerReturnRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost: function (drayageBookingId, containerReturnRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost(drayageBookingId, containerReturnRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Delivered
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Dispatched
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status In Transit
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Leg Execution Status Reset
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost: function (drayageBookingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost(drayageBookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Arrive
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopArriveRequest} stopArriveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost: function (drayageBookingId, sequenceId, stopArriveRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost(drayageBookingId, sequenceId, stopArriveRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Depart
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopDepartRequest} stopDepartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost: function (drayageBookingId, sequenceId, stopDepartRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost(drayageBookingId, sequenceId, stopDepartRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status En Route
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost: function (drayageBookingId, sequenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost(drayageBookingId, sequenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop Execution Status Reset
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost: function (drayageBookingId, sequenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost(drayageBookingId, sequenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Accessorials
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingAccessorials} updateDrayageBookingAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut: function (drayageBookingId, updateDrayageBookingAccessorials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut(drayageBookingId, updateDrayageBookingAccessorials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Drivers
         * @param {string} drayageBookingId
         * @param {Array<UpdateDriver>} updateDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut: function (drayageBookingId, updateDriver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut(drayageBookingId, updateDriver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Equipment
         * @param {string} drayageBookingId
         * @param {Array<UpdateEquipment>} updateEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut: function (drayageBookingId, updateEquipment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut(drayageBookingId, updateEquipment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking References
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingReferences} updateDrayageBookingReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut: function (drayageBookingId, updateDrayageBookingReferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut(drayageBookingId, updateDrayageBookingReferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Stops
         * @param {string} drayageBookingId
         * @param {UpdateRunningStopsRequest} updateRunningStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut: function (drayageBookingId, updateRunningStopsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut(drayageBookingId, updateRunningStopsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Booking Summary
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingSummary} updateDrayageBookingSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut: function (drayageBookingId, updateDrayageBookingSummary, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut(drayageBookingId, updateDrayageBookingSummary, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Bookings Stops Detail
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {UpdateRunningStop} updateRunningStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut: function (drayageBookingId, sequenceId, updateRunningStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut(drayageBookingId, sequenceId, updateRunningStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {Array<UpdateContact>} updateContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut: function (drayageBookingId, updateContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut(drayageBookingId, updateContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut: function (drayageBookingId, documentId, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut(drayageBookingId, documentId, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost: function (drayageBookingId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost(drayageBookingId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LegsDrayageApiFp = LegsDrayageApiFp;
/**
 * LegsDrayageApi - factory interface
 * @export
 */
var LegsDrayageApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LegsDrayageApiFp)(configuration);
    return {
        /**
         *
         * @summary Cancel Drayage Booking
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost: function (drayageBookingId, options) {
            return localVarFp.cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} drayageBookingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsLegsDrayageDrayageBookingIdContactsPost: function (drayageBookingId, createContact, options) {
            return localVarFp.createContactsLegsDrayageDrayageBookingIdContactsPost(drayageBookingId, createContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a DrayageBooking.
         * @summary Create Drayage Booking
         * @param {CreateDrayageBooking} createDrayageBooking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageBookingLegsDrayagePost: function (createDrayageBooking, options) {
            return localVarFp.createDrayageBookingLegsDrayagePost(createDrayageBooking, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Drayage Transportation Order From Mulitple Legs
         * @param {CreateDrayageTransportationOrderFromMultipleLegs} createDrayageTransportationOrderFromMultipleLegs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost: function (createDrayageTransportationOrderFromMultipleLegs, options) {
            return localVarFp.createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost(createDrayageTransportationOrderFromMultipleLegs, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Drayage Transportation Order
         * @param {string} drayageBookingId
         * @param {CreateDrayageTransportationOrderFromLegRequest} createDrayageTransportationOrderFromLegRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost: function (drayageBookingId, createDrayageTransportationOrderFromLegRequest, options) {
            return localVarFp.createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost(drayageBookingId, createDrayageTransportationOrderFromLegRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Driver
         * @param {string} drayageBookingId
         * @param {CreateDriver} createDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverLegsDrayageDrayageBookingIdDriversPost: function (drayageBookingId, createDriver, options) {
            return localVarFp.createDriverLegsDrayageDrayageBookingIdDriversPost(drayageBookingId, createDriver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Equipment
         * @param {string} drayageBookingId
         * @param {CreateEquipment} createEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEquipmentLegsDrayageDrayageBookingIdEquipmentPost: function (drayageBookingId, createEquipment, options) {
            return localVarFp.createEquipmentLegsDrayageDrayageBookingIdEquipmentPost(drayageBookingId, createEquipment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete: function (drayageBookingId, documentId, options) {
            return localVarFp.deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete(drayageBookingId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Drayage Booking Detail
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageBookingDetailLegsDrayageDrayageBookingIdGet: function (drayageBookingId, options) {
            return localVarFp.getDrayageBookingDetailLegsDrayageDrayageBookingIdGet(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Use GET /legs?transportation_mode=DRAYAGE instead
         * @summary Get Drayage Booking List
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getDrayageBookingListLegsDrayageGet: function (options) {
            return localVarFp.getDrayageBookingListLegsDrayageGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet: function (drayageBookingId, options) {
            return localVarFp.getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet: function (drayageBookingId, options) {
            return localVarFp.getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Drayage Leg Order List
         * @param {string} drayageBookingId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet: function (drayageBookingId, skip, limit, sort, options) {
            return localVarFp.getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet(drayageBookingId, skip, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status At Delivery
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status At Pickup
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status Container Returned
         * @param {string} drayageBookingId
         * @param {ContainerReturnRequest} containerReturnRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost: function (drayageBookingId, containerReturnRequest, options) {
            return localVarFp.legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost(drayageBookingId, containerReturnRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status Delivered
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status Dispatched
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status In Transit
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Leg Execution Status Reset
         * @param {string} drayageBookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost: function (drayageBookingId, options) {
            return localVarFp.legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost(drayageBookingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Stop Execution Status Arrive
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopArriveRequest} stopArriveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost: function (drayageBookingId, sequenceId, stopArriveRequest, options) {
            return localVarFp.stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost(drayageBookingId, sequenceId, stopArriveRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Stop Execution Status Depart
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {StopDepartRequest} stopDepartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost: function (drayageBookingId, sequenceId, stopDepartRequest, options) {
            return localVarFp.stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost(drayageBookingId, sequenceId, stopDepartRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Stop Execution Status En Route
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost: function (drayageBookingId, sequenceId, options) {
            return localVarFp.stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost(drayageBookingId, sequenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Stop Execution Status Reset
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost: function (drayageBookingId, sequenceId, options) {
            return localVarFp.stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost(drayageBookingId, sequenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking Accessorials
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingAccessorials} updateDrayageBookingAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut: function (drayageBookingId, updateDrayageBookingAccessorials, options) {
            return localVarFp.updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut(drayageBookingId, updateDrayageBookingAccessorials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking Drivers
         * @param {string} drayageBookingId
         * @param {Array<UpdateDriver>} updateDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut: function (drayageBookingId, updateDriver, options) {
            return localVarFp.updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut(drayageBookingId, updateDriver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking Equipment
         * @param {string} drayageBookingId
         * @param {Array<UpdateEquipment>} updateEquipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut: function (drayageBookingId, updateEquipment, options) {
            return localVarFp.updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut(drayageBookingId, updateEquipment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking References
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingReferences} updateDrayageBookingReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut: function (drayageBookingId, updateDrayageBookingReferences, options) {
            return localVarFp.updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut(drayageBookingId, updateDrayageBookingReferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking Stops
         * @param {string} drayageBookingId
         * @param {UpdateRunningStopsRequest} updateRunningStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut: function (drayageBookingId, updateRunningStopsRequest, options) {
            return localVarFp.updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut(drayageBookingId, updateRunningStopsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Booking Summary
         * @param {string} drayageBookingId
         * @param {UpdateDrayageBookingSummary} updateDrayageBookingSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut: function (drayageBookingId, updateDrayageBookingSummary, options) {
            return localVarFp.updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut(drayageBookingId, updateDrayageBookingSummary, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Bookings Stops Detail
         * @param {string} drayageBookingId
         * @param {number} sequenceId
         * @param {UpdateRunningStop} updateRunningStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut: function (drayageBookingId, sequenceId, updateRunningStop, options) {
            return localVarFp.updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut(drayageBookingId, sequenceId, updateRunningStop, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Leg Contacts
         * @param {string} drayageBookingId
         * @param {Array<UpdateContact>} updateContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut: function (drayageBookingId, updateContact, options) {
            return localVarFp.updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut(drayageBookingId, updateContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Drayage Leg Document
         * @param {string} drayageBookingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut: function (drayageBookingId, documentId, description, type, options) {
            return localVarFp.updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut(drayageBookingId, documentId, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload Drayage Leg Documents
         * @param {string} drayageBookingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost: function (drayageBookingId, file, description, type, options) {
            return localVarFp.uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost(drayageBookingId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LegsDrayageApiFactory = LegsDrayageApiFactory;
/**
 * LegsDrayageApi - object-oriented interface
 * @export
 * @class LegsDrayageApi
 * @extends {BaseAPI}
 */
var LegsDrayageApi = /** @class */ (function (_super) {
    __extends(LegsDrayageApi, _super);
    function LegsDrayageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Cancel Drayage Booking
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).cancelDrayageBookingLegsDrayageDrayageBookingIdCancelPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Contacts
     * @param {string} drayageBookingId
     * @param {CreateContact} createContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createContactsLegsDrayageDrayageBookingIdContactsPost = function (drayageBookingId, createContact, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createContactsLegsDrayageDrayageBookingIdContactsPost(drayageBookingId, createContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a DrayageBooking.
     * @summary Create Drayage Booking
     * @param {CreateDrayageBooking} createDrayageBooking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createDrayageBookingLegsDrayagePost = function (createDrayageBooking, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createDrayageBookingLegsDrayagePost(createDrayageBooking, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Drayage Transportation Order From Mulitple Legs
     * @param {CreateDrayageTransportationOrderFromMultipleLegs} createDrayageTransportationOrderFromMultipleLegs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost = function (createDrayageTransportationOrderFromMultipleLegs, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createDrayageTransportationOrderFromMulitpleLegsLegsDrayageTransportationOrderPost(createDrayageTransportationOrderFromMultipleLegs, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Drayage Transportation Order
     * @param {string} drayageBookingId
     * @param {CreateDrayageTransportationOrderFromLegRequest} createDrayageTransportationOrderFromLegRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost = function (drayageBookingId, createDrayageTransportationOrderFromLegRequest, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createDrayageTransportationOrderLegsDrayageDrayageBookingIdTransportationOrderPost(drayageBookingId, createDrayageTransportationOrderFromLegRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Driver
     * @param {string} drayageBookingId
     * @param {CreateDriver} createDriver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createDriverLegsDrayageDrayageBookingIdDriversPost = function (drayageBookingId, createDriver, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createDriverLegsDrayageDrayageBookingIdDriversPost(drayageBookingId, createDriver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Equipment
     * @param {string} drayageBookingId
     * @param {CreateEquipment} createEquipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.createEquipmentLegsDrayageDrayageBookingIdEquipmentPost = function (drayageBookingId, createEquipment, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).createEquipmentLegsDrayageDrayageBookingIdEquipmentPost(drayageBookingId, createEquipment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Drayage Leg Document
     * @param {string} drayageBookingId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete = function (drayageBookingId, documentId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).deleteDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdDelete(drayageBookingId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Drayage Booking Detail
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.getDrayageBookingDetailLegsDrayageDrayageBookingIdGet = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).getDrayageBookingDetailLegsDrayageDrayageBookingIdGet(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Use GET /legs?transportation_mode=DRAYAGE instead
     * @summary Get Drayage Booking List
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.getDrayageBookingListLegsDrayageGet = function (options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).getDrayageBookingListLegsDrayageGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Drayage Leg Contacts
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).getDrayageLegContactsLegsDrayageDrayageBookingIdContactsGet(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Drayage Leg Documents
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).getDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsGet(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Drayage Leg Order List
     * @param {string} drayageBookingId
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet = function (drayageBookingId, skip, limit, sort, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).getDrayageLegOrderListLegsDrayageDrayageBookingIdOrdersGet(drayageBookingId, skip, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status At Delivery
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusAtDeliveryLegsDrayageDrayageBookingIdExecutionStatusesAtDeliveryPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status At Pickup
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusAtPickupLegsDrayageDrayageBookingIdExecutionStatusesAtPickupPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status Container Returned
     * @param {string} drayageBookingId
     * @param {ContainerReturnRequest} containerReturnRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost = function (drayageBookingId, containerReturnRequest, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusContainerReturnedLegsDrayageDrayageBookingIdExecutionStatusesContainerReturnedPost(drayageBookingId, containerReturnRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status Delivered
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusDeliveredLegsDrayageDrayageBookingIdExecutionStatusesDeliveredPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status Dispatched
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusDispatchedLegsDrayageDrayageBookingIdExecutionStatusesDispatchedPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status In Transit
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusInTransitLegsDrayageDrayageBookingIdExecutionStatusesInTransitPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Leg Execution Status Reset
     * @param {string} drayageBookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost = function (drayageBookingId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).legExecutionStatusResetLegsDrayageDrayageBookingIdExecutionStatusesResetPost(drayageBookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Stop Execution Status Arrive
     * @param {string} drayageBookingId
     * @param {number} sequenceId
     * @param {StopArriveRequest} stopArriveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost = function (drayageBookingId, sequenceId, stopArriveRequest, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).stopExecutionStatusArriveLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesArrivePost(drayageBookingId, sequenceId, stopArriveRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Stop Execution Status Depart
     * @param {string} drayageBookingId
     * @param {number} sequenceId
     * @param {StopDepartRequest} stopDepartRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost = function (drayageBookingId, sequenceId, stopDepartRequest, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).stopExecutionStatusDepartLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesDepartPost(drayageBookingId, sequenceId, stopDepartRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Stop Execution Status En Route
     * @param {string} drayageBookingId
     * @param {number} sequenceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost = function (drayageBookingId, sequenceId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).stopExecutionStatusEnRouteLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesEnRoutePost(drayageBookingId, sequenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Stop Execution Status Reset
     * @param {string} drayageBookingId
     * @param {number} sequenceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost = function (drayageBookingId, sequenceId, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).stopExecutionStatusResetLegsDrayageDrayageBookingIdStopsSequenceIdExecutionStatusesResetPost(drayageBookingId, sequenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking Accessorials
     * @param {string} drayageBookingId
     * @param {UpdateDrayageBookingAccessorials} updateDrayageBookingAccessorials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut = function (drayageBookingId, updateDrayageBookingAccessorials, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingAccessorialsLegsDrayageDrayageBookingIdAccessorialsPut(drayageBookingId, updateDrayageBookingAccessorials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking Drivers
     * @param {string} drayageBookingId
     * @param {Array<UpdateDriver>} updateDriver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut = function (drayageBookingId, updateDriver, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingDriversLegsDrayageDrayageBookingIdDriversPut(drayageBookingId, updateDriver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking Equipment
     * @param {string} drayageBookingId
     * @param {Array<UpdateEquipment>} updateEquipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut = function (drayageBookingId, updateEquipment, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingEquipmentLegsDrayageDrayageBookingIdEquipmentPut(drayageBookingId, updateEquipment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking References
     * @param {string} drayageBookingId
     * @param {UpdateDrayageBookingReferences} updateDrayageBookingReferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut = function (drayageBookingId, updateDrayageBookingReferences, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingReferencesLegsDrayageDrayageBookingIdReferencesPut(drayageBookingId, updateDrayageBookingReferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking Stops
     * @param {string} drayageBookingId
     * @param {UpdateRunningStopsRequest} updateRunningStopsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut = function (drayageBookingId, updateRunningStopsRequest, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingStopsLegsDrayageDrayageBookingIdStopsPut(drayageBookingId, updateRunningStopsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Booking Summary
     * @param {string} drayageBookingId
     * @param {UpdateDrayageBookingSummary} updateDrayageBookingSummary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut = function (drayageBookingId, updateDrayageBookingSummary, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingSummaryLegsDrayageDrayageBookingIdSummaryPut(drayageBookingId, updateDrayageBookingSummary, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Bookings Stops Detail
     * @param {string} drayageBookingId
     * @param {number} sequenceId
     * @param {UpdateRunningStop} updateRunningStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut = function (drayageBookingId, sequenceId, updateRunningStop, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageBookingsStopsDetailLegsDrayageDrayageBookingIdStopsSequenceIdPut(drayageBookingId, sequenceId, updateRunningStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Leg Contacts
     * @param {string} drayageBookingId
     * @param {Array<UpdateContact>} updateContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut = function (drayageBookingId, updateContact, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageLegContactsLegsDrayageDrayageBookingIdContactsPut(drayageBookingId, updateContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Drayage Leg Document
     * @param {string} drayageBookingId
     * @param {string} documentId
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut = function (drayageBookingId, documentId, description, type, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).updateDrayageLegDocumentLegsDrayageDrayageBookingIdDocumentsDocumentIdPut(drayageBookingId, documentId, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload Drayage Leg Documents
     * @param {string} drayageBookingId
     * @param {any} file
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsDrayageApi
     */
    LegsDrayageApi.prototype.uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost = function (drayageBookingId, file, description, type, options) {
        var _this = this;
        return (0, exports.LegsDrayageApiFp)(this.configuration).uploadDrayageLegDocumentsLegsDrayageDrayageBookingIdDocumentsPost(drayageBookingId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LegsDrayageApi;
}(base_1.BaseAPI));
exports.LegsDrayageApi = LegsDrayageApi;
/**
 * LegsFTLAlphaApi - axios parameter creator
 * @export
 */
var LegsFTLAlphaApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates an FTL Leg.
         * @summary Create Leg
         * @param {CreateFtlLeg} createFtlLeg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegLegsFtlPost: function (createFtlLeg, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFtlLeg' is not null or undefined
                            (0, common_1.assertParamExists)('createLegLegsFtlPost', 'createFtlLeg', createFtlLeg);
                            localVarPath = "/legs/ftl";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFtlLeg, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LegsFTLAlphaApiAxiosParamCreator = LegsFTLAlphaApiAxiosParamCreator;
/**
 * LegsFTLAlphaApi - functional programming interface
 * @export
 */
var LegsFTLAlphaApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LegsFTLAlphaApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates an FTL Leg.
         * @summary Create Leg
         * @param {CreateFtlLeg} createFtlLeg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegLegsFtlPost: function (createFtlLeg, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLegLegsFtlPost(createFtlLeg, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LegsFTLAlphaApiFp = LegsFTLAlphaApiFp;
/**
 * LegsFTLAlphaApi - factory interface
 * @export
 */
var LegsFTLAlphaApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LegsFTLAlphaApiFp)(configuration);
    return {
        /**
         * Creates an FTL Leg.
         * @summary Create Leg
         * @param {CreateFtlLeg} createFtlLeg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegLegsFtlPost: function (createFtlLeg, options) {
            return localVarFp.createLegLegsFtlPost(createFtlLeg, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LegsFTLAlphaApiFactory = LegsFTLAlphaApiFactory;
/**
 * LegsFTLAlphaApi - object-oriented interface
 * @export
 * @class LegsFTLAlphaApi
 * @extends {BaseAPI}
 */
var LegsFTLAlphaApi = /** @class */ (function (_super) {
    __extends(LegsFTLAlphaApi, _super);
    function LegsFTLAlphaApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates an FTL Leg.
     * @summary Create Leg
     * @param {CreateFtlLeg} createFtlLeg
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsFTLAlphaApi
     */
    LegsFTLAlphaApi.prototype.createLegLegsFtlPost = function (createFtlLeg, options) {
        var _this = this;
        return (0, exports.LegsFTLAlphaApiFp)(this.configuration).createLegLegsFtlPost(createFtlLeg, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LegsFTLAlphaApi;
}(base_1.BaseAPI));
exports.LegsFTLAlphaApi = LegsFTLAlphaApi;
/**
 * OrdersApi - axios parameter creator
 * @export
 */
var OrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Bulk Load Orders
         * @param {Array<BulkLoadOrderOperation>} bulkLoadOrderOperation
         * @param {boolean} [validateOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkLoadOrders: function (bulkLoadOrderOperation, validateOnly, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bulkLoadOrderOperation' is not null or undefined
                            (0, common_1.assertParamExists)('bulkLoadOrders', 'bulkLoadOrderOperation', bulkLoadOrderOperation);
                            localVarPath = "/orders/bulk-load";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (validateOnly !== undefined) {
                                localVarQueryParameter['validate_only'] = validateOnly;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkLoadOrderOperation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrders: function (createPurchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPurchaseOrder' is not null or undefined
                            (0, common_1.assertParamExists)('createOrders', 'createPurchaseOrder', createPurchaseOrder);
                            localVarPath = "/orders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPurchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Orders
         * @param {Array<ProductOrderStatus>} [status]
         * @param {Array<string>} [orderNumber]
         * @param {Array<string>} [supplierName]
         * @param {Array<string>} [customerName]
         * @param {Array<string>} [shipFromAddress]
         * @param {Array<string>} [shipFromCompanyName]
         * @param {Array<string>} [shipFromRegion]
         * @param {Array<string>} [shipToAddress]
         * @param {Array<string>} [shipToCompanyName]
         * @param {Array<string>} [shipToRegion]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {string} [idIn]
         * @param {string} [statusIn]
         * @param {string} [orderNumberContains]
         * @param {string} [orderNumberIcontains]
         * @param {string} [orderNumberIn]
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIn]
         * @param {string} [createdAt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLte]
         * @param {string} [references]
         * @param {string} [referencesContains]
         * @param {string} [referencesIcontains]
         * @param {string} [referencesIn]
         * @param {string} [referencesPurchaseOrderNumber]
         * @param {string} [referencesPurchaseOrderNumberContains]
         * @param {string} [referencesPurchaseOrderNumberIcontains]
         * @param {string} [referencesPurchaseOrderNumberIn]
         * @param {string} [purchaseOrderNumber]
         * @param {string} [purchaseOrderNumberContains]
         * @param {string} [purchaseOrderNumberIcontains]
         * @param {string} [purchaseOrderNumberIn]
         * @param {string} [shipToCompanyNameContains]
         * @param {string} [shipToCompanyNameIcontains]
         * @param {string} [shipToCompanyNameIn]
         * @param {string} [shipToRegionContains]
         * @param {string} [shipToRegionIcontains]
         * @param {string} [shipToRegionIn]
         * @param {string} [shipToPlanWindowStartGte]
         * @param {string} [shipToPlanWindowStartLte]
         * @param {string} [shipToPlanWindowEndGte]
         * @param {string} [shipToPlanWindowEndLte]
         * @param {string} [shipToAddressIcontains]
         * @param {string} [shipFromCompanyNameContains]
         * @param {string} [shipFromCompanyNameIcontains]
         * @param {string} [shipFromCompanyNameIn]
         * @param {string} [shipFromRegionContains]
         * @param {string} [shipFromRegionIcontains]
         * @param {string} [shipFromRegionIn]
         * @param {string} [shipFromPlanWindowStartGte]
         * @param {string} [shipFromPlanWindowStartLte]
         * @param {string} [shipFromPlanWindowEndGte]
         * @param {string} [shipFromPlanWindowEndLte]
         * @param {string} [shipFromAddressIcontains]
         * @param {string} [supplierNameContains]
         * @param {string} [supplierNameIcontains]
         * @param {string} [supplierNameIn]
         * @param {string} [customerNameContains]
         * @param {string} [customerNameIcontains]
         * @param {string} [customerNameIn]
         * @param {string} [releasesReleasedOntoShipmentId]
         * @param {string} [releasesReleasedOntoShipmentIdContains]
         * @param {string} [releasesReleasedOntoShipmentIdIcontains]
         * @param {string} [releasesReleasedOntoShipmentIdIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: function (status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/orders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (orderNumber) {
                                localVarQueryParameter['order_number'] = orderNumber;
                            }
                            if (supplierName) {
                                localVarQueryParameter['supplier__name'] = supplierName;
                            }
                            if (customerName) {
                                localVarQueryParameter['customer__name'] = customerName;
                            }
                            if (shipFromAddress) {
                                localVarQueryParameter['ship_from__address'] = shipFromAddress;
                            }
                            if (shipFromCompanyName) {
                                localVarQueryParameter['ship_from__company_name'] = shipFromCompanyName;
                            }
                            if (shipFromRegion) {
                                localVarQueryParameter['ship_from__region'] = shipFromRegion;
                            }
                            if (shipToAddress) {
                                localVarQueryParameter['ship_to__address'] = shipToAddress;
                            }
                            if (shipToCompanyName) {
                                localVarQueryParameter['ship_to__company_name'] = shipToCompanyName;
                            }
                            if (shipToRegion) {
                                localVarQueryParameter['ship_to__region'] = shipToRegion;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (idIn !== undefined) {
                                localVarQueryParameter['id__in'] = idIn;
                            }
                            if (statusIn !== undefined) {
                                localVarQueryParameter['status__in'] = statusIn;
                            }
                            if (orderNumberContains !== undefined) {
                                localVarQueryParameter['order_number__contains'] = orderNumberContains;
                            }
                            if (orderNumberIcontains !== undefined) {
                                localVarQueryParameter['order_number__icontains'] = orderNumberIcontains;
                            }
                            if (orderNumberIn !== undefined) {
                                localVarQueryParameter['order_number__in'] = orderNumberIn;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (nameIcontains !== undefined) {
                                localVarQueryParameter['name__icontains'] = nameIcontains;
                            }
                            if (nameIn !== undefined) {
                                localVarQueryParameter['name__in'] = nameIn;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (references !== undefined) {
                                localVarQueryParameter['references'] = references;
                            }
                            if (referencesContains !== undefined) {
                                localVarQueryParameter['references__contains'] = referencesContains;
                            }
                            if (referencesIcontains !== undefined) {
                                localVarQueryParameter['references__icontains'] = referencesIcontains;
                            }
                            if (referencesIn !== undefined) {
                                localVarQueryParameter['references__in'] = referencesIn;
                            }
                            if (referencesPurchaseOrderNumber !== undefined) {
                                localVarQueryParameter['references__purchase_order_number'] = referencesPurchaseOrderNumber;
                            }
                            if (referencesPurchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['references__purchase_order_number__contains'] = referencesPurchaseOrderNumberContains;
                            }
                            if (referencesPurchaseOrderNumberIcontains !== undefined) {
                                localVarQueryParameter['references__purchase_order_number__icontains'] = referencesPurchaseOrderNumberIcontains;
                            }
                            if (referencesPurchaseOrderNumberIn !== undefined) {
                                localVarQueryParameter['references__purchase_order_number__in'] = referencesPurchaseOrderNumberIn;
                            }
                            if (purchaseOrderNumber !== undefined) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberIcontains !== undefined) {
                                localVarQueryParameter['purchase_order_number__icontains'] = purchaseOrderNumberIcontains;
                            }
                            if (purchaseOrderNumberIn !== undefined) {
                                localVarQueryParameter['purchase_order_number__in'] = purchaseOrderNumberIn;
                            }
                            if (shipToCompanyNameContains !== undefined) {
                                localVarQueryParameter['ship_to__company_name__contains'] = shipToCompanyNameContains;
                            }
                            if (shipToCompanyNameIcontains !== undefined) {
                                localVarQueryParameter['ship_to__company_name__icontains'] = shipToCompanyNameIcontains;
                            }
                            if (shipToCompanyNameIn !== undefined) {
                                localVarQueryParameter['ship_to__company_name__in'] = shipToCompanyNameIn;
                            }
                            if (shipToRegionContains !== undefined) {
                                localVarQueryParameter['ship_to__region__contains'] = shipToRegionContains;
                            }
                            if (shipToRegionIcontains !== undefined) {
                                localVarQueryParameter['ship_to__region__icontains'] = shipToRegionIcontains;
                            }
                            if (shipToRegionIn !== undefined) {
                                localVarQueryParameter['ship_to__region__in'] = shipToRegionIn;
                            }
                            if (shipToPlanWindowStartGte !== undefined) {
                                localVarQueryParameter['ship_to__plan_window_start__gte'] = (shipToPlanWindowStartGte instanceof Date) ?
                                    shipToPlanWindowStartGte.toISOString() :
                                    shipToPlanWindowStartGte;
                            }
                            if (shipToPlanWindowStartLte !== undefined) {
                                localVarQueryParameter['ship_to__plan_window_start__lte'] = (shipToPlanWindowStartLte instanceof Date) ?
                                    shipToPlanWindowStartLte.toISOString() :
                                    shipToPlanWindowStartLte;
                            }
                            if (shipToPlanWindowEndGte !== undefined) {
                                localVarQueryParameter['ship_to__plan_window_end__gte'] = (shipToPlanWindowEndGte instanceof Date) ?
                                    shipToPlanWindowEndGte.toISOString() :
                                    shipToPlanWindowEndGte;
                            }
                            if (shipToPlanWindowEndLte !== undefined) {
                                localVarQueryParameter['ship_to__plan_window_end__lte'] = (shipToPlanWindowEndLte instanceof Date) ?
                                    shipToPlanWindowEndLte.toISOString() :
                                    shipToPlanWindowEndLte;
                            }
                            if (shipToAddressIcontains !== undefined) {
                                localVarQueryParameter['ship_to__address__icontains'] = shipToAddressIcontains;
                            }
                            if (shipFromCompanyNameContains !== undefined) {
                                localVarQueryParameter['ship_from__company_name__contains'] = shipFromCompanyNameContains;
                            }
                            if (shipFromCompanyNameIcontains !== undefined) {
                                localVarQueryParameter['ship_from__company_name__icontains'] = shipFromCompanyNameIcontains;
                            }
                            if (shipFromCompanyNameIn !== undefined) {
                                localVarQueryParameter['ship_from__company_name__in'] = shipFromCompanyNameIn;
                            }
                            if (shipFromRegionContains !== undefined) {
                                localVarQueryParameter['ship_from__region__contains'] = shipFromRegionContains;
                            }
                            if (shipFromRegionIcontains !== undefined) {
                                localVarQueryParameter['ship_from__region__icontains'] = shipFromRegionIcontains;
                            }
                            if (shipFromRegionIn !== undefined) {
                                localVarQueryParameter['ship_from__region__in'] = shipFromRegionIn;
                            }
                            if (shipFromPlanWindowStartGte !== undefined) {
                                localVarQueryParameter['ship_from__plan_window_start__gte'] = (shipFromPlanWindowStartGte instanceof Date) ?
                                    shipFromPlanWindowStartGte.toISOString() :
                                    shipFromPlanWindowStartGte;
                            }
                            if (shipFromPlanWindowStartLte !== undefined) {
                                localVarQueryParameter['ship_from__plan_window_start__lte'] = (shipFromPlanWindowStartLte instanceof Date) ?
                                    shipFromPlanWindowStartLte.toISOString() :
                                    shipFromPlanWindowStartLte;
                            }
                            if (shipFromPlanWindowEndGte !== undefined) {
                                localVarQueryParameter['ship_from__plan_window_end__gte'] = (shipFromPlanWindowEndGte instanceof Date) ?
                                    shipFromPlanWindowEndGte.toISOString() :
                                    shipFromPlanWindowEndGte;
                            }
                            if (shipFromPlanWindowEndLte !== undefined) {
                                localVarQueryParameter['ship_from__plan_window_end__lte'] = (shipFromPlanWindowEndLte instanceof Date) ?
                                    shipFromPlanWindowEndLte.toISOString() :
                                    shipFromPlanWindowEndLte;
                            }
                            if (shipFromAddressIcontains !== undefined) {
                                localVarQueryParameter['ship_from__address__icontains'] = shipFromAddressIcontains;
                            }
                            if (supplierNameContains !== undefined) {
                                localVarQueryParameter['supplier__name__contains'] = supplierNameContains;
                            }
                            if (supplierNameIcontains !== undefined) {
                                localVarQueryParameter['supplier__name__icontains'] = supplierNameIcontains;
                            }
                            if (supplierNameIn !== undefined) {
                                localVarQueryParameter['supplier__name__in'] = supplierNameIn;
                            }
                            if (customerNameContains !== undefined) {
                                localVarQueryParameter['customer__name__contains'] = customerNameContains;
                            }
                            if (customerNameIcontains !== undefined) {
                                localVarQueryParameter['customer__name__icontains'] = customerNameIcontains;
                            }
                            if (customerNameIn !== undefined) {
                                localVarQueryParameter['customer__name__in'] = customerNameIn;
                            }
                            if (releasesReleasedOntoShipmentId !== undefined) {
                                localVarQueryParameter['releases__released_onto_shipment_id'] = releasesReleasedOntoShipmentId;
                            }
                            if (releasesReleasedOntoShipmentIdContains !== undefined) {
                                localVarQueryParameter['releases__released_onto_shipment_id__contains'] = releasesReleasedOntoShipmentIdContains;
                            }
                            if (releasesReleasedOntoShipmentIdIcontains !== undefined) {
                                localVarQueryParameter['releases__released_onto_shipment_id__icontains'] = releasesReleasedOntoShipmentIdIcontains;
                            }
                            if (releasesReleasedOntoShipmentIdIn !== undefined) {
                                localVarQueryParameter['releases__released_onto_shipment_id__in'] = releasesReleasedOntoShipmentIdIn;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder | UpdateEntireSalesOrder} updateEntirePurchaseOrderUpdateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: function (orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrder', 'orderId', orderId);
                            // verify required parameter 'updateEntirePurchaseOrderUpdateEntireSalesOrder' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrder', 'updateEntirePurchaseOrderUpdateEntireSalesOrder', updateEntirePurchaseOrderUpdateEntireSalesOrder);
                            localVarPath = "/orders/{order_id}"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEntirePurchaseOrderUpdateEntireSalesOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrdersApiAxiosParamCreator = OrdersApiAxiosParamCreator;
/**
 * OrdersApi - functional programming interface
 * @export
 */
var OrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Bulk Load Orders
         * @param {Array<BulkLoadOrderOperation>} bulkLoadOrderOperation
         * @param {boolean} [validateOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkLoadOrders: function (bulkLoadOrderOperation, validateOnly, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkLoadOrders(bulkLoadOrderOperation, validateOnly, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrders: function (createPurchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrders(createPurchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Orders
         * @param {Array<ProductOrderStatus>} [status]
         * @param {Array<string>} [orderNumber]
         * @param {Array<string>} [supplierName]
         * @param {Array<string>} [customerName]
         * @param {Array<string>} [shipFromAddress]
         * @param {Array<string>} [shipFromCompanyName]
         * @param {Array<string>} [shipFromRegion]
         * @param {Array<string>} [shipToAddress]
         * @param {Array<string>} [shipToCompanyName]
         * @param {Array<string>} [shipToRegion]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {string} [idIn]
         * @param {string} [statusIn]
         * @param {string} [orderNumberContains]
         * @param {string} [orderNumberIcontains]
         * @param {string} [orderNumberIn]
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIn]
         * @param {string} [createdAt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLte]
         * @param {string} [references]
         * @param {string} [referencesContains]
         * @param {string} [referencesIcontains]
         * @param {string} [referencesIn]
         * @param {string} [referencesPurchaseOrderNumber]
         * @param {string} [referencesPurchaseOrderNumberContains]
         * @param {string} [referencesPurchaseOrderNumberIcontains]
         * @param {string} [referencesPurchaseOrderNumberIn]
         * @param {string} [purchaseOrderNumber]
         * @param {string} [purchaseOrderNumberContains]
         * @param {string} [purchaseOrderNumberIcontains]
         * @param {string} [purchaseOrderNumberIn]
         * @param {string} [shipToCompanyNameContains]
         * @param {string} [shipToCompanyNameIcontains]
         * @param {string} [shipToCompanyNameIn]
         * @param {string} [shipToRegionContains]
         * @param {string} [shipToRegionIcontains]
         * @param {string} [shipToRegionIn]
         * @param {string} [shipToPlanWindowStartGte]
         * @param {string} [shipToPlanWindowStartLte]
         * @param {string} [shipToPlanWindowEndGte]
         * @param {string} [shipToPlanWindowEndLte]
         * @param {string} [shipToAddressIcontains]
         * @param {string} [shipFromCompanyNameContains]
         * @param {string} [shipFromCompanyNameIcontains]
         * @param {string} [shipFromCompanyNameIn]
         * @param {string} [shipFromRegionContains]
         * @param {string} [shipFromRegionIcontains]
         * @param {string} [shipFromRegionIn]
         * @param {string} [shipFromPlanWindowStartGte]
         * @param {string} [shipFromPlanWindowStartLte]
         * @param {string} [shipFromPlanWindowEndGte]
         * @param {string} [shipFromPlanWindowEndLte]
         * @param {string} [shipFromAddressIcontains]
         * @param {string} [supplierNameContains]
         * @param {string} [supplierNameIcontains]
         * @param {string} [supplierNameIn]
         * @param {string} [customerNameContains]
         * @param {string} [customerNameIcontains]
         * @param {string} [customerNameIn]
         * @param {string} [releasesReleasedOntoShipmentId]
         * @param {string} [releasesReleasedOntoShipmentIdContains]
         * @param {string} [releasesReleasedOntoShipmentIdIcontains]
         * @param {string} [releasesReleasedOntoShipmentIdIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: function (status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listOrders(status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder | UpdateEntireSalesOrder} updateEntirePurchaseOrderUpdateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: function (orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOrder(orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrdersApiFp = OrdersApiFp;
/**
 * OrdersApi - factory interface
 * @export
 */
var OrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrdersApiFp)(configuration);
    return {
        /**
         *
         * @summary Bulk Load Orders
         * @param {Array<BulkLoadOrderOperation>} bulkLoadOrderOperation
         * @param {boolean} [validateOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkLoadOrders: function (bulkLoadOrderOperation, validateOnly, options) {
            return localVarFp.bulkLoadOrders(bulkLoadOrderOperation, validateOnly, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrders: function (createPurchaseOrder, options) {
            return localVarFp.createOrders(createPurchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Orders
         * @param {Array<ProductOrderStatus>} [status]
         * @param {Array<string>} [orderNumber]
         * @param {Array<string>} [supplierName]
         * @param {Array<string>} [customerName]
         * @param {Array<string>} [shipFromAddress]
         * @param {Array<string>} [shipFromCompanyName]
         * @param {Array<string>} [shipFromRegion]
         * @param {Array<string>} [shipToAddress]
         * @param {Array<string>} [shipToCompanyName]
         * @param {Array<string>} [shipToRegion]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {string} [idIn]
         * @param {string} [statusIn]
         * @param {string} [orderNumberContains]
         * @param {string} [orderNumberIcontains]
         * @param {string} [orderNumberIn]
         * @param {string} [name]
         * @param {string} [nameContains]
         * @param {string} [nameIcontains]
         * @param {string} [nameIn]
         * @param {string} [createdAt]
         * @param {string} [createdAtGte]
         * @param {string} [createdAtLte]
         * @param {string} [references]
         * @param {string} [referencesContains]
         * @param {string} [referencesIcontains]
         * @param {string} [referencesIn]
         * @param {string} [referencesPurchaseOrderNumber]
         * @param {string} [referencesPurchaseOrderNumberContains]
         * @param {string} [referencesPurchaseOrderNumberIcontains]
         * @param {string} [referencesPurchaseOrderNumberIn]
         * @param {string} [purchaseOrderNumber]
         * @param {string} [purchaseOrderNumberContains]
         * @param {string} [purchaseOrderNumberIcontains]
         * @param {string} [purchaseOrderNumberIn]
         * @param {string} [shipToCompanyNameContains]
         * @param {string} [shipToCompanyNameIcontains]
         * @param {string} [shipToCompanyNameIn]
         * @param {string} [shipToRegionContains]
         * @param {string} [shipToRegionIcontains]
         * @param {string} [shipToRegionIn]
         * @param {string} [shipToPlanWindowStartGte]
         * @param {string} [shipToPlanWindowStartLte]
         * @param {string} [shipToPlanWindowEndGte]
         * @param {string} [shipToPlanWindowEndLte]
         * @param {string} [shipToAddressIcontains]
         * @param {string} [shipFromCompanyNameContains]
         * @param {string} [shipFromCompanyNameIcontains]
         * @param {string} [shipFromCompanyNameIn]
         * @param {string} [shipFromRegionContains]
         * @param {string} [shipFromRegionIcontains]
         * @param {string} [shipFromRegionIn]
         * @param {string} [shipFromPlanWindowStartGte]
         * @param {string} [shipFromPlanWindowStartLte]
         * @param {string} [shipFromPlanWindowEndGte]
         * @param {string} [shipFromPlanWindowEndLte]
         * @param {string} [shipFromAddressIcontains]
         * @param {string} [supplierNameContains]
         * @param {string} [supplierNameIcontains]
         * @param {string} [supplierNameIn]
         * @param {string} [customerNameContains]
         * @param {string} [customerNameIcontains]
         * @param {string} [customerNameIn]
         * @param {string} [releasesReleasedOntoShipmentId]
         * @param {string} [releasesReleasedOntoShipmentIdContains]
         * @param {string} [releasesReleasedOntoShipmentIdIcontains]
         * @param {string} [releasesReleasedOntoShipmentIdIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: function (status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options) {
            return localVarFp.listOrders(status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder | UpdateEntireSalesOrder} updateEntirePurchaseOrderUpdateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: function (orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options) {
            return localVarFp.updateOrder(orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrdersApiFactory = OrdersApiFactory;
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
var OrdersApi = /** @class */ (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Bulk Load Orders
     * @param {Array<BulkLoadOrderOperation>} bulkLoadOrderOperation
     * @param {boolean} [validateOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.bulkLoadOrders = function (bulkLoadOrderOperation, validateOnly, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).bulkLoadOrders(bulkLoadOrderOperation, validateOnly, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Order
     * @param {CreatePurchaseOrder} createPurchaseOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.createOrders = function (createPurchaseOrder, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).createOrders(createPurchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Orders
     * @param {Array<ProductOrderStatus>} [status]
     * @param {Array<string>} [orderNumber]
     * @param {Array<string>} [supplierName]
     * @param {Array<string>} [customerName]
     * @param {Array<string>} [shipFromAddress]
     * @param {Array<string>} [shipFromCompanyName]
     * @param {Array<string>} [shipFromRegion]
     * @param {Array<string>} [shipToAddress]
     * @param {Array<string>} [shipToCompanyName]
     * @param {Array<string>} [shipToRegion]
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [q]
     * @param {string} [orderBy]
     * @param {string} [id]
     * @param {string} [idIn]
     * @param {string} [statusIn]
     * @param {string} [orderNumberContains]
     * @param {string} [orderNumberIcontains]
     * @param {string} [orderNumberIn]
     * @param {string} [name]
     * @param {string} [nameContains]
     * @param {string} [nameIcontains]
     * @param {string} [nameIn]
     * @param {string} [createdAt]
     * @param {string} [createdAtGte]
     * @param {string} [createdAtLte]
     * @param {string} [references]
     * @param {string} [referencesContains]
     * @param {string} [referencesIcontains]
     * @param {string} [referencesIn]
     * @param {string} [referencesPurchaseOrderNumber]
     * @param {string} [referencesPurchaseOrderNumberContains]
     * @param {string} [referencesPurchaseOrderNumberIcontains]
     * @param {string} [referencesPurchaseOrderNumberIn]
     * @param {string} [purchaseOrderNumber]
     * @param {string} [purchaseOrderNumberContains]
     * @param {string} [purchaseOrderNumberIcontains]
     * @param {string} [purchaseOrderNumberIn]
     * @param {string} [shipToCompanyNameContains]
     * @param {string} [shipToCompanyNameIcontains]
     * @param {string} [shipToCompanyNameIn]
     * @param {string} [shipToRegionContains]
     * @param {string} [shipToRegionIcontains]
     * @param {string} [shipToRegionIn]
     * @param {string} [shipToPlanWindowStartGte]
     * @param {string} [shipToPlanWindowStartLte]
     * @param {string} [shipToPlanWindowEndGte]
     * @param {string} [shipToPlanWindowEndLte]
     * @param {string} [shipToAddressIcontains]
     * @param {string} [shipFromCompanyNameContains]
     * @param {string} [shipFromCompanyNameIcontains]
     * @param {string} [shipFromCompanyNameIn]
     * @param {string} [shipFromRegionContains]
     * @param {string} [shipFromRegionIcontains]
     * @param {string} [shipFromRegionIn]
     * @param {string} [shipFromPlanWindowStartGte]
     * @param {string} [shipFromPlanWindowStartLte]
     * @param {string} [shipFromPlanWindowEndGte]
     * @param {string} [shipFromPlanWindowEndLte]
     * @param {string} [shipFromAddressIcontains]
     * @param {string} [supplierNameContains]
     * @param {string} [supplierNameIcontains]
     * @param {string} [supplierNameIn]
     * @param {string} [customerNameContains]
     * @param {string} [customerNameIcontains]
     * @param {string} [customerNameIn]
     * @param {string} [releasesReleasedOntoShipmentId]
     * @param {string} [releasesReleasedOntoShipmentIdContains]
     * @param {string} [releasesReleasedOntoShipmentIdIcontains]
     * @param {string} [releasesReleasedOntoShipmentIdIn]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.listOrders = function (status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).listOrders(status, orderNumber, supplierName, customerName, shipFromAddress, shipFromCompanyName, shipFromRegion, shipToAddress, shipToCompanyName, shipToRegion, page, limit, q, orderBy, id, idIn, statusIn, orderNumberContains, orderNumberIcontains, orderNumberIn, name, nameContains, nameIcontains, nameIn, createdAt, createdAtGte, createdAtLte, references, referencesContains, referencesIcontains, referencesIn, referencesPurchaseOrderNumber, referencesPurchaseOrderNumberContains, referencesPurchaseOrderNumberIcontains, referencesPurchaseOrderNumberIn, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberIcontains, purchaseOrderNumberIn, shipToCompanyNameContains, shipToCompanyNameIcontains, shipToCompanyNameIn, shipToRegionContains, shipToRegionIcontains, shipToRegionIn, shipToPlanWindowStartGte, shipToPlanWindowStartLte, shipToPlanWindowEndGte, shipToPlanWindowEndLte, shipToAddressIcontains, shipFromCompanyNameContains, shipFromCompanyNameIcontains, shipFromCompanyNameIn, shipFromRegionContains, shipFromRegionIcontains, shipFromRegionIn, shipFromPlanWindowStartGte, shipFromPlanWindowStartLte, shipFromPlanWindowEndGte, shipFromPlanWindowEndLte, shipFromAddressIcontains, supplierNameContains, supplierNameIcontains, supplierNameIn, customerNameContains, customerNameIcontains, customerNameIn, releasesReleasedOntoShipmentId, releasesReleasedOntoShipmentIdContains, releasesReleasedOntoShipmentIdIcontains, releasesReleasedOntoShipmentIdIn, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Order
     * @param {string} orderId
     * @param {UpdateEntirePurchaseOrder | UpdateEntireSalesOrder} updateEntirePurchaseOrderUpdateEntireSalesOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.updateOrder = function (orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).updateOrder(orderId, updateEntirePurchaseOrderUpdateEntireSalesOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrdersApi;
}(base_1.BaseAPI));
exports.OrdersApi = OrdersApi;
/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
var PurchaseOrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Cancel Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPurchaseOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('cancelPurchaseOrder', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/cancel"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrder: function (createPurchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPurchaseOrder' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrder', 'createPurchaseOrder', createPurchaseOrder);
                            localVarPath = "/purchase-orders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPurchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderDocument: function (orderId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderDocument', 'orderId', orderId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderDocument', 'file', file);
                            localVarPath = "/purchase-orders/{order_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', new Blob([JSON.stringify(type)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Item
         * @param {string} orderId
         * @param {CreateOrderItem} createOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderItem: function (orderId, createOrderItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderItem', 'orderId', orderId);
                            // verify required parameter 'createOrderItem' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderItem', 'createOrderItem', createOrderItem);
                            localVarPath = "/purchase-orders/{order_id}/items"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOrderItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Release
         * @param {string} orderId
         * @param {CreateTransportationRelease | CreatePurchaseOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderRelease', 'orderId', orderId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createPurchaseOrderRelease', 'data', data);
                            localVarPath = "/purchase-orders/{order_id}/releases"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderDocument: function (documentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderDocument', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderItem: function (orderItemId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderItemId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderItem', 'orderItemId', orderItemId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderItem', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/items/{order_item_id}"
                                .replace("{".concat("order_item_id", "}"), encodeURIComponent(String(orderItemId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRelease: function (releaseId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderRelease', 'releaseId', releaseId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('deletePurchaseOrderRelease', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/releases/{release_id}"
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrder', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderDocument: function (documentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderDocument', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderItem: function (orderItemId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderItemId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderItem', 'orderItemId', orderItemId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderItem', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/items/{order_item_id}"
                                .replace("{".concat("order_item_id", "}"), encodeURIComponent(String(orderItemId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRelease: function (releaseId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderRelease', 'releaseId', releaseId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getPurchaseOrderRelease', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/releases/{release_id}"
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderDocuments: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listPurchaseOrderDocuments', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {boolean} [isUnassigned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderReleases: function (orderId, page, limit, q, orderBy, id, isUnassigned, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listPurchaseOrderReleases', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/releases"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (isUnassigned !== undefined) {
                                localVarQueryParameter['is_unassigned'] = isUnassigned;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listPurchaseOrderTransitTimelineEvents', 'orderId', orderId);
                            localVarPath = "/purchase-orders/{order_id}/transit-events"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Orders
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrders: function (page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder} updateEntirePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder: function (orderId, updateEntirePurchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrder', 'orderId', orderId);
                            // verify required parameter 'updateEntirePurchaseOrder' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrder', 'updateEntirePurchaseOrder', updateEntirePurchaseOrder);
                            localVarPath = "/purchase-orders/{order_id}"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEntirePurchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Details
         * @param {string} orderId
         * @param {UpdatePurchaseOrder} updatePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDetails: function (orderId, updatePurchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderDetails', 'orderId', orderId);
                            // verify required parameter 'updatePurchaseOrder' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderDetails', 'updatePurchaseOrder', updatePurchaseOrder);
                            localVarPath = "/purchase-orders/{order_id}/details"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePurchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderDocument', 'orderId', orderId);
                            // verify required parameter 'updateProductOrderDocument' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderDocument', 'updateProductOrderDocument', updateProductOrderDocument);
                            localVarPath = "/purchase-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductOrderDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateOrderItem} updateOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderItem: function (orderItemId, orderId, updateOrderItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderItemId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderItem', 'orderItemId', orderItemId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderItem', 'orderId', orderId);
                            // verify required parameter 'updateOrderItem' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderItem', 'updateOrderItem', updateOrderItem);
                            localVarPath = "/purchase-orders/{order_id}/items/{order_item_id}"
                                .replace("{".concat("order_item_id", "}"), encodeURIComponent(String(orderItemId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateOrderItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipFrom: function (orderId, orderStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderShipFrom', 'orderId', orderId);
                            // verify required parameter 'orderStop' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderShipFrom', 'orderStop', orderStop);
                            localVarPath = "/purchase-orders/{order_id}/ship-from"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipTo: function (orderId, orderStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderShipTo', 'orderId', orderId);
                            // verify required parameter 'orderStop' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderShipTo', 'orderStop', orderStop);
                            localVarPath = "/purchase-orders/{order_id}/ship-to"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Supplier
         * @param {string} orderId
         * @param {OrderSupplier} orderSupplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderSupplier: function (orderId, orderSupplier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderSupplier', 'orderId', orderId);
                            // verify required parameter 'orderSupplier' is not null or undefined
                            (0, common_1.assertParamExists)('updatePurchaseOrderSupplier', 'orderSupplier', orderSupplier);
                            localVarPath = "/purchase-orders/{order_id}/supplier"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderSupplier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PurchaseOrdersApiAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator;
/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
var PurchaseOrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PurchaseOrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Cancel Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPurchaseOrder: function (orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelPurchaseOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrder: function (createPurchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPurchaseOrder(createPurchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderDocument: function (orderId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPurchaseOrderDocument(orderId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Item
         * @param {string} orderId
         * @param {CreateOrderItem} createOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderItem: function (orderId, createOrderItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPurchaseOrderItem(orderId, createOrderItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Purchase Order Release
         * @param {string} orderId
         * @param {CreateTransportationRelease | CreatePurchaseOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPurchaseOrderRelease(orderId, data, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderDocument: function (documentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePurchaseOrderDocument(documentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderItem: function (orderItemId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePurchaseOrderItem(orderItemId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRelease: function (releaseId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePurchaseOrderRelease(releaseId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrder: function (orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderDocument: function (documentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseOrderDocument(documentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderItem: function (orderItemId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseOrderItem(orderItemId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRelease: function (releaseId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPurchaseOrderRelease(releaseId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderDocuments: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPurchaseOrderDocuments(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {boolean} [isUnassigned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderReleases: function (orderId, page, limit, q, orderBy, id, isUnassigned, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPurchaseOrderReleases(orderId, page, limit, q, orderBy, id, isUnassigned, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPurchaseOrderTransitTimelineEvents(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Purchase Orders
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrders: function (page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPurchaseOrders(page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder} updateEntirePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder: function (orderId, updateEntirePurchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrder(orderId, updateEntirePurchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Details
         * @param {string} orderId
         * @param {UpdatePurchaseOrder} updatePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDetails: function (orderId, updatePurchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderDetails(orderId, updatePurchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderDocument(documentId, orderId, updateProductOrderDocument, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateOrderItem} updateOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderItem: function (orderItemId, orderId, updateOrderItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderItem(orderItemId, orderId, updateOrderItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipFrom: function (orderId, orderStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderShipFrom(orderId, orderStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipTo: function (orderId, orderStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderShipTo(orderId, orderStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Purchase Order Supplier
         * @param {string} orderId
         * @param {OrderSupplier} orderSupplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderSupplier: function (orderId, orderSupplier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePurchaseOrderSupplier(orderId, orderSupplier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PurchaseOrdersApiFp = PurchaseOrdersApiFp;
/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
var PurchaseOrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PurchaseOrdersApiFp)(configuration);
    return {
        /**
         *
         * @summary Cancel Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPurchaseOrder: function (orderId, options) {
            return localVarFp.cancelPurchaseOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Purchase Order
         * @param {CreatePurchaseOrder} createPurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrder: function (createPurchaseOrder, options) {
            return localVarFp.createPurchaseOrder(createPurchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Purchase Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderDocument: function (orderId, file, description, type, options) {
            return localVarFp.createPurchaseOrderDocument(orderId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Purchase Order Item
         * @param {string} orderId
         * @param {CreateOrderItem} createOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderItem: function (orderId, createOrderItem, options) {
            return localVarFp.createPurchaseOrderItem(orderId, createOrderItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Purchase Order Release
         * @param {string} orderId
         * @param {CreateTransportationRelease | CreatePurchaseOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            return localVarFp.createPurchaseOrderRelease(orderId, data, documentsMetadata, documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderDocument: function (documentId, orderId, options) {
            return localVarFp.deletePurchaseOrderDocument(documentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderItem: function (orderItemId, orderId, options) {
            return localVarFp.deletePurchaseOrderItem(orderItemId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseOrderRelease: function (releaseId, orderId, options) {
            return localVarFp.deletePurchaseOrderRelease(releaseId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Purchase Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrder: function (orderId, options) {
            return localVarFp.getPurchaseOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderDocument: function (documentId, orderId, options) {
            return localVarFp.getPurchaseOrderDocument(documentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderItem: function (orderItemId, orderId, options) {
            return localVarFp.getPurchaseOrderItem(orderItemId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Purchase Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseOrderRelease: function (releaseId, orderId, options) {
            return localVarFp.getPurchaseOrderRelease(releaseId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Purchase Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderDocuments: function (orderId, page, limit, options) {
            return localVarFp.listPurchaseOrderDocuments(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Purchase Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [q]
         * @param {string} [orderBy]
         * @param {string} [id]
         * @param {boolean} [isUnassigned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderReleases: function (orderId, page, limit, q, orderBy, id, isUnassigned, options) {
            return localVarFp.listPurchaseOrderReleases(orderId, page, limit, q, orderBy, id, isUnassigned, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Purchase Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            return localVarFp.listPurchaseOrderTransitTimelineEvents(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Purchase Orders
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPurchaseOrders: function (page, limit, options) {
            return localVarFp.listPurchaseOrders(page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order
         * @param {string} orderId
         * @param {UpdateEntirePurchaseOrder} updateEntirePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrder: function (orderId, updateEntirePurchaseOrder, options) {
            return localVarFp.updatePurchaseOrder(orderId, updateEntirePurchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Details
         * @param {string} orderId
         * @param {UpdatePurchaseOrder} updatePurchaseOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDetails: function (orderId, updatePurchaseOrder, options) {
            return localVarFp.updatePurchaseOrderDetails(orderId, updatePurchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            return localVarFp.updatePurchaseOrderDocument(documentId, orderId, updateProductOrderDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateOrderItem} updateOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderItem: function (orderItemId, orderId, updateOrderItem, options) {
            return localVarFp.updatePurchaseOrderItem(orderItemId, orderId, updateOrderItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipFrom: function (orderId, orderStop, options) {
            return localVarFp.updatePurchaseOrderShipFrom(orderId, orderStop, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderShipTo: function (orderId, orderStop, options) {
            return localVarFp.updatePurchaseOrderShipTo(orderId, orderStop, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Purchase Order Supplier
         * @param {string} orderId
         * @param {OrderSupplier} orderSupplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseOrderSupplier: function (orderId, orderSupplier, options) {
            return localVarFp.updatePurchaseOrderSupplier(orderId, orderSupplier, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PurchaseOrdersApiFactory = PurchaseOrdersApiFactory;
/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
var PurchaseOrdersApi = /** @class */ (function (_super) {
    __extends(PurchaseOrdersApi, _super);
    function PurchaseOrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Cancel Purchase Order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.cancelPurchaseOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).cancelPurchaseOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Purchase Order
     * @param {CreatePurchaseOrder} createPurchaseOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.createPurchaseOrder = function (createPurchaseOrder, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).createPurchaseOrder(createPurchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Purchase Order Document
     * @param {string} orderId
     * @param {any} file
     * @param {string} [description]
     * @param {DocumentType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.createPurchaseOrderDocument = function (orderId, file, description, type, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).createPurchaseOrderDocument(orderId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Purchase Order Item
     * @param {string} orderId
     * @param {CreateOrderItem} createOrderItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.createPurchaseOrderItem = function (orderId, createOrderItem, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).createPurchaseOrderItem(orderId, createOrderItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Purchase Order Release
     * @param {string} orderId
     * @param {CreateTransportationRelease | CreatePurchaseOrderRelease} data
     * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
     * @param {Array<any>} [documents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.createPurchaseOrderRelease = function (orderId, data, documentsMetadata, documents, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).createPurchaseOrderRelease(orderId, data, documentsMetadata, documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Purchase Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.deletePurchaseOrderDocument = function (documentId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).deletePurchaseOrderDocument(documentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Purchase Order Item
     * @param {string} orderItemId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.deletePurchaseOrderItem = function (orderItemId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).deletePurchaseOrderItem(orderItemId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Purchase Order Release
     * @param {string} releaseId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.deletePurchaseOrderRelease = function (releaseId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).deletePurchaseOrderRelease(releaseId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Purchase Order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.getPurchaseOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).getPurchaseOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Purchase Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.getPurchaseOrderDocument = function (documentId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).getPurchaseOrderDocument(documentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Purchase Order Item
     * @param {string} orderItemId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.getPurchaseOrderItem = function (orderItemId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).getPurchaseOrderItem(orderItemId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Purchase Order Release
     * @param {string} releaseId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.getPurchaseOrderRelease = function (releaseId, orderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).getPurchaseOrderRelease(releaseId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Purchase Order Documents
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.listPurchaseOrderDocuments = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).listPurchaseOrderDocuments(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Purchase Order Releases
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {string} [q]
     * @param {string} [orderBy]
     * @param {string} [id]
     * @param {boolean} [isUnassigned]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.listPurchaseOrderReleases = function (orderId, page, limit, q, orderBy, id, isUnassigned, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).listPurchaseOrderReleases(orderId, page, limit, q, orderBy, id, isUnassigned, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Purchase Order Transit Timeline Events
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.listPurchaseOrderTransitTimelineEvents = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).listPurchaseOrderTransitTimelineEvents(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Purchase Orders
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.listPurchaseOrders = function (page, limit, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).listPurchaseOrders(page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order
     * @param {string} orderId
     * @param {UpdateEntirePurchaseOrder} updateEntirePurchaseOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrder = function (orderId, updateEntirePurchaseOrder, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrder(orderId, updateEntirePurchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Details
     * @param {string} orderId
     * @param {UpdatePurchaseOrder} updatePurchaseOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderDetails = function (orderId, updatePurchaseOrder, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderDetails(orderId, updatePurchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {UpdateProductOrderDocument} updateProductOrderDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderDocument = function (documentId, orderId, updateProductOrderDocument, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderDocument(documentId, orderId, updateProductOrderDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Item
     * @param {string} orderItemId
     * @param {string} orderId
     * @param {UpdateOrderItem} updateOrderItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderItem = function (orderItemId, orderId, updateOrderItem, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderItem(orderItemId, orderId, updateOrderItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Stop Ship From
     * @param {string} orderId
     * @param {OrderStop} orderStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderShipFrom = function (orderId, orderStop, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderShipFrom(orderId, orderStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Stop Ship To
     * @param {string} orderId
     * @param {OrderStop} orderStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderShipTo = function (orderId, orderStop, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderShipTo(orderId, orderStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Purchase Order Supplier
     * @param {string} orderId
     * @param {OrderSupplier} orderSupplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.updatePurchaseOrderSupplier = function (orderId, orderSupplier, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).updatePurchaseOrderSupplier(orderId, orderSupplier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PurchaseOrdersApi;
}(base_1.BaseAPI));
exports.PurchaseOrdersApi = PurchaseOrdersApi;
/**
 * SalesOrdersApi - axios parameter creator
 * @export
 */
var SalesOrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Cancel Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSalesOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('cancelSalesOrder', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/cancel"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderDocument: function (orderId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderDocument', 'orderId', orderId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderDocument', 'file', file);
                            localVarPath = "/sales-orders/{order_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', new Blob([JSON.stringify(type)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Release
         * @param {string} orderId
         * @param {CreateSalesOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderRelease', 'orderId', orderId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderRelease', 'data', data);
                            localVarPath = "/sales-orders/{order_id}/releases"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Release Document
         * @param {string} orderId
         * @param {string} releaseId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderReleaseDocument: function (orderId, releaseId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderReleaseDocument', 'orderId', orderId);
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderReleaseDocument', 'releaseId', releaseId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('createSalesOrderReleaseDocument', 'file', file);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', new Blob([JSON.stringify(type)], { type: "application/json", }));
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderDocument: function (documentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSalesOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSalesOrderDocument', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSalesOrderReleaseDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSalesOrderReleaseDocument', 'orderId', orderId);
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSalesOrderReleaseDocument', 'releaseId', releaseId);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrder', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderDocument: function (documentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderDocument', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRelease: function (releaseId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderRelease', 'releaseId', releaseId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderRelease', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}"
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderReleaseDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderReleaseDocument', 'orderId', orderId);
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('getSalesOrderReleaseDocument', 'releaseId', releaseId);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderDocuments: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderDocuments', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Release Documents
         * @param {string} orderId
         * @param {string} releaseId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleaseDocuments: function (orderId, releaseId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderReleaseDocuments', 'orderId', orderId);
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderReleaseDocuments', 'releaseId', releaseId);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}/documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleases: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderReleases', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/releases"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Details
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDetails: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderTransitDetails', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/transit-details"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDocuments: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderTransitDocuments', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/transit-documents"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('listSalesOrderTransitTimelineEvents', 'orderId', orderId);
                            localVarPath = "/sales-orders/{order_id}/transit-events"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order
         * @param {string} orderId
         * @param {UpdateEntireSalesOrder} updateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrder: function (orderId, updateEntireSalesOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrder', 'orderId', orderId);
                            // verify required parameter 'updateEntireSalesOrder' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrder', 'updateEntireSalesOrder', updateEntireSalesOrder);
                            localVarPath = "/sales-orders/{order_id}"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateEntireSalesOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Details
         * @param {string} orderId
         * @param {UpdateSalesOrder} updateSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDetails: function (orderId, updateSalesOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderDetails', 'orderId', orderId);
                            // verify required parameter 'updateSalesOrder' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderDetails', 'updateSalesOrder', updateSalesOrder);
                            localVarPath = "/sales-orders/{order_id}/details"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSalesOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderDocument', 'orderId', orderId);
                            // verify required parameter 'updateProductOrderDocument' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderDocument', 'updateProductOrderDocument', updateProductOrderDocument);
                            localVarPath = "/sales-orders/{order_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductOrderDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateSalesOrderItem} updateSalesOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderItem: function (orderItemId, orderId, updateSalesOrderItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderItemId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderItem', 'orderItemId', orderItemId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderItem', 'orderId', orderId);
                            // verify required parameter 'updateSalesOrderItem' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderItem', 'updateSalesOrderItem', updateSalesOrderItem);
                            localVarPath = "/sales-orders/{order_id}/items/{order_item_id}"
                                .replace("{".concat("order_item_id", "}"), encodeURIComponent(String(orderItemId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSalesOrderItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {UpdateOrderReleaseDocument} updateOrderReleaseDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderReleaseDocument: function (documentId, orderId, releaseId, updateOrderReleaseDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderReleaseDocument', 'documentId', documentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderReleaseDocument', 'orderId', orderId);
                            // verify required parameter 'releaseId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderReleaseDocument', 'releaseId', releaseId);
                            // verify required parameter 'updateOrderReleaseDocument' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderReleaseDocument', 'updateOrderReleaseDocument', updateOrderReleaseDocument);
                            localVarPath = "/sales-orders/{order_id}/releases/{release_id}/documents/{document_id}"
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("release_id", "}"), encodeURIComponent(String(releaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateOrderReleaseDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipFrom: function (orderId, orderStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderShipFrom', 'orderId', orderId);
                            // verify required parameter 'orderStop' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderShipFrom', 'orderStop', orderStop);
                            localVarPath = "/sales-orders/{order_id}/ship-from"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipTo: function (orderId, orderStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderShipTo', 'orderId', orderId);
                            // verify required parameter 'orderStop' is not null or undefined
                            (0, common_1.assertParamExists)('updateSalesOrderShipTo', 'orderStop', orderStop);
                            localVarPath = "/sales-orders/{order_id}/ship-to"
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orderStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SalesOrdersApiAxiosParamCreator = SalesOrdersApiAxiosParamCreator;
/**
 * SalesOrdersApi - functional programming interface
 * @export
 */
var SalesOrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SalesOrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Cancel Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSalesOrder: function (orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelSalesOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderDocument: function (orderId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSalesOrderDocument(orderId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Release
         * @param {string} orderId
         * @param {CreateSalesOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSalesOrderRelease(orderId, data, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Sales Order Release Document
         * @param {string} orderId
         * @param {string} releaseId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderReleaseDocument: function (orderId, releaseId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSalesOrderReleaseDocument(orderId, releaseId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderDocument: function (documentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSalesOrderDocument(documentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSalesOrderReleaseDocument(documentId, orderId, releaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrder: function (orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSalesOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderDocument: function (documentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSalesOrderDocument(documentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRelease: function (releaseId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSalesOrderRelease(releaseId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSalesOrderReleaseDocument(documentId, orderId, releaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderDocuments: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderDocuments(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Release Documents
         * @param {string} orderId
         * @param {string} releaseId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleaseDocuments: function (orderId, releaseId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderReleaseDocuments(orderId, releaseId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleases: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderReleases(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Details
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDetails: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderTransitDetails(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDocuments: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderTransitDocuments(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Sales Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listSalesOrderTransitTimelineEvents(orderId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order
         * @param {string} orderId
         * @param {UpdateEntireSalesOrder} updateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrder: function (orderId, updateEntireSalesOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrder(orderId, updateEntireSalesOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Details
         * @param {string} orderId
         * @param {UpdateSalesOrder} updateSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDetails: function (orderId, updateSalesOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderDetails(orderId, updateSalesOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderDocument(documentId, orderId, updateProductOrderDocument, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateSalesOrderItem} updateSalesOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderItem: function (orderItemId, orderId, updateSalesOrderItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderItem(orderItemId, orderId, updateSalesOrderItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {UpdateOrderReleaseDocument} updateOrderReleaseDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderReleaseDocument: function (documentId, orderId, releaseId, updateOrderReleaseDocument, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderReleaseDocument(documentId, orderId, releaseId, updateOrderReleaseDocument, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipFrom: function (orderId, orderStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderShipFrom(orderId, orderStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipTo: function (orderId, orderStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSalesOrderShipTo(orderId, orderStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SalesOrdersApiFp = SalesOrdersApiFp;
/**
 * SalesOrdersApi - factory interface
 * @export
 */
var SalesOrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SalesOrdersApiFp)(configuration);
    return {
        /**
         *
         * @summary Cancel Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSalesOrder: function (orderId, options) {
            return localVarFp.cancelSalesOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Sales Order Document
         * @param {string} orderId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderDocument: function (orderId, file, description, type, options) {
            return localVarFp.createSalesOrderDocument(orderId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Sales Order Release
         * @param {string} orderId
         * @param {CreateSalesOrderRelease} data
         * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderRelease: function (orderId, data, documentsMetadata, documents, options) {
            return localVarFp.createSalesOrderRelease(orderId, data, documentsMetadata, documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Sales Order Release Document
         * @param {string} orderId
         * @param {string} releaseId
         * @param {any} file
         * @param {string} [description]
         * @param {DocumentType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesOrderReleaseDocument: function (orderId, releaseId, file, description, type, options) {
            return localVarFp.createSalesOrderReleaseDocument(orderId, releaseId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderDocument: function (documentId, orderId, options) {
            return localVarFp.deleteSalesOrderDocument(documentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            return localVarFp.deleteSalesOrderReleaseDocument(documentId, orderId, releaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Sales Order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrder: function (orderId, options) {
            return localVarFp.getSalesOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderDocument: function (documentId, orderId, options) {
            return localVarFp.getSalesOrderDocument(documentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Sales Order Release
         * @param {string} releaseId
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderRelease: function (releaseId, orderId, options) {
            return localVarFp.getSalesOrderRelease(releaseId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesOrderReleaseDocument: function (documentId, orderId, releaseId, options) {
            return localVarFp.getSalesOrderReleaseDocument(documentId, orderId, releaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderDocuments: function (orderId, page, limit, options) {
            return localVarFp.listSalesOrderDocuments(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Release Documents
         * @param {string} orderId
         * @param {string} releaseId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleaseDocuments: function (orderId, releaseId, page, limit, options) {
            return localVarFp.listSalesOrderReleaseDocuments(orderId, releaseId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Releases
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderReleases: function (orderId, page, limit, options) {
            return localVarFp.listSalesOrderReleases(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Transit Details
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDetails: function (orderId, page, limit, options) {
            return localVarFp.listSalesOrderTransitDetails(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Transit Documents
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitDocuments: function (orderId, page, limit, options) {
            return localVarFp.listSalesOrderTransitDocuments(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Sales Order Transit Timeline Events
         * @param {string} orderId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSalesOrderTransitTimelineEvents: function (orderId, page, limit, options) {
            return localVarFp.listSalesOrderTransitTimelineEvents(orderId, page, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order
         * @param {string} orderId
         * @param {UpdateEntireSalesOrder} updateEntireSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrder: function (orderId, updateEntireSalesOrder, options) {
            return localVarFp.updateSalesOrder(orderId, updateEntireSalesOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Details
         * @param {string} orderId
         * @param {UpdateSalesOrder} updateSalesOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDetails: function (orderId, updateSalesOrder, options) {
            return localVarFp.updateSalesOrderDetails(orderId, updateSalesOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {UpdateProductOrderDocument} updateProductOrderDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderDocument: function (documentId, orderId, updateProductOrderDocument, options) {
            return localVarFp.updateSalesOrderDocument(documentId, orderId, updateProductOrderDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Item
         * @param {string} orderItemId
         * @param {string} orderId
         * @param {UpdateSalesOrderItem} updateSalesOrderItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderItem: function (orderItemId, orderId, updateSalesOrderItem, options) {
            return localVarFp.updateSalesOrderItem(orderItemId, orderId, updateSalesOrderItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Release Document
         * @param {string} documentId
         * @param {string} orderId
         * @param {string} releaseId
         * @param {UpdateOrderReleaseDocument} updateOrderReleaseDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderReleaseDocument: function (documentId, orderId, releaseId, updateOrderReleaseDocument, options) {
            return localVarFp.updateSalesOrderReleaseDocument(documentId, orderId, releaseId, updateOrderReleaseDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship From
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipFrom: function (orderId, orderStop, options) {
            return localVarFp.updateSalesOrderShipFrom(orderId, orderStop, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Sales Order Stop Ship To
         * @param {string} orderId
         * @param {OrderStop} orderStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesOrderShipTo: function (orderId, orderStop, options) {
            return localVarFp.updateSalesOrderShipTo(orderId, orderStop, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SalesOrdersApiFactory = SalesOrdersApiFactory;
/**
 * SalesOrdersApi - object-oriented interface
 * @export
 * @class SalesOrdersApi
 * @extends {BaseAPI}
 */
var SalesOrdersApi = /** @class */ (function (_super) {
    __extends(SalesOrdersApi, _super);
    function SalesOrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Cancel Sales Order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.cancelSalesOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).cancelSalesOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Sales Order Document
     * @param {string} orderId
     * @param {any} file
     * @param {string} [description]
     * @param {DocumentType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.createSalesOrderDocument = function (orderId, file, description, type, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).createSalesOrderDocument(orderId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Sales Order Release
     * @param {string} orderId
     * @param {CreateSalesOrderRelease} data
     * @param {CreateDocumentsMetadataSchema} [documentsMetadata]
     * @param {Array<any>} [documents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.createSalesOrderRelease = function (orderId, data, documentsMetadata, documents, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).createSalesOrderRelease(orderId, data, documentsMetadata, documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Sales Order Release Document
     * @param {string} orderId
     * @param {string} releaseId
     * @param {any} file
     * @param {string} [description]
     * @param {DocumentType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.createSalesOrderReleaseDocument = function (orderId, releaseId, file, description, type, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).createSalesOrderReleaseDocument(orderId, releaseId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Sales Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.deleteSalesOrderDocument = function (documentId, orderId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).deleteSalesOrderDocument(documentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Sales Order Release Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {string} releaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.deleteSalesOrderReleaseDocument = function (documentId, orderId, releaseId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).deleteSalesOrderReleaseDocument(documentId, orderId, releaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Sales Order
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.getSalesOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).getSalesOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Sales Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.getSalesOrderDocument = function (documentId, orderId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).getSalesOrderDocument(documentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Sales Order Release
     * @param {string} releaseId
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.getSalesOrderRelease = function (releaseId, orderId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).getSalesOrderRelease(releaseId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Sales Order Release Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {string} releaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.getSalesOrderReleaseDocument = function (documentId, orderId, releaseId, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).getSalesOrderReleaseDocument(documentId, orderId, releaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Documents
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderDocuments = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderDocuments(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Release Documents
     * @param {string} orderId
     * @param {string} releaseId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderReleaseDocuments = function (orderId, releaseId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderReleaseDocuments(orderId, releaseId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Releases
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderReleases = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderReleases(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Transit Details
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderTransitDetails = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderTransitDetails(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Transit Documents
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderTransitDocuments = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderTransitDocuments(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Sales Order Transit Timeline Events
     * @param {string} orderId
     * @param {number} [page]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.listSalesOrderTransitTimelineEvents = function (orderId, page, limit, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).listSalesOrderTransitTimelineEvents(orderId, page, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order
     * @param {string} orderId
     * @param {UpdateEntireSalesOrder} updateEntireSalesOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrder = function (orderId, updateEntireSalesOrder, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrder(orderId, updateEntireSalesOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Details
     * @param {string} orderId
     * @param {UpdateSalesOrder} updateSalesOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderDetails = function (orderId, updateSalesOrder, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderDetails(orderId, updateSalesOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {UpdateProductOrderDocument} updateProductOrderDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderDocument = function (documentId, orderId, updateProductOrderDocument, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderDocument(documentId, orderId, updateProductOrderDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Item
     * @param {string} orderItemId
     * @param {string} orderId
     * @param {UpdateSalesOrderItem} updateSalesOrderItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderItem = function (orderItemId, orderId, updateSalesOrderItem, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderItem(orderItemId, orderId, updateSalesOrderItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Release Document
     * @param {string} documentId
     * @param {string} orderId
     * @param {string} releaseId
     * @param {UpdateOrderReleaseDocument} updateOrderReleaseDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderReleaseDocument = function (documentId, orderId, releaseId, updateOrderReleaseDocument, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderReleaseDocument(documentId, orderId, releaseId, updateOrderReleaseDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Stop Ship From
     * @param {string} orderId
     * @param {OrderStop} orderStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderShipFrom = function (orderId, orderStop, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderShipFrom(orderId, orderStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Sales Order Stop Ship To
     * @param {string} orderId
     * @param {OrderStop} orderStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesOrdersApi
     */
    SalesOrdersApi.prototype.updateSalesOrderShipTo = function (orderId, orderStop, options) {
        var _this = this;
        return (0, exports.SalesOrdersApiFp)(this.configuration).updateSalesOrderShipTo(orderId, orderStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SalesOrdersApi;
}(base_1.BaseAPI));
exports.SalesOrdersApi = SalesOrdersApi;
/**
 * ServicesApi - axios parameter creator
 * @export
 */
var ServicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost: function (oceanTrackingId, createContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'createContact' is not null or undefined
                            (0, common_1.assertParamExists)('createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost', 'createContact', createContact);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/contacts"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Ocean Tracking
         * @param {CreateOceanTracking} createOceanTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingServicesOceanTrackingPost: function (createOceanTracking, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createOceanTracking' is not null or undefined
                            (0, common_1.assertParamExists)('createOceanTrackingServicesOceanTrackingPost', 'createOceanTracking', createOceanTracking);
                            localVarPath = "/services/ocean-tracking";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOceanTracking, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost: function (railTrackingId, createContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost', 'railTrackingId', railTrackingId);
                            // verify required parameter 'createContact' is not null or undefined
                            (0, common_1.assertParamExists)('createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost', 'createContact', createContact);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/contacts"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rail Tracking
         * @param {CreateRailTracking} createRailTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingServicesRailTrackingPost: function (createRailTracking, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createRailTracking' is not null or undefined
                            (0, common_1.assertParamExists)('createRailTrackingServicesRailTrackingPost', 'createRailTracking', createRailTracking);
                            localVarPath = "/services/rail-tracking";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRailTracking, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Service Timeline Event
         * @param {string} serviceId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTimelineEventServicesServiceIdTimelineEventsPost: function (serviceId, createStageTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('createServiceTimelineEventServicesServiceIdTimelineEventsPost', 'serviceId', serviceId);
                            // verify required parameter 'createStageTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('createServiceTimelineEventServicesServiceIdTimelineEventsPost', 'createStageTimelineEvent', createStageTimelineEvent);
                            localVarPath = "/services/{service_id}/timeline-events"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createStageTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Service Tracking Point
         * @param {string} serviceId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTrackingPointServicesServiceIdTrackingPost: function (serviceId, createTrackingPoint, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('createServiceTrackingPointServicesServiceIdTrackingPost', 'serviceId', serviceId);
                            // verify required parameter 'createTrackingPoint' is not null or undefined
                            (0, common_1.assertParamExists)('createServiceTrackingPointServicesServiceIdTrackingPost', 'createTrackingPoint', createTrackingPoint);
                            localVarPath = "/services/{service_id}/tracking"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTrackingPoint, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Storage Service
         * @param {CreateStorage} createStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorageServiceServicesStoragePost: function (createStorage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createStorage' is not null or undefined
                            (0, common_1.assertParamExists)('createStorageServiceServicesStoragePost', 'createStorage', createStorage);
                            localVarPath = "/services/storage";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createStorage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Terminal Fee Service
         * @param {CreateTerminalFee} createTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerminalFeeServiceServicesTerminalFeePost: function (createTerminalFee, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createTerminalFee' is not null or undefined
                            (0, common_1.assertParamExists)('createTerminalFeeServiceServicesTerminalFeePost', 'createTerminalFee', createTerminalFee);
                            localVarPath = "/services/terminal-fee";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTerminalFee, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Transload Service
         * @param {CreateTransload} createTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransloadServiceServicesTransloadPost: function (createTransload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createTransload' is not null or undefined
                            (0, common_1.assertParamExists)('createTransloadServiceServicesTransloadPost', 'createTransload', createTransload);
                            localVarPath = "/services/transload";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTransload, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete: function (oceanTrackingId, contactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete', 'contactId', contactId);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/contacts/{contact_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete: function (oceanTrackingId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/documents/{document_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete: function (railTrackingId, contactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete', 'railTrackingId', railTrackingId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete', 'contactId', contactId);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/contacts/{contact_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete: function (railTrackingId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete', 'railTrackingId', railTrackingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/documents/{document_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete: function (serviceId, timelineEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete', 'serviceId', serviceId);
                            // verify required parameter 'timelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete', 'timelineEventId', timelineEventId);
                            localVarPath = "/services/{service_id}/timeline-events/{timeline_event_id}"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)))
                                .replace("{".concat("timeline_event_id", "}"), encodeURIComponent(String(timelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorageServiceServicesStorageStorageIdDelete: function (storageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'storageId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteStorageServiceServicesStorageStorageIdDelete', 'storageId', storageId);
                            localVarPath = "/services/storage/{storage_id}"
                                .replace("{".concat("storage_id", "}"), encodeURIComponent(String(storageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete: function (terminalFeeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'terminalFeeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete', 'terminalFeeId', terminalFeeId);
                            localVarPath = "/services/terminal-fee/{terminal_fee_id}"
                                .replace("{".concat("terminal_fee_id", "}"), encodeURIComponent(String(terminalFeeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransloadServiceServicesTransloadTransloadIdDelete: function (transloadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transloadId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTransloadServiceServicesTransloadTransloadIdDelete', 'transloadId', transloadId);
                            localVarPath = "/services/transload/{transload_id}"
                                .replace("{".concat("transload_id", "}"), encodeURIComponent(String(transloadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get A Specific Ocean Tracking Object.
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet: function (oceanTrackingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet', 'oceanTrackingId', oceanTrackingId);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get A Specific Rail Tracking Object.
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet: function (railTrackingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet', 'railTrackingId', railTrackingId);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet: function (oceanTrackingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet', 'oceanTrackingId', oceanTrackingId);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/documents"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ocean Tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingServicesOceanTrackingGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/services/ocean-tracking";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet: function (railTrackingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet', 'railTrackingId', railTrackingId);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/documents"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rail Tracking List.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingListServicesRailTrackingGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/services/rail-tracking";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns service timeline events
         * @summary Get Service Timeline Events
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTimelineEventsServicesServiceIdTimelineEventsGet: function (serviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('getServiceTimelineEventsServicesServiceIdTimelineEventsGet', 'serviceId', serviceId);
                            localVarPath = "/services/{service_id}/timeline-events"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Service Tracking Points
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServiceTrackingPointsServicesServiceIdTrackingGet: function (serviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('listServiceTrackingPointsServicesServiceIdTrackingGet', 'serviceId', serviceId);
                            localVarPath = "/services/{service_id}/tracking"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStorageServiceServicesStorageStorageIdGet: function (storageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'storageId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveStorageServiceServicesStorageStorageIdGet', 'storageId', storageId);
                            localVarPath = "/services/storage/{storage_id}"
                                .replace("{".concat("storage_id", "}"), encodeURIComponent(String(storageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet: function (terminalFeeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'terminalFeeId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet', 'terminalFeeId', terminalFeeId);
                            localVarPath = "/services/terminal-fee/{terminal_fee_id}"
                                .replace("{".concat("terminal_fee_id", "}"), encodeURIComponent(String(terminalFeeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTransloadServiceServicesTransloadTransloadIdGet: function (transloadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transloadId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveTransloadServiceServicesTransloadTransloadIdGet', 'transloadId', transloadId);
                            localVarPath = "/services/transload/{transload_id}"
                                .replace("{".concat("transload_id", "}"), encodeURIComponent(String(transloadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut: function (oceanTrackingId, contactId, updateContactDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut', 'contactId', contactId);
                            // verify required parameter 'updateContactDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut', 'updateContactDetail', updateContactDetail);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/contacts/{contact_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateContactDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut: function (oceanTrackingId, documentId, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut', 'documentId', documentId);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/documents/{document_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new URLSearchParams();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.set('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.set('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams.toString();
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking
         * @param {string} oceanTrackingId
         * @param {UpdateOceanTrackingDetail} updateOceanTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut: function (oceanTrackingId, updateOceanTrackingDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'updateOceanTrackingDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut', 'updateOceanTrackingDetail', updateOceanTrackingDetail);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateOceanTrackingDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut: function (railTrackingId, contactId, updateContactDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut', 'railTrackingId', railTrackingId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut', 'contactId', contactId);
                            // verify required parameter 'updateContactDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut', 'updateContactDetail', updateContactDetail);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/contacts/{contact_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateContactDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut: function (railTrackingId, documentId, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut', 'railTrackingId', railTrackingId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut', 'documentId', documentId);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/documents/{document_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new URLSearchParams();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.set('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.set('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams.toString();
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking
         * @param {string} railTrackingId
         * @param {UpdateRailTrackingDetail} updateRailTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingServicesRailTrackingRailTrackingIdPut: function (railTrackingId, updateRailTrackingDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingServicesRailTrackingRailTrackingIdPut', 'railTrackingId', railTrackingId);
                            // verify required parameter 'updateRailTrackingDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateRailTrackingServicesRailTrackingRailTrackingIdPut', 'updateRailTrackingDetail', updateRailTrackingDetail);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateRailTrackingDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {UpdateStageTimelineEvent} updateStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut: function (serviceId, timelineEventId, updateStageTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut', 'serviceId', serviceId);
                            // verify required parameter 'timelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut', 'timelineEventId', timelineEventId);
                            // verify required parameter 'updateStageTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut', 'updateStageTimelineEvent', updateStageTimelineEvent);
                            localVarPath = "/services/{service_id}/timeline-events/{timeline_event_id}"
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)))
                                .replace("{".concat("timeline_event_id", "}"), encodeURIComponent(String(timelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateStageTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Storage Service
         * @param {string} storageId
         * @param {UpdateStorage} updateStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStorageServiceServicesStorageStorageIdPut: function (storageId, updateStorage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'storageId' is not null or undefined
                            (0, common_1.assertParamExists)('updateStorageServiceServicesStorageStorageIdPut', 'storageId', storageId);
                            // verify required parameter 'updateStorage' is not null or undefined
                            (0, common_1.assertParamExists)('updateStorageServiceServicesStorageStorageIdPut', 'updateStorage', updateStorage);
                            localVarPath = "/services/storage/{storage_id}"
                                .replace("{".concat("storage_id", "}"), encodeURIComponent(String(storageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateStorage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {UpdateTerminalFee} updateTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut: function (terminalFeeId, updateTerminalFee, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'terminalFeeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut', 'terminalFeeId', terminalFeeId);
                            // verify required parameter 'updateTerminalFee' is not null or undefined
                            (0, common_1.assertParamExists)('updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut', 'updateTerminalFee', updateTerminalFee);
                            localVarPath = "/services/terminal-fee/{terminal_fee_id}"
                                .replace("{".concat("terminal_fee_id", "}"), encodeURIComponent(String(terminalFeeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTerminalFee, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Transload Service
         * @param {string} transloadId
         * @param {UpdateTransload} updateTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransloadServiceServicesTransloadTransloadIdPut: function (transloadId, updateTransload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transloadId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTransloadServiceServicesTransloadTransloadIdPut', 'transloadId', transloadId);
                            // verify required parameter 'updateTransload' is not null or undefined
                            (0, common_1.assertParamExists)('updateTransloadServiceServicesTransloadTransloadIdPut', 'updateTransload', updateTransload);
                            localVarPath = "/services/transload/{transload_id}"
                                .replace("{".concat("transload_id", "}"), encodeURIComponent(String(transloadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTransload, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost: function (oceanTrackingId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'oceanTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost', 'oceanTrackingId', oceanTrackingId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost', 'file', file);
                            localVarPath = "/services/ocean-tracking/{ocean_tracking_id}/documents"
                                .replace("{".concat("ocean_tracking_id", "}"), encodeURIComponent(String(oceanTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost: function (railTrackingId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'railTrackingId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost', 'railTrackingId', railTrackingId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost', 'file', file);
                            localVarPath = "/services/rail-tracking/{rail_tracking_id}/documents"
                                .replace("{".concat("rail_tracking_id", "}"), encodeURIComponent(String(railTrackingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ServicesApiAxiosParamCreator = ServicesApiAxiosParamCreator;
/**
 * ServicesApi - functional programming interface
 * @export
 */
var ServicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ServicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost: function (oceanTrackingId, createContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost(oceanTrackingId, createContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Ocean Tracking
         * @param {CreateOceanTracking} createOceanTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingServicesOceanTrackingPost: function (createOceanTracking, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOceanTrackingServicesOceanTrackingPost(createOceanTracking, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost: function (railTrackingId, createContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost(railTrackingId, createContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rail Tracking
         * @param {CreateRailTracking} createRailTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingServicesRailTrackingPost: function (createRailTracking, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRailTrackingServicesRailTrackingPost(createRailTracking, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Service Timeline Event
         * @param {string} serviceId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTimelineEventServicesServiceIdTimelineEventsPost: function (serviceId, createStageTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createServiceTimelineEventServicesServiceIdTimelineEventsPost(serviceId, createStageTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Service Tracking Point
         * @param {string} serviceId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTrackingPointServicesServiceIdTrackingPost: function (serviceId, createTrackingPoint, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createServiceTrackingPointServicesServiceIdTrackingPost(serviceId, createTrackingPoint, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Storage Service
         * @param {CreateStorage} createStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorageServiceServicesStoragePost: function (createStorage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createStorageServiceServicesStoragePost(createStorage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Terminal Fee Service
         * @param {CreateTerminalFee} createTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerminalFeeServiceServicesTerminalFeePost: function (createTerminalFee, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTerminalFeeServiceServicesTerminalFeePost(createTerminalFee, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Transload Service
         * @param {CreateTransload} createTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransloadServiceServicesTransloadPost: function (createTransload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTransloadServiceServicesTransloadPost(createTransload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete: function (oceanTrackingId, contactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete(oceanTrackingId, contactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete: function (oceanTrackingId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete(oceanTrackingId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete: function (railTrackingId, contactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete(railTrackingId, contactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete: function (railTrackingId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete(railTrackingId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete: function (serviceId, timelineEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete(serviceId, timelineEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorageServiceServicesStorageStorageIdDelete: function (storageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStorageServiceServicesStorageStorageIdDelete(storageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete: function (terminalFeeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete(terminalFeeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransloadServiceServicesTransloadTransloadIdDelete: function (transloadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTransloadServiceServicesTransloadTransloadIdDelete(transloadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get A Specific Ocean Tracking Object.
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet: function (oceanTrackingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet(oceanTrackingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get A Specific Rail Tracking Object.
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet: function (railTrackingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet(railTrackingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet: function (oceanTrackingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet(oceanTrackingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ocean Tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingServicesOceanTrackingGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOceanTrackingServicesOceanTrackingGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet: function (railTrackingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet(railTrackingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rail Tracking List.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingListServicesRailTrackingGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRailTrackingListServicesRailTrackingGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns service timeline events
         * @summary Get Service Timeline Events
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTimelineEventsServicesServiceIdTimelineEventsGet: function (serviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getServiceTimelineEventsServicesServiceIdTimelineEventsGet(serviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Service Tracking Points
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServiceTrackingPointsServicesServiceIdTrackingGet: function (serviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listServiceTrackingPointsServicesServiceIdTrackingGet(serviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStorageServiceServicesStorageStorageIdGet: function (storageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveStorageServiceServicesStorageStorageIdGet(storageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet: function (terminalFeeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet(terminalFeeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTransloadServiceServicesTransloadTransloadIdGet: function (transloadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveTransloadServiceServicesTransloadTransloadIdGet(transloadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut: function (oceanTrackingId, contactId, updateContactDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut(oceanTrackingId, contactId, updateContactDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut: function (oceanTrackingId, documentId, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut(oceanTrackingId, documentId, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Ocean Tracking
         * @param {string} oceanTrackingId
         * @param {UpdateOceanTrackingDetail} updateOceanTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut: function (oceanTrackingId, updateOceanTrackingDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut(oceanTrackingId, updateOceanTrackingDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut: function (railTrackingId, contactId, updateContactDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut(railTrackingId, contactId, updateContactDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut: function (railTrackingId, documentId, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut(railTrackingId, documentId, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rail Tracking
         * @param {string} railTrackingId
         * @param {UpdateRailTrackingDetail} updateRailTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingServicesRailTrackingRailTrackingIdPut: function (railTrackingId, updateRailTrackingDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateRailTrackingServicesRailTrackingRailTrackingIdPut(railTrackingId, updateRailTrackingDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {UpdateStageTimelineEvent} updateStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut: function (serviceId, timelineEventId, updateStageTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut(serviceId, timelineEventId, updateStageTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Storage Service
         * @param {string} storageId
         * @param {UpdateStorage} updateStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStorageServiceServicesStorageStorageIdPut: function (storageId, updateStorage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateStorageServiceServicesStorageStorageIdPut(storageId, updateStorage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {UpdateTerminalFee} updateTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut: function (terminalFeeId, updateTerminalFee, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut(terminalFeeId, updateTerminalFee, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Transload Service
         * @param {string} transloadId
         * @param {UpdateTransload} updateTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransloadServiceServicesTransloadTransloadIdPut: function (transloadId, updateTransload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTransloadServiceServicesTransloadTransloadIdPut(transloadId, updateTransload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost: function (oceanTrackingId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost(oceanTrackingId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost: function (railTrackingId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost(railTrackingId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ServicesApiFp = ServicesApiFp;
/**
 * ServicesApi - factory interface
 * @export
 */
var ServicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ServicesApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost: function (oceanTrackingId, createContact, options) {
            return localVarFp.createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost(oceanTrackingId, createContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Ocean Tracking
         * @param {CreateOceanTracking} createOceanTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOceanTrackingServicesOceanTrackingPost: function (createOceanTracking, options) {
            return localVarFp.createOceanTrackingServicesOceanTrackingPost(createOceanTracking, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost: function (railTrackingId, createContact, options) {
            return localVarFp.createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost(railTrackingId, createContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Rail Tracking
         * @param {CreateRailTracking} createRailTracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRailTrackingServicesRailTrackingPost: function (createRailTracking, options) {
            return localVarFp.createRailTrackingServicesRailTrackingPost(createRailTracking, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Service Timeline Event
         * @param {string} serviceId
         * @param {CreateStageTimelineEvent} createStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTimelineEventServicesServiceIdTimelineEventsPost: function (serviceId, createStageTimelineEvent, options) {
            return localVarFp.createServiceTimelineEventServicesServiceIdTimelineEventsPost(serviceId, createStageTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Service Tracking Point
         * @param {string} serviceId
         * @param {CreateTrackingPoint} createTrackingPoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceTrackingPointServicesServiceIdTrackingPost: function (serviceId, createTrackingPoint, options) {
            return localVarFp.createServiceTrackingPointServicesServiceIdTrackingPost(serviceId, createTrackingPoint, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Storage Service
         * @param {CreateStorage} createStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStorageServiceServicesStoragePost: function (createStorage, options) {
            return localVarFp.createStorageServiceServicesStoragePost(createStorage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Terminal Fee Service
         * @param {CreateTerminalFee} createTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerminalFeeServiceServicesTerminalFeePost: function (createTerminalFee, options) {
            return localVarFp.createTerminalFeeServiceServicesTerminalFeePost(createTerminalFee, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Transload Service
         * @param {CreateTransload} createTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransloadServiceServicesTransloadPost: function (createTransload, options) {
            return localVarFp.createTransloadServiceServicesTransloadPost(createTransload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete: function (oceanTrackingId, contactId, options) {
            return localVarFp.deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete(oceanTrackingId, contactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete: function (oceanTrackingId, documentId, options) {
            return localVarFp.deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete(oceanTrackingId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete: function (railTrackingId, contactId, options) {
            return localVarFp.deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete(railTrackingId, contactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete: function (railTrackingId, documentId, options) {
            return localVarFp.deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete(railTrackingId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete: function (serviceId, timelineEventId, options) {
            return localVarFp.deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete(serviceId, timelineEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStorageServiceServicesStorageStorageIdDelete: function (storageId, options) {
            return localVarFp.deleteStorageServiceServicesStorageStorageIdDelete(storageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete: function (terminalFeeId, options) {
            return localVarFp.deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete(terminalFeeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransloadServiceServicesTransloadTransloadIdDelete: function (transloadId, options) {
            return localVarFp.deleteTransloadServiceServicesTransloadTransloadIdDelete(transloadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get A Specific Ocean Tracking Object.
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet: function (oceanTrackingId, options) {
            return localVarFp.getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet(oceanTrackingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get A Specific Rail Tracking Object.
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet: function (railTrackingId, options) {
            return localVarFp.getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet(railTrackingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet: function (oceanTrackingId, options) {
            return localVarFp.getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet(oceanTrackingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Ocean Tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOceanTrackingServicesOceanTrackingGet: function (options) {
            return localVarFp.getOceanTrackingServicesOceanTrackingGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet: function (railTrackingId, options) {
            return localVarFp.getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet(railTrackingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rail Tracking List.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRailTrackingListServicesRailTrackingGet: function (options) {
            return localVarFp.getRailTrackingListServicesRailTrackingGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns service timeline events
         * @summary Get Service Timeline Events
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTimelineEventsServicesServiceIdTimelineEventsGet: function (serviceId, options) {
            return localVarFp.getServiceTimelineEventsServicesServiceIdTimelineEventsGet(serviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Service Tracking Points
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServiceTrackingPointsServicesServiceIdTrackingGet: function (serviceId, options) {
            return localVarFp.listServiceTrackingPointsServicesServiceIdTrackingGet(serviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Storage Service
         * @param {string} storageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStorageServiceServicesStorageStorageIdGet: function (storageId, options) {
            return localVarFp.retrieveStorageServiceServicesStorageStorageIdGet(storageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet: function (terminalFeeId, options) {
            return localVarFp.retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet(terminalFeeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Transload Service
         * @param {string} transloadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTransloadServiceServicesTransloadTransloadIdGet: function (transloadId, options) {
            return localVarFp.retrieveTransloadServiceServicesTransloadTransloadIdGet(transloadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Ocean Tracking Contact
         * @param {string} oceanTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut: function (oceanTrackingId, contactId, updateContactDetail, options) {
            return localVarFp.updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut(oceanTrackingId, contactId, updateContactDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Ocean Tracking Document
         * @param {string} oceanTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut: function (oceanTrackingId, documentId, description, type, options) {
            return localVarFp.updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut(oceanTrackingId, documentId, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Ocean Tracking
         * @param {string} oceanTrackingId
         * @param {UpdateOceanTrackingDetail} updateOceanTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut: function (oceanTrackingId, updateOceanTrackingDetail, options) {
            return localVarFp.updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut(oceanTrackingId, updateOceanTrackingDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Rail Tracking Contact
         * @param {string} railTrackingId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut: function (railTrackingId, contactId, updateContactDetail, options) {
            return localVarFp.updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut(railTrackingId, contactId, updateContactDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Rail Tracking Document
         * @param {string} railTrackingId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut: function (railTrackingId, documentId, description, type, options) {
            return localVarFp.updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut(railTrackingId, documentId, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Rail Tracking
         * @param {string} railTrackingId
         * @param {UpdateRailTrackingDetail} updateRailTrackingDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRailTrackingServicesRailTrackingRailTrackingIdPut: function (railTrackingId, updateRailTrackingDetail, options) {
            return localVarFp.updateRailTrackingServicesRailTrackingRailTrackingIdPut(railTrackingId, updateRailTrackingDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Service Timeline Event
         * @param {string} serviceId
         * @param {string} timelineEventId
         * @param {UpdateStageTimelineEvent} updateStageTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut: function (serviceId, timelineEventId, updateStageTimelineEvent, options) {
            return localVarFp.updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut(serviceId, timelineEventId, updateStageTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Storage Service
         * @param {string} storageId
         * @param {UpdateStorage} updateStorage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStorageServiceServicesStorageStorageIdPut: function (storageId, updateStorage, options) {
            return localVarFp.updateStorageServiceServicesStorageStorageIdPut(storageId, updateStorage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Terminal Fee Service
         * @param {string} terminalFeeId
         * @param {UpdateTerminalFee} updateTerminalFee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut: function (terminalFeeId, updateTerminalFee, options) {
            return localVarFp.updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut(terminalFeeId, updateTerminalFee, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Transload Service
         * @param {string} transloadId
         * @param {UpdateTransload} updateTransload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransloadServiceServicesTransloadTransloadIdPut: function (transloadId, updateTransload, options) {
            return localVarFp.updateTransloadServiceServicesTransloadTransloadIdPut(transloadId, updateTransload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload Ocean Tracking Documents
         * @param {string} oceanTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost: function (oceanTrackingId, file, description, type, options) {
            return localVarFp.uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost(oceanTrackingId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload Rail Tracking Documents
         * @param {string} railTrackingId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost: function (railTrackingId, file, description, type, options) {
            return localVarFp.uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost(railTrackingId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ServicesApiFactory = ServicesApiFactory;
/**
 * ServicesApi - object-oriented interface
 * @export
 * @class ServicesApi
 * @extends {BaseAPI}
 */
var ServicesApi = /** @class */ (function (_super) {
    __extends(ServicesApi, _super);
    function ServicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Ocean Tracking Contact
     * @param {string} oceanTrackingId
     * @param {CreateContact} createContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost = function (oceanTrackingId, createContact, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsPost(oceanTrackingId, createContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Ocean Tracking
     * @param {CreateOceanTracking} createOceanTracking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createOceanTrackingServicesOceanTrackingPost = function (createOceanTracking, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createOceanTrackingServicesOceanTrackingPost(createOceanTracking, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Rail Tracking Contact
     * @param {string} railTrackingId
     * @param {CreateContact} createContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost = function (railTrackingId, createContact, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createRailTrackingContactServicesRailTrackingRailTrackingIdContactsPost(railTrackingId, createContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Rail Tracking
     * @param {CreateRailTracking} createRailTracking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createRailTrackingServicesRailTrackingPost = function (createRailTracking, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createRailTrackingServicesRailTrackingPost(createRailTracking, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Service Timeline Event
     * @param {string} serviceId
     * @param {CreateStageTimelineEvent} createStageTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createServiceTimelineEventServicesServiceIdTimelineEventsPost = function (serviceId, createStageTimelineEvent, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createServiceTimelineEventServicesServiceIdTimelineEventsPost(serviceId, createStageTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Service Tracking Point
     * @param {string} serviceId
     * @param {CreateTrackingPoint} createTrackingPoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createServiceTrackingPointServicesServiceIdTrackingPost = function (serviceId, createTrackingPoint, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createServiceTrackingPointServicesServiceIdTrackingPost(serviceId, createTrackingPoint, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Storage Service
     * @param {CreateStorage} createStorage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createStorageServiceServicesStoragePost = function (createStorage, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createStorageServiceServicesStoragePost(createStorage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Terminal Fee Service
     * @param {CreateTerminalFee} createTerminalFee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createTerminalFeeServiceServicesTerminalFeePost = function (createTerminalFee, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createTerminalFeeServiceServicesTerminalFeePost(createTerminalFee, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Transload Service
     * @param {CreateTransload} createTransload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.createTransloadServiceServicesTransloadPost = function (createTransload, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).createTransloadServiceServicesTransloadPost(createTransload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Ocean Tracking Contact
     * @param {string} oceanTrackingId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete = function (oceanTrackingId, contactId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdDelete(oceanTrackingId, contactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Ocean Tracking Document
     * @param {string} oceanTrackingId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete = function (oceanTrackingId, documentId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdDelete(oceanTrackingId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Rail Tracking Contact
     * @param {string} railTrackingId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete = function (railTrackingId, contactId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdDelete(railTrackingId, contactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Rail Tracking Document
     * @param {string} railTrackingId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete = function (railTrackingId, documentId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdDelete(railTrackingId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Service Timeline Event
     * @param {string} serviceId
     * @param {string} timelineEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete = function (serviceId, timelineEventId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdDelete(serviceId, timelineEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Storage Service
     * @param {string} storageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteStorageServiceServicesStorageStorageIdDelete = function (storageId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteStorageServiceServicesStorageStorageIdDelete(storageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Terminal Fee Service
     * @param {string} terminalFeeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete = function (terminalFeeId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteTerminalFeeServiceServicesTerminalFeeTerminalFeeIdDelete(terminalFeeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Transload Service
     * @param {string} transloadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.deleteTransloadServiceServicesTransloadTransloadIdDelete = function (transloadId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).deleteTransloadServiceServicesTransloadTransloadIdDelete(transloadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get A Specific Ocean Tracking Object.
     * @param {string} oceanTrackingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet = function (oceanTrackingId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getASpecificOceanTrackingObjectServicesOceanTrackingOceanTrackingIdGet(oceanTrackingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get A Specific Rail Tracking Object.
     * @param {string} railTrackingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet = function (railTrackingId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getASpecificRailTrackingObjectServicesRailTrackingRailTrackingIdGet(railTrackingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Ocean Tracking Documents
     * @param {string} oceanTrackingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet = function (oceanTrackingId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsGet(oceanTrackingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Ocean Tracking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getOceanTrackingServicesOceanTrackingGet = function (options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getOceanTrackingServicesOceanTrackingGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rail Tracking Documents
     * @param {string} railTrackingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet = function (railTrackingId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsGet(railTrackingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rail Tracking List.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getRailTrackingListServicesRailTrackingGet = function (options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getRailTrackingListServicesRailTrackingGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns service timeline events
     * @summary Get Service Timeline Events
     * @param {string} serviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.getServiceTimelineEventsServicesServiceIdTimelineEventsGet = function (serviceId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).getServiceTimelineEventsServicesServiceIdTimelineEventsGet(serviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Service Tracking Points
     * @param {string} serviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.listServiceTrackingPointsServicesServiceIdTrackingGet = function (serviceId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).listServiceTrackingPointsServicesServiceIdTrackingGet(serviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Storage Service
     * @param {string} storageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.retrieveStorageServiceServicesStorageStorageIdGet = function (storageId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).retrieveStorageServiceServicesStorageStorageIdGet(storageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Terminal Fee Service
     * @param {string} terminalFeeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet = function (terminalFeeId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).retrieveTerminalFeeServiceServicesTerminalFeeTerminalFeeIdGet(terminalFeeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Transload Service
     * @param {string} transloadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.retrieveTransloadServiceServicesTransloadTransloadIdGet = function (transloadId, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).retrieveTransloadServiceServicesTransloadTransloadIdGet(transloadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Ocean Tracking Contact
     * @param {string} oceanTrackingId
     * @param {string} contactId
     * @param {UpdateContactDetail} updateContactDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut = function (oceanTrackingId, contactId, updateContactDetail, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateOceanTrackingContactServicesOceanTrackingOceanTrackingIdContactsContactIdPut(oceanTrackingId, contactId, updateContactDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Ocean Tracking Document
     * @param {string} oceanTrackingId
     * @param {string} documentId
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut = function (oceanTrackingId, documentId, description, type, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateOceanTrackingDocumentServicesOceanTrackingOceanTrackingIdDocumentsDocumentIdPut(oceanTrackingId, documentId, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Ocean Tracking
     * @param {string} oceanTrackingId
     * @param {UpdateOceanTrackingDetail} updateOceanTrackingDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut = function (oceanTrackingId, updateOceanTrackingDetail, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateOceanTrackingServicesOceanTrackingOceanTrackingIdPut(oceanTrackingId, updateOceanTrackingDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Rail Tracking Contact
     * @param {string} railTrackingId
     * @param {string} contactId
     * @param {UpdateContactDetail} updateContactDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut = function (railTrackingId, contactId, updateContactDetail, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateRailTrackingContactServicesRailTrackingRailTrackingIdContactsContactIdPut(railTrackingId, contactId, updateContactDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Rail Tracking Document
     * @param {string} railTrackingId
     * @param {string} documentId
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut = function (railTrackingId, documentId, description, type, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateRailTrackingDocumentServicesRailTrackingRailTrackingIdDocumentsDocumentIdPut(railTrackingId, documentId, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Rail Tracking
     * @param {string} railTrackingId
     * @param {UpdateRailTrackingDetail} updateRailTrackingDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateRailTrackingServicesRailTrackingRailTrackingIdPut = function (railTrackingId, updateRailTrackingDetail, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateRailTrackingServicesRailTrackingRailTrackingIdPut(railTrackingId, updateRailTrackingDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Service Timeline Event
     * @param {string} serviceId
     * @param {string} timelineEventId
     * @param {UpdateStageTimelineEvent} updateStageTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut = function (serviceId, timelineEventId, updateStageTimelineEvent, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateServiceTimelineEventServicesServiceIdTimelineEventsTimelineEventIdPut(serviceId, timelineEventId, updateStageTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Storage Service
     * @param {string} storageId
     * @param {UpdateStorage} updateStorage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateStorageServiceServicesStorageStorageIdPut = function (storageId, updateStorage, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateStorageServiceServicesStorageStorageIdPut(storageId, updateStorage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Terminal Fee Service
     * @param {string} terminalFeeId
     * @param {UpdateTerminalFee} updateTerminalFee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut = function (terminalFeeId, updateTerminalFee, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateTerminalFeeServiceServicesTerminalFeeTerminalFeeIdPut(terminalFeeId, updateTerminalFee, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Transload Service
     * @param {string} transloadId
     * @param {UpdateTransload} updateTransload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.updateTransloadServiceServicesTransloadTransloadIdPut = function (transloadId, updateTransload, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).updateTransloadServiceServicesTransloadTransloadIdPut(transloadId, updateTransload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload Ocean Tracking Documents
     * @param {string} oceanTrackingId
     * @param {any} file
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost = function (oceanTrackingId, file, description, type, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).uploadOceanTrackingDocumentsServicesOceanTrackingOceanTrackingIdDocumentsPost(oceanTrackingId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload Rail Tracking Documents
     * @param {string} railTrackingId
     * @param {any} file
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesApi
     */
    ServicesApi.prototype.uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost = function (railTrackingId, file, description, type, options) {
        var _this = this;
        return (0, exports.ServicesApiFp)(this.configuration).uploadRailTrackingDocumentsServicesRailTrackingRailTrackingIdDocumentsPost(railTrackingId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ServicesApi;
}(base_1.BaseAPI));
exports.ServicesApi = ServicesApi;
/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
var ShipmentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Archive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveShipmentsShipmentIdArchivePost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('archiveShipmentsShipmentIdArchivePost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/archive"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Assign Service To Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {AssociateServiceToShipmentRequest} associateServiceToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost: function (shipmentId, serviceId, associateServiceToShipmentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost', 'shipmentId', shipmentId);
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost', 'serviceId', serviceId);
                            // verify required parameter 'associateServiceToShipmentRequest' is not null or undefined
                            (0, common_1.assertParamExists)('assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost', 'associateServiceToShipmentRequest', associateServiceToShipmentRequest);
                            localVarPath = "/shipments/{shipment_id}/services/{service_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(associateServiceToShipmentRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates association Leg to Shipment
         * @summary Associate Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {AssociateLegToShipmentRequest} associateLegToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateLegToShipmentShipmentsShipmentIdLegsLegIdPost: function (shipmentId, legId, associateLegToShipmentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('associateLegToShipmentShipmentsShipmentIdLegsLegIdPost', 'shipmentId', shipmentId);
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('associateLegToShipmentShipmentsShipmentIdLegsLegIdPost', 'legId', legId);
                            // verify required parameter 'associateLegToShipmentRequest' is not null or undefined
                            (0, common_1.assertParamExists)('associateLegToShipmentShipmentsShipmentIdLegsLegIdPost', 'associateLegToShipmentRequest', associateLegToShipmentRequest);
                            localVarPath = "/shipments/{shipment_id}/legs/{leg_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(associateLegToShipmentRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} shipmentId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsShipmentsShipmentIdContactsPost: function (shipmentId, createContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createContactsShipmentsShipmentIdContactsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createContact' is not null or undefined
                            (0, common_1.assertParamExists)('createContactsShipmentsShipmentIdContactsPost', 'createContact', createContact);
                            localVarPath = "/shipments/{shipment_id}/contacts"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Legs From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/create-drayage-legs"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {CreateLegacyShipmentStage} createLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost: function (shipmentId, createLegacyShipmentStage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createLegacyShipmentStage' is not null or undefined
                            (0, common_1.assertParamExists)('createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost', 'createLegacyShipmentStage', createLegacyShipmentStage);
                            localVarPath = "/shipments/{shipment_id}/legacy-shipment-stages"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLegacyShipmentStage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Order From Shipment
         * @param {string} shipmentId
         * @param {CreateOrderFromShipmentRequest} createOrderFromShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFromShipmentShipmentsShipmentIdOrdersPost: function (shipmentId, createOrderFromShipmentRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createOrderFromShipmentShipmentsShipmentIdOrdersPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createOrderFromShipmentRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createOrderFromShipmentShipmentsShipmentIdOrdersPost', 'createOrderFromShipmentRequest', createOrderFromShipmentRequest);
                            localVarPath = "/shipments/{shipment_id}/orders"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOrderFromShipmentRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new Shipment Item for a Shipment
         * @summary Create Shipment Item
         * @param {string} shipmentId
         * @param {CreateShipmentItemRequest} createShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentItemShipmentsShipmentIdItemsPost: function (shipmentId, createShipmentItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createShipmentItemShipmentsShipmentIdItemsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createShipmentItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createShipmentItemShipmentsShipmentIdItemsPost', 'createShipmentItemRequest', createShipmentItemRequest);
                            localVarPath = "/shipments/{shipment_id}/items"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Shipment Note
         * @param {string} shipmentId
         * @param {CreateShipmentNote} createShipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentNoteShipmentsShipmentIdNotesPost: function (shipmentId, createShipmentNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createShipmentNoteShipmentsShipmentIdNotesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createShipmentNote' is not null or undefined
                            (0, common_1.assertParamExists)('createShipmentNoteShipmentsShipmentIdNotesPost', 'createShipmentNote', createShipmentNote);
                            localVarPath = "/shipments/{shipment_id}/notes"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new Shipment
         * @summary Create Shipment
         * @param {CreateShipment} [createShipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentShipmentsPost: function (createShipment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Timeline Event
         * @param {string} shipmentId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimelineEventShipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('createTimelineEventShipmentsShipmentIdTimelineEventsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createShipmentTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('createTimelineEventShipmentsShipmentIdTimelineEventsPost', 'createShipmentTimelineEvent', createShipmentTimelineEvent);
                            localVarPath = "/shipments/{shipment_id}/timeline-events"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete: function (shipmentId, stageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'stageId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete', 'stageId', stageId);
                            localVarPath = "/shipments/{shipment_id}/legacy-shipment-stages/{stage_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stage_id", "}"), encodeURIComponent(String(stageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Contact
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete: function (shipmentId, contactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete', 'contactId', contactId);
                            localVarPath = "/shipments/{shipment_id}/contacts/{contact_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/shipments/{shipment_id}/documents/{document_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipment_id}/notes/{shipment_note_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_note_id", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deleting a Shipment stage will also delete the object (Leg, Service, etc.) on this Stage
         * @summary Delete Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete: function (shipmentId, stageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'stageId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete', 'stageId', stageId);
                            localVarPath = "/shipments/{shipment_id}/stages/{stage_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stage_id", "}"), encodeURIComponent(String(stageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Stop Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete: function (shipmentId, sequenceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete', 'sequenceId', sequenceId);
                            localVarPath = "/shipments/{shipment_id}/stops/{sequence_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete: function (shipmentId, timelineEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'timelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete', 'timelineEventId', timelineEventId);
                            localVarPath = "/shipments/{shipment_id}/timeline-events/{timeline_event_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("timeline_event_id", "}"), encodeURIComponent(String(timelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific BOL from the specified Shipment
         * @summary Generate Bol From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/documents/generate-bol"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns Drayage Transportation Orders associated to a Shipment
         * @summary Get Drayage Transportation Orders Associated To Shipment
         * @param {string} shipmentId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet: function (shipmentId, skip, limit, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/transportation-orders/drayage"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns Legs associated to Shipment
         * @summary Get Legs Associated To Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/legs"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Documents
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDocumentsShipmentsShipmentIdDocumentsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentDocumentsShipmentsShipmentIdDocumentsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/documents"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves all the ShipmentItems for a Shipment
         * @summary Get Shipment Items
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentItemsShipmentsShipmentIdItemsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentItemsShipmentsShipmentIdItemsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/items"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipment_id}/notes/{shipment_note_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_note_id", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Notes
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNotesShipmentsShipmentIdNotesGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentNotesShipmentsShipmentIdNotesGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/notes"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the details for a single Shipment
         * @summary Get Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentShipmentsShipmentIdGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentShipmentsShipmentIdGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Timeline Events
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/timeline-events/summary"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets all stages associated with a shipment. Useful for determining if a given resource id is associated with a shipment or not via a stage
         * @summary Get Stages
         * @param {Array<string>} transportationDetailIds Transportation detail id that this stage is linked to, like a leg id, service id, etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStagesShipmentsStagesGet: function (transportationDetailIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationDetailIds' is not null or undefined
                            (0, common_1.assertParamExists)('getStagesShipmentsStagesGet', 'transportationDetailIds', transportationDetailIds);
                            localVarPath = "/shipments/stages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (transportationDetailIds) {
                                localVarQueryParameter['transportation_detail_ids'] = transportationDetailIds;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Tracking Summary
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/tracking/summary"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Shipment Stages
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmentStagesShipmentsShipmentIdStagesGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('listShipmentStagesShipmentsShipmentIdStagesGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/stages"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Pin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipment_id}/notes/{shipment_note_id}/pin"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_note_id", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Removes association Leg to Shipment
         * @summary Remove Association Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete: function (shipmentId, legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete', 'legId', legId);
                            localVarPath = "/shipments/{shipment_id}/legs/{leg_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("leg_id", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet: function (shipmentId, stageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'stageId' is not null or undefined
                            (0, common_1.assertParamExists)('retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet', 'stageId', stageId);
                            localVarPath = "/shipments/{shipment_id}/stages/{stage_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stage_id", "}"), encodeURIComponent(String(stageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unarchive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveShipmentsShipmentIdUnarchivePost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('unarchiveShipmentsShipmentIdUnarchivePost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/unarchive"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unassign Service From Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete: function (shipmentId, serviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'serviceId' is not null or undefined
                            (0, common_1.assertParamExists)('unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete', 'serviceId', serviceId);
                            localVarPath = "/shipments/{shipment_id}/services/{service_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("service_id", "}"), encodeURIComponent(String(serviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unpin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipment_id}/notes/{shipment_note_id}/unpin"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_note_id", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Leg Stops
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegStopsShipmentsShipmentIdUpdateLegStopsPut: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegStopsShipmentsShipmentIdUpdateLegStopsPut', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipment_id}/update-leg-stops"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {UpdateLegacyShipmentStage} updateLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut: function (shipmentId, stageId, updateLegacyShipmentStage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'stageId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut', 'stageId', stageId);
                            // verify required parameter 'updateLegacyShipmentStage' is not null or undefined
                            (0, common_1.assertParamExists)('updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut', 'updateLegacyShipmentStage', updateLegacyShipmentStage);
                            localVarPath = "/shipments/{shipment_id}/legacy-shipment-stages/{stage_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stage_id", "}"), encodeURIComponent(String(stageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLegacyShipmentStage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Mode Specific Data Drayage
         * @param {string} shipmentId
         * @param {DrayageShipmentModeSpecificData} drayageShipmentModeSpecificData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut: function (shipmentId, drayageShipmentModeSpecificData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut', 'shipmentId', shipmentId);
                            // verify required parameter 'drayageShipmentModeSpecificData' is not null or undefined
                            (0, common_1.assertParamExists)('updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut', 'drayageShipmentModeSpecificData', drayageShipmentModeSpecificData);
                            localVarPath = "/shipments/{shipment_id}/mode-specific-data/drayage"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(drayageShipmentModeSpecificData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Contact Detail
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut: function (shipmentId, contactId, updateContactDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'contactId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut', 'contactId', contactId);
                            // verify required parameter 'updateContactDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut', 'updateContactDetail', updateContactDetail);
                            localVarPath = "/shipments/{shipment_id}/contacts/{contact_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("contact_id", "}"), encodeURIComponent(String(contactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateContactDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut', 'documentId', documentId);
                            localVarPath = "/shipments/{shipment_id}/documents/{document_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new URLSearchParams();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.set('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.set('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams.toString();
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates an existing Shipment Item
         * @summary Update Shipment Item
         * @param {string} shipmentId
         * @param {string} shipmentItemId
         * @param {UpdateShipmentItemRequest} updateShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut: function (shipmentId, shipmentItemId, updateShipmentItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentItemId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut', 'shipmentItemId', shipmentItemId);
                            // verify required parameter 'updateShipmentItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut', 'updateShipmentItemRequest', updateShipmentItemRequest);
                            localVarPath = "/shipments/{shipment_id}/items/{shipment_item_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_item_id", "}"), encodeURIComponent(String(shipmentItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {UpdateShipmentNoteDetail} updateShipmentNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, updateShipmentNoteDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut', 'shipmentNoteId', shipmentNoteId);
                            // verify required parameter 'updateShipmentNoteDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut', 'updateShipmentNoteDetail', updateShipmentNoteDetail);
                            localVarPath = "/shipments/{shipment_id}/notes/{shipment_note_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipment_note_id", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentNoteDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment References
         * @param {string} shipmentId
         * @param {UpdateShipmentReferences} updateShipmentReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentReferencesShipmentsShipmentIdReferencesPut: function (shipmentId, updateShipmentReferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentReferencesShipmentsShipmentIdReferencesPut', 'shipmentId', shipmentId);
                            // verify required parameter 'updateShipmentReferences' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentReferencesShipmentsShipmentIdReferencesPut', 'updateShipmentReferences', updateShipmentReferences);
                            localVarPath = "/shipments/{shipment_id}/references"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentReferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stage Dependencies
         * @param {string} shipmentId
         * @param {UpdateShipmentStageDependenciesRequest} updateShipmentStageDependenciesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut: function (shipmentId, updateShipmentStageDependenciesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut', 'shipmentId', shipmentId);
                            // verify required parameter 'updateShipmentStageDependenciesRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut', 'updateShipmentStageDependenciesRequest', updateShipmentStageDependenciesRequest);
                            localVarPath = "/shipments/{shipment_id}/stages/dependencies"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentStageDependenciesRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stops Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {UpdateStop} updateStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut: function (shipmentId, sequenceId, updateStop, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'sequenceId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut', 'sequenceId', sequenceId);
                            // verify required parameter 'updateStop' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut', 'updateStop', updateStop);
                            localVarPath = "/shipments/{shipment_id}/stops/{sequence_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("sequence_id", "}"), encodeURIComponent(String(sequenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateStop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stops
         * @param {string} shipmentId
         * @param {UpdateStopsRequest} updateStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsShipmentsShipmentIdStopsPut: function (shipmentId, updateStopsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStopsShipmentsShipmentIdStopsPut', 'shipmentId', shipmentId);
                            // verify required parameter 'updateStopsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentStopsShipmentsShipmentIdStopsPut', 'updateStopsRequest', updateStopsRequest);
                            localVarPath = "/shipments/{shipment_id}/stops"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateStopsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Summary
         * @param {string} shipmentId
         * @param {UpdateShipmentSummary} updateShipmentSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentSummaryShipmentsShipmentIdSummaryPut: function (shipmentId, updateShipmentSummary, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentSummaryShipmentsShipmentIdSummaryPut', 'shipmentId', shipmentId);
                            // verify required parameter 'updateShipmentSummary' is not null or undefined
                            (0, common_1.assertParamExists)('updateShipmentSummaryShipmentsShipmentIdSummaryPut', 'updateShipmentSummary', updateShipmentSummary);
                            localVarPath = "/shipments/{shipment_id}/summary"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentSummary, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {UpdateShipmentTimelineEvent} updateShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut: function (shipmentId, timelineEventId, updateShipmentTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'timelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut', 'timelineEventId', timelineEventId);
                            // verify required parameter 'updateShipmentTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut', 'updateShipmentTimelineEvent', updateShipmentTimelineEvent);
                            localVarPath = "/shipments/{shipment_id}/timeline-events/{timeline_event_id}"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("timeline_event_id", "}"), encodeURIComponent(String(timelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Shipment Documents
         * @param {string} shipmentId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost: function (shipmentId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost', 'file', file);
                            localVarPath = "/shipments/{shipment_id}/documents"
                                .replace("{".concat("shipment_id", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipmentsApiAxiosParamCreator = ShipmentsApiAxiosParamCreator;
/**
 * ShipmentsApi - functional programming interface
 * @export
 */
var ShipmentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipmentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Archive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveShipmentsShipmentIdArchivePost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.archiveShipmentsShipmentIdArchivePost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Assign Service To Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {AssociateServiceToShipmentRequest} associateServiceToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost: function (shipmentId, serviceId, associateServiceToShipmentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost(shipmentId, serviceId, associateServiceToShipmentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates association Leg to Shipment
         * @summary Associate Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {AssociateLegToShipmentRequest} associateLegToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateLegToShipmentShipmentsShipmentIdLegsLegIdPost: function (shipmentId, legId, associateLegToShipmentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.associateLegToShipmentShipmentsShipmentIdLegsLegIdPost(shipmentId, legId, associateLegToShipmentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} shipmentId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsShipmentsShipmentIdContactsPost: function (shipmentId, createContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createContactsShipmentsShipmentIdContactsPost(shipmentId, createContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Drayage Legs From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {CreateLegacyShipmentStage} createLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost: function (shipmentId, createLegacyShipmentStage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost(shipmentId, createLegacyShipmentStage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Order From Shipment
         * @param {string} shipmentId
         * @param {CreateOrderFromShipmentRequest} createOrderFromShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFromShipmentShipmentsShipmentIdOrdersPost: function (shipmentId, createOrderFromShipmentRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrderFromShipmentShipmentsShipmentIdOrdersPost(shipmentId, createOrderFromShipmentRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new Shipment Item for a Shipment
         * @summary Create Shipment Item
         * @param {string} shipmentId
         * @param {CreateShipmentItemRequest} createShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentItemShipmentsShipmentIdItemsPost: function (shipmentId, createShipmentItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShipmentItemShipmentsShipmentIdItemsPost(shipmentId, createShipmentItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Shipment Note
         * @param {string} shipmentId
         * @param {CreateShipmentNote} createShipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentNoteShipmentsShipmentIdNotesPost: function (shipmentId, createShipmentNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShipmentNoteShipmentsShipmentIdNotesPost(shipmentId, createShipmentNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new Shipment
         * @summary Create Shipment
         * @param {CreateShipment} [createShipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentShipmentsPost: function (createShipment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShipmentShipmentsPost(createShipment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Timeline Event
         * @param {string} shipmentId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimelineEventShipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTimelineEventShipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete: function (shipmentId, stageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete(shipmentId, stageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Contact
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete: function (shipmentId, contactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete(shipmentId, contactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deleting a Shipment stage will also delete the object (Leg, Service, etc.) on this Stage
         * @summary Delete Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete: function (shipmentId, stageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete(shipmentId, stageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Shipment Stop Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete: function (shipmentId, sequenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete(shipmentId, sequenceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete: function (shipmentId, timelineEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete(shipmentId, timelineEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific BOL from the specified Shipment
         * @summary Generate Bol From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns Drayage Transportation Orders associated to a Shipment
         * @summary Get Drayage Transportation Orders Associated To Shipment
         * @param {string} shipmentId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet: function (shipmentId, skip, limit, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet(shipmentId, skip, limit, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns Legs associated to Shipment
         * @summary Get Legs Associated To Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Documents
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDocumentsShipmentsShipmentIdDocumentsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentDocumentsShipmentsShipmentIdDocumentsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all the ShipmentItems for a Shipment
         * @summary Get Shipment Items
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentItemsShipmentsShipmentIdItemsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentItemsShipmentsShipmentIdItemsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Notes
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNotesShipmentsShipmentIdNotesGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentNotesShipmentsShipmentIdNotesGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the details for a single Shipment
         * @summary Get Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentShipmentsShipmentIdGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentShipmentsShipmentIdGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Shipment Timeline Events
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets all stages associated with a shipment. Useful for determining if a given resource id is associated with a shipment or not via a stage
         * @summary Get Stages
         * @param {Array<string>} transportationDetailIds Transportation detail id that this stage is linked to, like a leg id, service id, etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStagesShipmentsStagesGet: function (transportationDetailIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStagesShipmentsStagesGet(transportationDetailIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Tracking Summary
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Shipment Stages
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmentStagesShipmentsShipmentIdStagesGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listShipmentStagesShipmentsShipmentIdStagesGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Pin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Removes association Leg to Shipment
         * @summary Remove Association Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete: function (shipmentId, legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete(shipmentId, legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet: function (shipmentId, stageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet(shipmentId, stageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unarchive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveShipmentsShipmentIdUnarchivePost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unarchiveShipmentsShipmentIdUnarchivePost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unassign Service From Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete: function (shipmentId, serviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete(shipmentId, serviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unpin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Leg Stops
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegStopsShipmentsShipmentIdUpdateLegStopsPut: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLegStopsShipmentsShipmentIdUpdateLegStopsPut(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {UpdateLegacyShipmentStage} updateLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut: function (shipmentId, stageId, updateLegacyShipmentStage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut(shipmentId, stageId, updateLegacyShipmentStage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Mode Specific Data Drayage
         * @param {string} shipmentId
         * @param {DrayageShipmentModeSpecificData} drayageShipmentModeSpecificData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut: function (shipmentId, drayageShipmentModeSpecificData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut(shipmentId, drayageShipmentModeSpecificData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Contact Detail
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut: function (shipmentId, contactId, updateContactDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut(shipmentId, contactId, updateContactDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates an existing Shipment Item
         * @summary Update Shipment Item
         * @param {string} shipmentId
         * @param {string} shipmentItemId
         * @param {UpdateShipmentItemRequest} updateShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut: function (shipmentId, shipmentItemId, updateShipmentItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut(shipmentId, shipmentItemId, updateShipmentItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {UpdateShipmentNoteDetail} updateShipmentNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, updateShipmentNoteDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, updateShipmentNoteDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment References
         * @param {string} shipmentId
         * @param {UpdateShipmentReferences} updateShipmentReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentReferencesShipmentsShipmentIdReferencesPut: function (shipmentId, updateShipmentReferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentReferencesShipmentsShipmentIdReferencesPut(shipmentId, updateShipmentReferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stage Dependencies
         * @param {string} shipmentId
         * @param {UpdateShipmentStageDependenciesRequest} updateShipmentStageDependenciesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut: function (shipmentId, updateShipmentStageDependenciesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut(shipmentId, updateShipmentStageDependenciesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stops Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {UpdateStop} updateStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut: function (shipmentId, sequenceId, updateStop, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut(shipmentId, sequenceId, updateStop, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Stops
         * @param {string} shipmentId
         * @param {UpdateStopsRequest} updateStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsShipmentsShipmentIdStopsPut: function (shipmentId, updateStopsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentStopsShipmentsShipmentIdStopsPut(shipmentId, updateStopsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Shipment Summary
         * @param {string} shipmentId
         * @param {UpdateShipmentSummary} updateShipmentSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentSummaryShipmentsShipmentIdSummaryPut: function (shipmentId, updateShipmentSummary, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShipmentSummaryShipmentsShipmentIdSummaryPut(shipmentId, updateShipmentSummary, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {UpdateShipmentTimelineEvent} updateShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut: function (shipmentId, timelineEventId, updateShipmentTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut(shipmentId, timelineEventId, updateShipmentTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Shipment Documents
         * @param {string} shipmentId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost: function (shipmentId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost(shipmentId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipmentsApiFp = ShipmentsApiFp;
/**
 * ShipmentsApi - factory interface
 * @export
 */
var ShipmentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipmentsApiFp)(configuration);
    return {
        /**
         *
         * @summary Archive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveShipmentsShipmentIdArchivePost: function (shipmentId, options) {
            return localVarFp.archiveShipmentsShipmentIdArchivePost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Assign Service To Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {AssociateServiceToShipmentRequest} associateServiceToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost: function (shipmentId, serviceId, associateServiceToShipmentRequest, options) {
            return localVarFp.assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost(shipmentId, serviceId, associateServiceToShipmentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates association Leg to Shipment
         * @summary Associate Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {AssociateLegToShipmentRequest} associateLegToShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateLegToShipmentShipmentsShipmentIdLegsLegIdPost: function (shipmentId, legId, associateLegToShipmentRequest, options) {
            return localVarFp.associateLegToShipmentShipmentsShipmentIdLegsLegIdPost(shipmentId, legId, associateLegToShipmentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Contacts
         * @param {string} shipmentId
         * @param {CreateContact} createContact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactsShipmentsShipmentIdContactsPost: function (shipmentId, createContact, options) {
            return localVarFp.createContactsShipmentsShipmentIdContactsPost(shipmentId, createContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Drayage Legs From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost: function (shipmentId, options) {
            return localVarFp.createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {CreateLegacyShipmentStage} createLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost: function (shipmentId, createLegacyShipmentStage, options) {
            return localVarFp.createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost(shipmentId, createLegacyShipmentStage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Order From Shipment
         * @param {string} shipmentId
         * @param {CreateOrderFromShipmentRequest} createOrderFromShipmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderFromShipmentShipmentsShipmentIdOrdersPost: function (shipmentId, createOrderFromShipmentRequest, options) {
            return localVarFp.createOrderFromShipmentShipmentsShipmentIdOrdersPost(shipmentId, createOrderFromShipmentRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new Shipment Item for a Shipment
         * @summary Create Shipment Item
         * @param {string} shipmentId
         * @param {CreateShipmentItemRequest} createShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentItemShipmentsShipmentIdItemsPost: function (shipmentId, createShipmentItemRequest, options) {
            return localVarFp.createShipmentItemShipmentsShipmentIdItemsPost(shipmentId, createShipmentItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Shipment Note
         * @param {string} shipmentId
         * @param {CreateShipmentNote} createShipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentNoteShipmentsShipmentIdNotesPost: function (shipmentId, createShipmentNote, options) {
            return localVarFp.createShipmentNoteShipmentsShipmentIdNotesPost(shipmentId, createShipmentNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new Shipment
         * @summary Create Shipment
         * @param {CreateShipment} [createShipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentShipmentsPost: function (createShipment, options) {
            return localVarFp.createShipmentShipmentsPost(createShipment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Timeline Event
         * @param {string} shipmentId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimelineEventShipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            return localVarFp.createTimelineEventShipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete: function (shipmentId, stageId, options) {
            return localVarFp.deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete(shipmentId, stageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Shipment Contact
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete: function (shipmentId, contactId, options) {
            return localVarFp.deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete(shipmentId, contactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            return localVarFp.deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deleting a Shipment stage will also delete the object (Leg, Service, etc.) on this Stage
         * @summary Delete Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete: function (shipmentId, stageId, options) {
            return localVarFp.deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete(shipmentId, stageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Shipment Stop Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete: function (shipmentId, sequenceId, options) {
            return localVarFp.deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete(shipmentId, sequenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete: function (shipmentId, timelineEventId, options) {
            return localVarFp.deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete(shipmentId, timelineEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates a Drayage specific BOL from the specified Shipment
         * @summary Generate Bol From Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost: function (shipmentId, options) {
            return localVarFp.generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns Drayage Transportation Orders associated to a Shipment
         * @summary Get Drayage Transportation Orders Associated To Shipment
         * @param {string} shipmentId
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet: function (shipmentId, skip, limit, sort, options) {
            return localVarFp.getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet(shipmentId, skip, limit, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns Legs associated to Shipment
         * @summary Get Legs Associated To Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet: function (shipmentId, options) {
            return localVarFp.getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Shipment Documents
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentDocumentsShipmentsShipmentIdDocumentsGet: function (shipmentId, options) {
            return localVarFp.getShipmentDocumentsShipmentsShipmentIdDocumentsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all the ShipmentItems for a Shipment
         * @summary Get Shipment Items
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentItemsShipmentsShipmentIdItemsGet: function (shipmentId, options) {
            return localVarFp.getShipmentItemsShipmentsShipmentIdItemsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Shipment Notes
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentNotesShipmentsShipmentIdNotesGet: function (shipmentId, options) {
            return localVarFp.getShipmentNotesShipmentsShipmentIdNotesGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the details for a single Shipment
         * @summary Get Shipment
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentShipmentsShipmentIdGet: function (shipmentId, options) {
            return localVarFp.getShipmentShipmentsShipmentIdGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Shipment Timeline Events
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet: function (shipmentId, options) {
            return localVarFp.getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all stages associated with a shipment. Useful for determining if a given resource id is associated with a shipment or not via a stage
         * @summary Get Stages
         * @param {Array<string>} transportationDetailIds Transportation detail id that this stage is linked to, like a leg id, service id, etc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStagesShipmentsStagesGet: function (transportationDetailIds, options) {
            return localVarFp.getStagesShipmentsStagesGet(transportationDetailIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Tracking Summary
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet: function (shipmentId, options) {
            return localVarFp.getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Shipment Stages
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShipmentStagesShipmentsShipmentIdStagesGet: function (shipmentId, options) {
            return localVarFp.listShipmentStagesShipmentsShipmentIdStagesGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Pin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes association Leg to Shipment
         * @summary Remove Association Leg To Shipment
         * @param {string} shipmentId
         * @param {string} legId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete: function (shipmentId, legId, options) {
            return localVarFp.removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete(shipmentId, legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet: function (shipmentId, stageId, options) {
            return localVarFp.retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet(shipmentId, stageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unarchive
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveShipmentsShipmentIdUnarchivePost: function (shipmentId, options) {
            return localVarFp.unarchiveShipmentsShipmentIdUnarchivePost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unassign Service From Shipment
         * @param {string} shipmentId
         * @param {string} serviceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete: function (shipmentId, serviceId, options) {
            return localVarFp.unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete(shipmentId, serviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unpin Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Leg Stops
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegStopsShipmentsShipmentIdUpdateLegStopsPut: function (shipmentId, options) {
            return localVarFp.updateLegStopsShipmentsShipmentIdUpdateLegStopsPut(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Legacy Shipment Stage
         * @param {string} shipmentId
         * @param {string} stageId
         * @param {UpdateLegacyShipmentStage} updateLegacyShipmentStage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut: function (shipmentId, stageId, updateLegacyShipmentStage, options) {
            return localVarFp.updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut(shipmentId, stageId, updateLegacyShipmentStage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Mode Specific Data Drayage
         * @param {string} shipmentId
         * @param {DrayageShipmentModeSpecificData} drayageShipmentModeSpecificData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut: function (shipmentId, drayageShipmentModeSpecificData, options) {
            return localVarFp.updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut(shipmentId, drayageShipmentModeSpecificData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Contact Detail
         * @param {string} shipmentId
         * @param {string} contactId
         * @param {UpdateContactDetail} updateContactDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut: function (shipmentId, contactId, updateContactDetail, options) {
            return localVarFp.updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut(shipmentId, contactId, updateContactDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Document
         * @param {string} shipmentId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, description, type, options) {
            return localVarFp.updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an existing Shipment Item
         * @summary Update Shipment Item
         * @param {string} shipmentId
         * @param {string} shipmentItemId
         * @param {UpdateShipmentItemRequest} updateShipmentItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut: function (shipmentId, shipmentItemId, updateShipmentItemRequest, options) {
            return localVarFp.updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut(shipmentId, shipmentItemId, updateShipmentItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Note
         * @param {string} shipmentId
         * @param {string} shipmentNoteId
         * @param {UpdateShipmentNoteDetail} updateShipmentNoteDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, updateShipmentNoteDetail, options) {
            return localVarFp.updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, updateShipmentNoteDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment References
         * @param {string} shipmentId
         * @param {UpdateShipmentReferences} updateShipmentReferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentReferencesShipmentsShipmentIdReferencesPut: function (shipmentId, updateShipmentReferences, options) {
            return localVarFp.updateShipmentReferencesShipmentsShipmentIdReferencesPut(shipmentId, updateShipmentReferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Stage Dependencies
         * @param {string} shipmentId
         * @param {UpdateShipmentStageDependenciesRequest} updateShipmentStageDependenciesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut: function (shipmentId, updateShipmentStageDependenciesRequest, options) {
            return localVarFp.updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut(shipmentId, updateShipmentStageDependenciesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Stops Detail
         * @param {string} shipmentId
         * @param {number} sequenceId
         * @param {UpdateStop} updateStop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut: function (shipmentId, sequenceId, updateStop, options) {
            return localVarFp.updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut(shipmentId, sequenceId, updateStop, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Stops
         * @param {string} shipmentId
         * @param {UpdateStopsRequest} updateStopsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentStopsShipmentsShipmentIdStopsPut: function (shipmentId, updateStopsRequest, options) {
            return localVarFp.updateShipmentStopsShipmentsShipmentIdStopsPut(shipmentId, updateStopsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Shipment Summary
         * @param {string} shipmentId
         * @param {UpdateShipmentSummary} updateShipmentSummary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentSummaryShipmentsShipmentIdSummaryPut: function (shipmentId, updateShipmentSummary, options) {
            return localVarFp.updateShipmentSummaryShipmentsShipmentIdSummaryPut(shipmentId, updateShipmentSummary, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Timeline Event
         * @param {string} shipmentId
         * @param {string} timelineEventId
         * @param {UpdateShipmentTimelineEvent} updateShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut: function (shipmentId, timelineEventId, updateShipmentTimelineEvent, options) {
            return localVarFp.updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut(shipmentId, timelineEventId, updateShipmentTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload Shipment Documents
         * @param {string} shipmentId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost: function (shipmentId, file, description, type, options) {
            return localVarFp.uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost(shipmentId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipmentsApiFactory = ShipmentsApiFactory;
/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
var ShipmentsApi = /** @class */ (function (_super) {
    __extends(ShipmentsApi, _super);
    function ShipmentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Archive
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.archiveShipmentsShipmentIdArchivePost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).archiveShipmentsShipmentIdArchivePost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Assign Service To Shipment
     * @param {string} shipmentId
     * @param {string} serviceId
     * @param {AssociateServiceToShipmentRequest} associateServiceToShipmentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost = function (shipmentId, serviceId, associateServiceToShipmentRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).assignServiceToShipmentShipmentsShipmentIdServicesServiceIdPost(shipmentId, serviceId, associateServiceToShipmentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates association Leg to Shipment
     * @summary Associate Leg To Shipment
     * @param {string} shipmentId
     * @param {string} legId
     * @param {AssociateLegToShipmentRequest} associateLegToShipmentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.associateLegToShipmentShipmentsShipmentIdLegsLegIdPost = function (shipmentId, legId, associateLegToShipmentRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).associateLegToShipmentShipmentsShipmentIdLegsLegIdPost(shipmentId, legId, associateLegToShipmentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Contacts
     * @param {string} shipmentId
     * @param {CreateContact} createContact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createContactsShipmentsShipmentIdContactsPost = function (shipmentId, createContact, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createContactsShipmentsShipmentIdContactsPost(shipmentId, createContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Drayage Legs From Shipment
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createDrayageLegsFromShipmentShipmentsShipmentIdCreateDrayageLegsPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Legacy Shipment Stage
     * @param {string} shipmentId
     * @param {CreateLegacyShipmentStage} createLegacyShipmentStage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost = function (shipmentId, createLegacyShipmentStage, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesPost(shipmentId, createLegacyShipmentStage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Order From Shipment
     * @param {string} shipmentId
     * @param {CreateOrderFromShipmentRequest} createOrderFromShipmentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createOrderFromShipmentShipmentsShipmentIdOrdersPost = function (shipmentId, createOrderFromShipmentRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createOrderFromShipmentShipmentsShipmentIdOrdersPost(shipmentId, createOrderFromShipmentRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new Shipment Item for a Shipment
     * @summary Create Shipment Item
     * @param {string} shipmentId
     * @param {CreateShipmentItemRequest} createShipmentItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createShipmentItemShipmentsShipmentIdItemsPost = function (shipmentId, createShipmentItemRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createShipmentItemShipmentsShipmentIdItemsPost(shipmentId, createShipmentItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Shipment Note
     * @param {string} shipmentId
     * @param {CreateShipmentNote} createShipmentNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createShipmentNoteShipmentsShipmentIdNotesPost = function (shipmentId, createShipmentNote, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createShipmentNoteShipmentsShipmentIdNotesPost(shipmentId, createShipmentNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new Shipment
     * @summary Create Shipment
     * @param {CreateShipment} [createShipment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createShipmentShipmentsPost = function (createShipment, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createShipmentShipmentsPost(createShipment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Timeline Event
     * @param {string} shipmentId
     * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.createTimelineEventShipmentsShipmentIdTimelineEventsPost = function (shipmentId, createShipmentTimelineEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).createTimelineEventShipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Legacy Shipment Stage
     * @param {string} shipmentId
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete = function (shipmentId, stageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdDelete(shipmentId, stageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Shipment Contact
     * @param {string} shipmentId
     * @param {string} contactId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete = function (shipmentId, contactId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteShipmentContactShipmentsShipmentIdContactsContactIdDelete(shipmentId, contactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Shipment Document
     * @param {string} shipmentId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete = function (shipmentId, documentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Shipment Note
     * @param {string} shipmentId
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deleting a Shipment stage will also delete the object (Leg, Service, etc.) on this Stage
     * @summary Delete Shipment Stage
     * @param {string} shipmentId
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete = function (shipmentId, stageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteShipmentStageShipmentsShipmentIdStagesStageIdDelete(shipmentId, stageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Shipment Stop Detail
     * @param {string} shipmentId
     * @param {number} sequenceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete = function (shipmentId, sequenceId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteShipmentStopDetailShipmentsShipmentIdStopsSequenceIdDelete(shipmentId, sequenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Timeline Event
     * @param {string} shipmentId
     * @param {string} timelineEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete = function (shipmentId, timelineEventId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).deleteTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdDelete(shipmentId, timelineEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates a Drayage specific BOL from the specified Shipment
     * @summary Generate Bol From Shipment
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).generateBolFromShipmentShipmentsShipmentIdDocumentsGenerateBolPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns Drayage Transportation Orders associated to a Shipment
     * @summary Get Drayage Transportation Orders Associated To Shipment
     * @param {string} shipmentId
     * @param {number} [skip]
     * @param {number} [limit]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet = function (shipmentId, skip, limit, sort, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getDrayageTransportationOrdersAssociatedToShipmentShipmentsShipmentIdTransportationOrdersDrayageGet(shipmentId, skip, limit, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns Legs associated to Shipment
     * @summary Get Legs Associated To Shipment
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getLegsAssociatedToShipmentShipmentsShipmentIdLegsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Shipment Documents
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentDocumentsShipmentsShipmentIdDocumentsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentDocumentsShipmentsShipmentIdDocumentsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all the ShipmentItems for a Shipment
     * @summary Get Shipment Items
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentItemsShipmentsShipmentIdItemsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentItemsShipmentsShipmentIdItemsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Shipment Note
     * @param {string} shipmentId
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Shipment Notes
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentNotesShipmentsShipmentIdNotesGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentNotesShipmentsShipmentIdNotesGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the details for a single Shipment
     * @summary Get Shipment
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentShipmentsShipmentIdGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentShipmentsShipmentIdGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Shipment Timeline Events
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getShipmentTimelineEventsShipmentsShipmentIdTimelineEventsSummaryGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all stages associated with a shipment. Useful for determining if a given resource id is associated with a shipment or not via a stage
     * @summary Get Stages
     * @param {Array<string>} transportationDetailIds Transportation detail id that this stage is linked to, like a leg id, service id, etc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getStagesShipmentsStagesGet = function (transportationDetailIds, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getStagesShipmentsStagesGet(transportationDetailIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Tracking Summary
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).getTrackingSummaryShipmentsShipmentIdTrackingSummaryGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Shipment Stages
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.listShipmentStagesShipmentsShipmentIdStagesGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).listShipmentStagesShipmentsShipmentIdStagesGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Pin Shipment Note
     * @param {string} shipmentId
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).pinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPinPost(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes association Leg to Shipment
     * @summary Remove Association Leg To Shipment
     * @param {string} shipmentId
     * @param {string} legId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete = function (shipmentId, legId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).removeAssociationLegToShipmentShipmentsShipmentIdLegsLegIdDelete(shipmentId, legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve Shipment Stage
     * @param {string} shipmentId
     * @param {string} stageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet = function (shipmentId, stageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).retrieveShipmentStageShipmentsShipmentIdStagesStageIdGet(shipmentId, stageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unarchive
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.unarchiveShipmentsShipmentIdUnarchivePost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).unarchiveShipmentsShipmentIdUnarchivePost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unassign Service From Shipment
     * @param {string} shipmentId
     * @param {string} serviceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete = function (shipmentId, serviceId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).unassignServiceFromShipmentShipmentsShipmentIdServicesServiceIdDelete(shipmentId, serviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unpin Shipment Note
     * @param {string} shipmentId
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).unpinShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdUnpinPost(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Leg Stops
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateLegStopsShipmentsShipmentIdUpdateLegStopsPut = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateLegStopsShipmentsShipmentIdUpdateLegStopsPut(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Legacy Shipment Stage
     * @param {string} shipmentId
     * @param {string} stageId
     * @param {UpdateLegacyShipmentStage} updateLegacyShipmentStage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut = function (shipmentId, stageId, updateLegacyShipmentStage, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateLegacyShipmentStageShipmentsShipmentIdLegacyShipmentStagesStageIdPut(shipmentId, stageId, updateLegacyShipmentStage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Mode Specific Data Drayage
     * @param {string} shipmentId
     * @param {DrayageShipmentModeSpecificData} drayageShipmentModeSpecificData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut = function (shipmentId, drayageShipmentModeSpecificData, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateModeSpecificDataDrayageShipmentsShipmentIdModeSpecificDataDrayagePut(shipmentId, drayageShipmentModeSpecificData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Contact Detail
     * @param {string} shipmentId
     * @param {string} contactId
     * @param {UpdateContactDetail} updateContactDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut = function (shipmentId, contactId, updateContactDetail, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentContactDetailShipmentsShipmentIdContactsContactIdPut(shipmentId, contactId, updateContactDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Document
     * @param {string} shipmentId
     * @param {string} documentId
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut = function (shipmentId, documentId, description, type, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentDocumentShipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an existing Shipment Item
     * @summary Update Shipment Item
     * @param {string} shipmentId
     * @param {string} shipmentItemId
     * @param {UpdateShipmentItemRequest} updateShipmentItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut = function (shipmentId, shipmentItemId, updateShipmentItemRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentItemShipmentsShipmentIdItemsShipmentItemIdPut(shipmentId, shipmentItemId, updateShipmentItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Note
     * @param {string} shipmentId
     * @param {string} shipmentNoteId
     * @param {UpdateShipmentNoteDetail} updateShipmentNoteDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut = function (shipmentId, shipmentNoteId, updateShipmentNoteDetail, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentNoteShipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, updateShipmentNoteDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment References
     * @param {string} shipmentId
     * @param {UpdateShipmentReferences} updateShipmentReferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentReferencesShipmentsShipmentIdReferencesPut = function (shipmentId, updateShipmentReferences, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentReferencesShipmentsShipmentIdReferencesPut(shipmentId, updateShipmentReferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Stage Dependencies
     * @param {string} shipmentId
     * @param {UpdateShipmentStageDependenciesRequest} updateShipmentStageDependenciesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut = function (shipmentId, updateShipmentStageDependenciesRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentStageDependenciesShipmentsShipmentIdStagesDependenciesPut(shipmentId, updateShipmentStageDependenciesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Stops Detail
     * @param {string} shipmentId
     * @param {number} sequenceId
     * @param {UpdateStop} updateStop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut = function (shipmentId, sequenceId, updateStop, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentStopsDetailShipmentsShipmentIdStopsSequenceIdPut(shipmentId, sequenceId, updateStop, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Stops
     * @param {string} shipmentId
     * @param {UpdateStopsRequest} updateStopsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentStopsShipmentsShipmentIdStopsPut = function (shipmentId, updateStopsRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentStopsShipmentsShipmentIdStopsPut(shipmentId, updateStopsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Shipment Summary
     * @param {string} shipmentId
     * @param {UpdateShipmentSummary} updateShipmentSummary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateShipmentSummaryShipmentsShipmentIdSummaryPut = function (shipmentId, updateShipmentSummary, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateShipmentSummaryShipmentsShipmentIdSummaryPut(shipmentId, updateShipmentSummary, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Timeline Event
     * @param {string} shipmentId
     * @param {string} timelineEventId
     * @param {UpdateShipmentTimelineEvent} updateShipmentTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut = function (shipmentId, timelineEventId, updateShipmentTimelineEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).updateTimelineEventShipmentsShipmentIdTimelineEventsTimelineEventIdPut(shipmentId, timelineEventId, updateShipmentTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload Shipment Documents
     * @param {string} shipmentId
     * @param {any} file
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost = function (shipmentId, file, description, type, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).uploadShipmentDocumentsShipmentsShipmentIdDocumentsPost(shipmentId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipmentsApi;
}(base_1.BaseAPI));
exports.ShipmentsApi = ShipmentsApi;
/**
 * TransportationOrdersApi - axios parameter creator
 * @export
 */
var TransportationOrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Accept Drayage Transportation order.
         * @summary Accept Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {AcceptTransportationOrderRequest} acceptTransportationOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost: function (transportationOrderId, acceptTransportationOrderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'acceptTransportationOrderRequest' is not null or undefined
                            (0, common_1.assertParamExists)('acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost', 'acceptTransportationOrderRequest', acceptTransportationOrderRequest);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/responses"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(acceptTransportationOrderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Accounting Bill From Order
         * @param {string} transportationOrderId
         * @param {CreateAccountingBillSchema} createAccountingBillSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost: function (transportationOrderId, createAccountingBillSchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createAccountingBillSchema' is not null or undefined
                            (0, common_1.assertParamExists)('createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost', 'createAccountingBillSchema', createAccountingBillSchema);
                            localVarPath = "/transportation-orders/{transportation_order_id}/accounting-bills"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createAccountingBillSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new booking party credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-credits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new booking party debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-debits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new initial credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-credits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new initial debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-debits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new service provider credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-credits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new service provider debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost: function (transportationOrderId, createCharge, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createCharge' is not null or undefined
                            (0, common_1.assertParamExists)('createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost', 'createCharge', createCharge);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-debits"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCharge, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Freight Invoice From Order
         * @param {string} transportationOrderId
         * @param {CreateFreightInvoiceRequestSchema} data
         * @param {CreateFreightInvoiceDocumentSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceFromOrder: function (transportationOrderId, data, documentsMetadata, documents, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createFreightInvoiceFromOrder', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('createFreightInvoiceFromOrder', 'data', data);
                            localVarPath = "/transportation-orders/{transportation_order_id}/freight-invoices"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new order item for a Drayage Transportation Order
         * @summary Create Order Item
         * @param {string} transportationOrderId
         * @param {CreateDrayageTransportationOrderItemRequest} createDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost: function (transportationOrderId, createDrayageTransportationOrderItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'createDrayageTransportationOrderItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost', 'createDrayageTransportationOrderItemRequest', createDrayageTransportationOrderItemRequest);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/items"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDrayageTransportationOrderItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes booking party credit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes booking party debit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes initial credit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes initial debit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes service provider credit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes service provider debit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete', 'chargeId', chargeId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete: function (transportationOrderId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents/{document_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific BOL from the specified Drayage Transportation Order
         * @summary Generate Bol From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents/generate-bol"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific Rate Con from the specified Drayage Transportation Order
         * @summary Generate Rate Con From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents/generate-rate-confirmation"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get All Freight Invoice For Order
         * @param {string} transportationOrderId
         * @param {FreightInvoiceTenantRole} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFreightInvoiceForOrder: function (transportationOrderId, role, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllFreightInvoiceForOrder', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/{transportation_order_id}/freight-invoices"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get All Public Rule Configurations For Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublicRuleConfigurationsForOrder: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllPublicRuleConfigurationsForOrder', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/{transportation_order_id}/invoice-rule-configurations"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return the details for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return the services for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Services
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/services"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves all of the DrayageTransportationOrderItem for an Order
         * @summary Get Order Items
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/items"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Reject Drayage Transportation Order. Rejecting a Drayage Transportation Order that is already is accepted is allowed.
         * @summary Reject Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/responses"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Revoke Drayage Transportation Order. Revocation of already accepted Drayage Transportation Order is allowed.
         * @summary Revoke Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete: function (transportationOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete', 'transportationOrderId', transportationOrderId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Accessorials
         * @param {string} transportationOrderId
         * @param {UpdateDrayageTransportationOrderAccessorials} updateDrayageTransportationOrderAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut: function (transportationOrderId, updateDrayageTransportationOrderAccessorials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'updateDrayageTransportationOrderAccessorials' is not null or undefined
                            (0, common_1.assertParamExists)('updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut', 'updateDrayageTransportationOrderAccessorials', updateDrayageTransportationOrderAccessorials);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/accessorials"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDrayageTransportationOrderAccessorials, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates booking party credit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates booking party debit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/booking-party-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates initial credit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates initial debit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/initial-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates service provider credit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-credits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates service provider debit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'chargeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut', 'chargeId', chargeId);
                            // verify required parameter 'updateChargeDetail' is not null or undefined
                            (0, common_1.assertParamExists)('updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut', 'updateChargeDetail', updateChargeDetail);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/service-provider-debits/{charge_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("charge_id", "}"), encodeURIComponent(String(chargeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateChargeDetail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates an existing Drayage Transportation Order Item
         * @summary Update Order Item
         * @param {string} transportationOrderId
         * @param {string} orderItemId
         * @param {UpdateDrayageTransportationOrderItemRequest} updateDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut: function (transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'orderItemId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut', 'orderItemId', orderItemId);
                            // verify required parameter 'updateDrayageTransportationOrderItemRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut', 'updateDrayageTransportationOrderItemRequest', updateDrayageTransportationOrderItemRequest);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/items/{order_item_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("order_item_id", "}"), encodeURIComponent(String(orderItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDrayageTransportationOrderItemRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut: function (transportationOrderId, documentId, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut', 'documentId', documentId);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents/{document_id}"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)))
                                .replace("{".concat("document_id", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new URLSearchParams();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.set('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.set('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams.toString();
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost: function (transportationOrderId, file, description, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transportationOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost', 'transportationOrderId', transportationOrderId);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost', 'file', file);
                            localVarPath = "/transportation-orders/drayage/{transportation_order_id}/documents"
                                .replace("{".concat("transportation_order_id", "}"), encodeURIComponent(String(transportationOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TransportationOrdersApiAxiosParamCreator = TransportationOrdersApiAxiosParamCreator;
/**
 * TransportationOrdersApi - functional programming interface
 * @export
 */
var TransportationOrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TransportationOrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Accept Drayage Transportation order.
         * @summary Accept Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {AcceptTransportationOrderRequest} acceptTransportationOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost: function (transportationOrderId, acceptTransportationOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost(transportationOrderId, acceptTransportationOrderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Accounting Bill From Order
         * @param {string} transportationOrderId
         * @param {CreateAccountingBillSchema} createAccountingBillSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost: function (transportationOrderId, createAccountingBillSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost(transportationOrderId, createAccountingBillSchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new booking party credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new booking party debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new initial credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new initial debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new service provider credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new service provider debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost: function (transportationOrderId, createCharge, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost(transportationOrderId, createCharge, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Freight Invoice From Order
         * @param {string} transportationOrderId
         * @param {CreateFreightInvoiceRequestSchema} data
         * @param {CreateFreightInvoiceDocumentSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceFromOrder: function (transportationOrderId, data, documentsMetadata, documents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFreightInvoiceFromOrder(transportationOrderId, data, documentsMetadata, documents, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new order item for a Drayage Transportation Order
         * @summary Create Order Item
         * @param {string} transportationOrderId
         * @param {CreateDrayageTransportationOrderItemRequest} createDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost: function (transportationOrderId, createDrayageTransportationOrderItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost(transportationOrderId, createDrayageTransportationOrderItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes booking party credit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes booking party debit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes initial credit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes initial debit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes service provider credit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Deletes service provider debit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete(transportationOrderId, chargeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete: function (transportationOrderId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete(transportationOrderId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific BOL from the specified Drayage Transportation Order
         * @summary Generate Bol From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Generates a Drayage specific Rate Con from the specified Drayage Transportation Order
         * @summary Generate Rate Con From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get All Freight Invoice For Order
         * @param {string} transportationOrderId
         * @param {FreightInvoiceTenantRole} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFreightInvoiceForOrder: function (transportationOrderId, role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFreightInvoiceForOrder(transportationOrderId, role, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get All Public Rule Configurations For Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublicRuleConfigurationsForOrder: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllPublicRuleConfigurationsForOrder(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Return the details for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Return the services for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Services
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves all of the DrayageTransportationOrderItem for an Order
         * @summary Get Order Items
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Reject Drayage Transportation Order. Rejecting a Drayage Transportation Order that is already is accepted is allowed.
         * @summary Reject Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Revoke Drayage Transportation Order. Revocation of already accepted Drayage Transportation Order is allowed.
         * @summary Revoke Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete: function (transportationOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete(transportationOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Accessorials
         * @param {string} transportationOrderId
         * @param {UpdateDrayageTransportationOrderAccessorials} updateDrayageTransportationOrderAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut: function (transportationOrderId, updateDrayageTransportationOrderAccessorials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut(transportationOrderId, updateDrayageTransportationOrderAccessorials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates booking party credit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates booking party debit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates initial credit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates initial debit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates service provider credit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates service provider debit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates an existing Drayage Transportation Order Item
         * @summary Update Order Item
         * @param {string} transportationOrderId
         * @param {string} orderItemId
         * @param {UpdateDrayageTransportationOrderItemRequest} updateDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut: function (transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut(transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut: function (transportationOrderId, documentId, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut(transportationOrderId, documentId, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost: function (transportationOrderId, file, description, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost(transportationOrderId, file, description, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TransportationOrdersApiFp = TransportationOrdersApiFp;
/**
 * TransportationOrdersApi - factory interface
 * @export
 */
var TransportationOrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TransportationOrdersApiFp)(configuration);
    return {
        /**
         * Accept Drayage Transportation order.
         * @summary Accept Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {AcceptTransportationOrderRequest} acceptTransportationOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost: function (transportationOrderId, acceptTransportationOrderRequest, options) {
            return localVarFp.acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost(transportationOrderId, acceptTransportationOrderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Accounting Bill From Order
         * @param {string} transportationOrderId
         * @param {CreateAccountingBillSchema} createAccountingBillSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost: function (transportationOrderId, createAccountingBillSchema, options) {
            return localVarFp.createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost(transportationOrderId, createAccountingBillSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new booking party credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new booking party debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Booking Party Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new initial credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new initial debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Initial Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new service provider credit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Credit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new service provider debit for a Drayage Transportation Order
         * @summary Create Drayage Transportation Order Service Provider Debit
         * @param {string} transportationOrderId
         * @param {CreateCharge} createCharge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost: function (transportationOrderId, createCharge, options) {
            return localVarFp.createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Freight Invoice From Order
         * @param {string} transportationOrderId
         * @param {CreateFreightInvoiceRequestSchema} data
         * @param {CreateFreightInvoiceDocumentSchema} [documentsMetadata]
         * @param {Array<any>} [documents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreightInvoiceFromOrder: function (transportationOrderId, data, documentsMetadata, documents, options) {
            return localVarFp.createFreightInvoiceFromOrder(transportationOrderId, data, documentsMetadata, documents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new order item for a Drayage Transportation Order
         * @summary Create Order Item
         * @param {string} transportationOrderId
         * @param {CreateDrayageTransportationOrderItemRequest} createDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost: function (transportationOrderId, createDrayageTransportationOrderItemRequest, options) {
            return localVarFp.createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost(transportationOrderId, createDrayageTransportationOrderItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes booking party credit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes booking party debit for Transportation Order
         * @summary Delete Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes initial credit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes initial debit for Transportation Order
         * @summary Delete Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes service provider credit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes service provider debit for Transportation Order
         * @summary Delete Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete: function (transportationOrderId, chargeId, options) {
            return localVarFp.deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete: function (transportationOrderId, documentId, options) {
            return localVarFp.deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete(transportationOrderId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates a Drayage specific BOL from the specified Drayage Transportation Order
         * @summary Generate Bol From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost: function (transportationOrderId, options) {
            return localVarFp.generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generates a Drayage specific Rate Con from the specified Drayage Transportation Order
         * @summary Generate Rate Con From Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost: function (transportationOrderId, options) {
            return localVarFp.generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get All Freight Invoice For Order
         * @param {string} transportationOrderId
         * @param {FreightInvoiceTenantRole} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFreightInvoiceForOrder: function (transportationOrderId, role, options) {
            return localVarFp.getAllFreightInvoiceForOrder(transportationOrderId, role, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get All Public Rule Configurations For Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPublicRuleConfigurationsForOrder: function (transportationOrderId, options) {
            return localVarFp.getAllPublicRuleConfigurationsForOrder(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return the details for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet: function (transportationOrderId, options) {
            return localVarFp.getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return the services for a single Drayage Transportation Order.
         * @summary Get Drayage Transportation Order Services
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet: function (transportationOrderId, options) {
            return localVarFp.getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves all of the DrayageTransportationOrderItem for an Order
         * @summary Get Order Items
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet: function (transportationOrderId, options) {
            return localVarFp.getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet: function (transportationOrderId, options) {
            return localVarFp.getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reject Drayage Transportation Order. Rejecting a Drayage Transportation Order that is already is accepted is allowed.
         * @summary Reject Drayage Transportation Order
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete: function (transportationOrderId, options) {
            return localVarFp.rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Revoke Drayage Transportation Order. Revocation of already accepted Drayage Transportation Order is allowed.
         * @summary Revoke Drayage Transportation Order Detail
         * @param {string} transportationOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete: function (transportationOrderId, options) {
            return localVarFp.revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete(transportationOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Accessorials
         * @param {string} transportationOrderId
         * @param {UpdateDrayageTransportationOrderAccessorials} updateDrayageTransportationOrderAccessorials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut: function (transportationOrderId, updateDrayageTransportationOrderAccessorials, options) {
            return localVarFp.updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut(transportationOrderId, updateDrayageTransportationOrderAccessorials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates booking party credit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates booking party debit for Transportation Order
         * @summary Update Drayage Transportation Order Booking Party Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates initial credit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates initial debit for Transportation Order
         * @summary Update Drayage Transportation Order Initial Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates service provider credit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Credit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates service provider debit for Transportation Order
         * @summary Update Drayage Transportation Order Service Provider Debit Detail
         * @param {string} transportationOrderId
         * @param {string} chargeId
         * @param {UpdateChargeDetail} updateChargeDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut: function (transportationOrderId, chargeId, updateChargeDetail, options) {
            return localVarFp.updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an existing Drayage Transportation Order Item
         * @summary Update Order Item
         * @param {string} transportationOrderId
         * @param {string} orderItemId
         * @param {UpdateDrayageTransportationOrderItemRequest} updateDrayageTransportationOrderItemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut: function (transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options) {
            return localVarFp.updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut(transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Transportation Order Document
         * @param {string} transportationOrderId
         * @param {string} documentId
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut: function (transportationOrderId, documentId, description, type, options) {
            return localVarFp.updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut(transportationOrderId, documentId, description, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload Transportation Order Documents
         * @param {string} transportationOrderId
         * @param {any} file
         * @param {string} [description]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost: function (transportationOrderId, file, description, type, options) {
            return localVarFp.uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost(transportationOrderId, file, description, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TransportationOrdersApiFactory = TransportationOrdersApiFactory;
/**
 * TransportationOrdersApi - object-oriented interface
 * @export
 * @class TransportationOrdersApi
 * @extends {BaseAPI}
 */
var TransportationOrdersApi = /** @class */ (function (_super) {
    __extends(TransportationOrdersApi, _super);
    function TransportationOrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Accept Drayage Transportation order.
     * @summary Accept Drayage Transportation Order
     * @param {string} transportationOrderId
     * @param {AcceptTransportationOrderRequest} acceptTransportationOrderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost = function (transportationOrderId, acceptTransportationOrderRequest, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).acceptDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesPost(transportationOrderId, acceptTransportationOrderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Accounting Bill From Order
     * @param {string} transportationOrderId
     * @param {CreateAccountingBillSchema} createAccountingBillSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost = function (transportationOrderId, createAccountingBillSchema, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createAccountingBillFromOrderTransportationOrdersTransportationOrderIdAccountingBillsPost(transportationOrderId, createAccountingBillSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new booking party credit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Booking Party Credit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderBookingPartyCreditTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new booking party debit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Booking Party Debit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderBookingPartyDebitTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new initial credit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Initial Credit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderInitialCreditTransportationOrdersDrayageTransportationOrderIdInitialCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new initial debit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Initial Debit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderInitialDebitTransportationOrdersDrayageTransportationOrderIdInitialDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new service provider credit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Service Provider Credit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderServiceProviderCreditTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new service provider debit for a Drayage Transportation Order
     * @summary Create Drayage Transportation Order Service Provider Debit
     * @param {string} transportationOrderId
     * @param {CreateCharge} createCharge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost = function (transportationOrderId, createCharge, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createDrayageTransportationOrderServiceProviderDebitTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsPost(transportationOrderId, createCharge, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Freight Invoice From Order
     * @param {string} transportationOrderId
     * @param {CreateFreightInvoiceRequestSchema} data
     * @param {CreateFreightInvoiceDocumentSchema} [documentsMetadata]
     * @param {Array<any>} [documents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createFreightInvoiceFromOrder = function (transportationOrderId, data, documentsMetadata, documents, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createFreightInvoiceFromOrder(transportationOrderId, data, documentsMetadata, documents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new order item for a Drayage Transportation Order
     * @summary Create Order Item
     * @param {string} transportationOrderId
     * @param {CreateDrayageTransportationOrderItemRequest} createDrayageTransportationOrderItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost = function (transportationOrderId, createDrayageTransportationOrderItemRequest, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).createOrderItemTransportationOrdersDrayageTransportationOrderIdItemsPost(transportationOrderId, createDrayageTransportationOrderItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes booking party credit for Transportation Order
     * @summary Delete Drayage Transportation Order Booking Party Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes booking party debit for Transportation Order
     * @summary Delete Drayage Transportation Order Booking Party Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes initial credit for Transportation Order
     * @summary Delete Drayage Transportation Order Initial Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes initial debit for Transportation Order
     * @summary Delete Drayage Transportation Order Initial Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes service provider credit for Transportation Order
     * @summary Delete Drayage Transportation Order Service Provider Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes service provider debit for Transportation Order
     * @summary Delete Drayage Transportation Order Service Provider Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete = function (transportationOrderId, chargeId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdDelete(transportationOrderId, chargeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Transportation Order Document
     * @param {string} transportationOrderId
     * @param {string} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete = function (transportationOrderId, documentId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).deleteTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdDelete(transportationOrderId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates a Drayage specific BOL from the specified Drayage Transportation Order
     * @summary Generate Bol From Drayage Transportation Order
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).generateBolFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateBolPost(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generates a Drayage specific Rate Con from the specified Drayage Transportation Order
     * @summary Generate Rate Con From Drayage Transportation Order
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).generateRateConFromDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdDocumentsGenerateRateConfirmationPost(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get All Freight Invoice For Order
     * @param {string} transportationOrderId
     * @param {FreightInvoiceTenantRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getAllFreightInvoiceForOrder = function (transportationOrderId, role, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getAllFreightInvoiceForOrder(transportationOrderId, role, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get All Public Rule Configurations For Order
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getAllPublicRuleConfigurationsForOrder = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getAllPublicRuleConfigurationsForOrder(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return the details for a single Drayage Transportation Order.
     * @summary Get Drayage Transportation Order Detail
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdGet(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return the services for a single Drayage Transportation Order.
     * @summary Get Drayage Transportation Order Services
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getDrayageTransportationOrderServicesTransportationOrdersDrayageTransportationOrderIdServicesGet(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves all of the DrayageTransportationOrderItem for an Order
     * @summary Get Order Items
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getOrderItemsTransportationOrdersDrayageTransportationOrderIdItemsGet(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Transportation Order Documents
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).getTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsGet(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reject Drayage Transportation Order. Rejecting a Drayage Transportation Order that is already is accepted is allowed.
     * @summary Reject Drayage Transportation Order
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).rejectDrayageTransportationOrderTransportationOrdersDrayageTransportationOrderIdResponsesDelete(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Revoke Drayage Transportation Order. Revocation of already accepted Drayage Transportation Order is allowed.
     * @summary Revoke Drayage Transportation Order Detail
     * @param {string} transportationOrderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete = function (transportationOrderId, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).revokeDrayageTransportationOrderDetailTransportationOrdersDrayageTransportationOrderIdDelete(transportationOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Accessorials
     * @param {string} transportationOrderId
     * @param {UpdateDrayageTransportationOrderAccessorials} updateDrayageTransportationOrderAccessorials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut = function (transportationOrderId, updateDrayageTransportationOrderAccessorials, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateAccessorialsTransportationOrdersDrayageTransportationOrderIdAccessorialsPut(transportationOrderId, updateDrayageTransportationOrderAccessorials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates booking party credit for Transportation Order
     * @summary Update Drayage Transportation Order Booking Party Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderBookingPartyCreditDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates booking party debit for Transportation Order
     * @summary Update Drayage Transportation Order Booking Party Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderBookingPartyDebitDetailTransportationOrdersDrayageTransportationOrderIdBookingPartyDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates initial credit for Transportation Order
     * @summary Update Drayage Transportation Order Initial Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderInitialCreditDetailTransportationOrdersDrayageTransportationOrderIdInitialCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates initial debit for Transportation Order
     * @summary Update Drayage Transportation Order Initial Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderInitialDebitDetailTransportationOrdersDrayageTransportationOrderIdInitialDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates service provider credit for Transportation Order
     * @summary Update Drayage Transportation Order Service Provider Credit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderServiceProviderCreditDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderCreditsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates service provider debit for Transportation Order
     * @summary Update Drayage Transportation Order Service Provider Debit Detail
     * @param {string} transportationOrderId
     * @param {string} chargeId
     * @param {UpdateChargeDetail} updateChargeDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut = function (transportationOrderId, chargeId, updateChargeDetail, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateDrayageTransportationOrderServiceProviderDebitDetailTransportationOrdersDrayageTransportationOrderIdServiceProviderDebitsChargeIdPut(transportationOrderId, chargeId, updateChargeDetail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an existing Drayage Transportation Order Item
     * @summary Update Order Item
     * @param {string} transportationOrderId
     * @param {string} orderItemId
     * @param {UpdateDrayageTransportationOrderItemRequest} updateDrayageTransportationOrderItemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut = function (transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateOrderItemTransportationOrdersDrayageTransportationOrderIdItemsOrderItemIdPut(transportationOrderId, orderItemId, updateDrayageTransportationOrderItemRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Transportation Order Document
     * @param {string} transportationOrderId
     * @param {string} documentId
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut = function (transportationOrderId, documentId, description, type, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).updateTransportationOrderDocumentTransportationOrdersDrayageTransportationOrderIdDocumentsDocumentIdPut(transportationOrderId, documentId, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload Transportation Order Documents
     * @param {string} transportationOrderId
     * @param {any} file
     * @param {string} [description]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransportationOrdersApi
     */
    TransportationOrdersApi.prototype.uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost = function (transportationOrderId, file, description, type, options) {
        var _this = this;
        return (0, exports.TransportationOrdersApiFp)(this.configuration).uploadTransportationOrderDocumentsTransportationOrdersDrayageTransportationOrderIdDocumentsPost(transportationOrderId, file, description, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TransportationOrdersApi;
}(base_1.BaseAPI));
exports.TransportationOrdersApi = TransportationOrdersApi;
